var _excluded = ["class", "isInternal"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  "use strict";

  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
    }
  } catch (t) {
    console.error("vite-plugin-css-injected-by-js", t);
  }
})();

var Ce = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : (typeof global === "undefined" ? "undefined" : _typeof(global)) < "u" ? global : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : {};

function Ke(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}

function Xn(n) {
  if (n.__esModule) return n;
  var e = n.default;

  if (typeof e == "function") {
    var t = function o() {
      return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };

    t.prototype = e.prototype;
  } else t = {};

  return Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.keys(n).forEach(function (o) {
    var i = Object.getOwnPropertyDescriptor(n, o);
    Object.defineProperty(t, o, i.get ? i : {
      enumerable: !0,
      get: function get() {
        return n[o];
      }
    });
  }), t;
}

function ot() {}

Object.assign(ot, {
  default: ot,
  register: ot,
  revert: function revert() {},
  __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (n) {
  var e = (this.document || this.ownerDocument).querySelectorAll(n);
  var t = e.length;

  for (; --t >= 0 && e.item(t) !== this;) {
    ;
  }

  return t > -1;
});
Element.prototype.closest || (Element.prototype.closest = function (n) {
  var e = this;
  if (!document.documentElement.contains(e)) return null;

  do {
    if (e.matches(n)) return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null);

  return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function (e) {
  var t = document.createDocumentFragment();
  Array.isArray(e) || (e = [e]), e.forEach(function (o) {
    var i = o instanceof Node;
    t.appendChild(i ? o : document.createTextNode(o));
  }), this.insertBefore(t, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function (n) {
  n = arguments.length === 0 ? !0 : !!n;
  var e = this.parentNode,
      t = window.getComputedStyle(e, null),
      o = parseInt(t.getPropertyValue("border-top-width")),
      i = parseInt(t.getPropertyValue("border-left-width")),
      s = this.offsetTop - e.offsetTop < e.scrollTop,
      r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight,
      a = this.offsetLeft - e.offsetLeft < e.scrollLeft,
      l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth,
      c = s && !r;
  (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});

window.requestIdleCallback = window.requestIdleCallback || function (n) {
  var e = Date.now();
  return setTimeout(function () {
    n({
      didTimeout: !1,
      timeRemaining: function timeRemaining() {
        return Math.max(0, 50 - (Date.now() - e));
      }
    });
  }, 1);
};

window.cancelIdleCallback = window.cancelIdleCallback || function (n) {
  clearTimeout(n);
};

var Vn = function Vn() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  return crypto.getRandomValues(new Uint8Array(n)).reduce(function (e, t) {
    return t &= 63, t < 36 ? e += t.toString(36) : t < 62 ? e += (t - 26).toString(36).toUpperCase() : t > 62 ? e += "-" : e += "_", e;
  }, "");
};

var Lo = /* @__PURE__ */function (n) {
  return n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n;
}(Lo || {});

var y = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  DELETE: 46,
  META: 91,
  SLASH: 191
},
    qn = {
  LEFT: 0,
  WHEEL: 1,
  RIGHT: 2,
  BACKWARD: 3,
  FORWARD: 4
};

function Ie(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "log";
  var o = arguments.length > 3 ? arguments[3] : undefined;
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "color: inherit";
  if (!("console" in window) || !window.console[t]) return;
  var s = ["info", "log", "warn", "error"].includes(t),
      r = [];

  switch (Ie.logLevel) {
    case "ERROR":
      if (t !== "error") return;
      break;

    case "WARN":
      if (!["error", "warn"].includes(t)) return;
      break;

    case "INFO":
      if (!s || n) return;
      break;
  }

  o && r.push(o);
  var a = "Editor.js 2.31.0",
      l = "line-height: 1em;\n            color: #006FEA;\n            display: inline-block;\n            font-size: 11px;\n            line-height: 1em;\n            background-color: #fff;\n            padding: 4px 9px;\n            border-radius: 30px;\n            border: 1px solid rgba(56, 138, 229, 0.16);\n            margin: 4px 5px 4px 0;";
  n && (s ? (r.unshift(l, i), e = "%c".concat(a, "%c ").concat(e)) : e = "( ".concat(a, " )").concat(e));

  try {
    var _console, _console2;

    s ? o ? (_console = console)[t].apply(_console, ["".concat(e, " %o")].concat(r)) : (_console2 = console)[t].apply(_console2, [e].concat(r)) : console[t](e);
  } catch (_unused) {}
}

Ie.logLevel = "VERBOSE";

function Zn(n) {
  Ie.logLevel = n;
}

var S = Ie.bind(window, !1),
    X = Ie.bind(window, !0);

function le(n) {
  return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}

function A(n) {
  return le(n) === "function" || le(n) === "asyncfunction";
}

function D(n) {
  return le(n) === "object";
}

function te(n) {
  return le(n) === "string";
}

function Gn(n) {
  return le(n) === "boolean";
}

function yo(n) {
  return le(n) === "number";
}

function wo(n) {
  return le(n) === "undefined";
}

function V(n) {
  return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}

function Po(n) {
  return n > 47 && n < 58 || // number keys
  n === 32 || n === 13 || // Space bar & return key(s)
  n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
  n > 64 && n < 91 || // letter keys
  n > 95 && n < 112 || // Numpad keys
  n > 185 && n < 193 || // ;=,-./` (in order)
  n > 218 && n < 223;
}

function Qn(_x) {
  return _Qn.apply(this, arguments);
}

function _Qn() {
  _Qn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(n) {
    var e,
        t,
        o,
        _o4,
        _args56 = arguments;

    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            _o4 = function _o6() {
              _o4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(i, s, r) {
                return _regeneratorRuntime.wrap(function _callee55$(_context55) {
                  while (1) {
                    switch (_context55.prev = _context55.next) {
                      case 0:
                        _context55.prev = 0;
                        _context55.next = 3;
                        return i.function(i.data);

                      case 3:
                        _context55.next = 5;
                        return s(wo(i.data) ? {} : i.data);

                      case 5:
                        _context55.next = 10;
                        break;

                      case 7:
                        _context55.prev = 7;
                        _context55.t0 = _context55["catch"](0);
                        r(wo(i.data) ? {} : i.data);

                      case 10:
                      case "end":
                        return _context55.stop();
                    }
                  }
                }, _callee55, null, [[0, 7]]);
              }));
              return _o4.apply(this, arguments);
            };

            o = function _o5(_x46, _x47, _x48) {
              return _o4.apply(this, arguments);
            };

            e = _args56.length > 1 && _args56[1] !== undefined ? _args56[1] : function () {};
            t = _args56.length > 2 && _args56[2] !== undefined ? _args56[2] : function () {};
            return _context56.abrupt("return", n.reduce( /*#__PURE__*/function () {
              var _ref85 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(i, s) {
                return _regeneratorRuntime.wrap(function _callee54$(_context54) {
                  while (1) {
                    switch (_context54.prev = _context54.next) {
                      case 0:
                        _context54.next = 2;
                        return i;

                      case 2:
                        return _context54.abrupt("return", o(s, e, t));

                      case 3:
                      case "end":
                        return _context54.stop();
                    }
                  }
                }, _callee54);
              }));

              return function (_x49, _x50) {
                return _ref85.apply(this, arguments);
              };
            }(), Promise.resolve()));

          case 5:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }));
  return _Qn.apply(this, arguments);
}

function No(n) {
  return Array.prototype.slice.call(n);
}

function Fe(n, e) {
  return function () {
    var t = this,
        o = arguments;
    window.setTimeout(function () {
      return n.apply(t, o);
    }, e);
  };
}

function Jn(n) {
  return n.name.split(".").pop();
}

function ei(n) {
  return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}

function Eo(n, e, t) {
  var _this = this;

  var o;
  return function () {
    for (var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++) {
      i[_key] = arguments[_key];
    }

    var s = _this,
        r = function r() {
      o = null, t || n.apply(s, i);
    },
        a = t && !o;

    window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
  };
}

function dt(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
  var o,
      i,
      s,
      r = null,
      a = 0;
  t || (t = {});

  var l = function l() {
    a = t.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
  };

  return function () {
    var c = Date.now();
    !a && t.leading === !1 && (a = c);
    var d = e - (c - a);
    return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t.trailing !== !1 && (r = setTimeout(l, d)), s;
  };
}

function ti() {
  var n = {
    win: !1,
    mac: !1,
    x11: !1,
    linux: !1
  },
      e = Object.keys(n).find(function (t) {
    return window.navigator.appVersion.toLowerCase().indexOf(t) !== -1;
  });
  return e && (n[e] = !0), n;
}

function je(n) {
  return n[0].toUpperCase() + n.slice(1);
}

function ut(n) {
  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }

  if (!e.length) return n;
  var t = e.shift();
  if (D(n) && D(t)) for (var o in t) {
    D(t[o]) ? (n[o] || Object.assign(n, _defineProperty({}, o, {})), ut(n[o], t[o])) : Object.assign(n, _defineProperty({}, o, t[o]));
  }
  return ut.apply(void 0, [n].concat(e));
}

function vt(n) {
  var e = ti();
  return n = n.replace(/shift/gi, "⇧").replace(/backspace/gi, "⌫").replace(/enter/gi, "⏎").replace(/up/gi, "↑").replace(/left/gi, "→").replace(/down/gi, "↓").replace(/right/gi, "←").replace(/escape/gi, "⎋").replace(/insert/gi, "Ins").replace(/delete/gi, "␡").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "⌘").replace(/alt/gi, "⌥") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}

function oi(n) {
  try {
    return new URL(n).href;
  } catch (_unused2) {}

  return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}

function ni() {
  return Vn(10);
}

function ii(n) {
  window.open(n, "_blank");
}

function si() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return "".concat(n).concat(Math.floor(Math.random() * 1e8).toString(16));
}

function ht(n, e, t) {
  var o = "\xAB".concat(e, "\xBB is deprecated and will be removed in the next major release. Please use the \xAB").concat(t, "\xBB instead.");
  n && X(o, "warn");
}

function me(n, e, t) {
  var o = t.value ? "value" : "get",
      i = t[o],
      s = "#".concat(e, "Cache");

  if (t[o] = function () {
    for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      r[_key3] = arguments[_key3];
    }

    return this[s] === void 0 && (this[s] = i.apply.apply(i, [this].concat(r))), this[s];
  }, o === "get" && t.set) {
    var r = t.set;

    t.set = function (a) {
      delete n[s], r.apply(this, a);
    };
  }

  return t;
}

var Ro = 650;

function be() {
  return window.matchMedia("(max-width: ".concat(Ro, "px)")).matches;
}

var pt = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

function ri(n, e) {
  var t = Array.isArray(n) || D(n),
      o = Array.isArray(e) || D(e);
  return t || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}

var u = /*#__PURE__*/function () {
  function u() {
    _classCallCheck(this, u);
  }

  _createClass(u, null, [{
    key: "isSingleTag",
    value:
    /**
     * Check if passed tag has no closed tag
     *
     * @param {HTMLElement} tag - element to check
     * @returns {boolean}
     */
    function isSingleTag(e) {
      return e.tagName && ["AREA", "BASE", "BR", "COL", "COMMAND", "EMBED", "HR", "IMG", "INPUT", "KEYGEN", "LINK", "META", "PARAM", "SOURCE", "TRACK", "WBR"].includes(e.tagName);
    }
    /**
     * Check if element is BR or WBR
     *
     * @param {HTMLElement} element - element to check
     * @returns {boolean}
     */

  }, {
    key: "isLineBreakTag",
    value: function isLineBreakTag(e) {
      return e && e.tagName && ["BR", "WBR"].includes(e.tagName);
    }
    /**
     * Helper for making Elements with class name and attributes
     *
     * @param  {string} tagName - new Element tag name
     * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
     * @param  {object} [attributes] - any attributes
     * @returns {HTMLElement}
     */

  }, {
    key: "make",
    value: function make(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = document.createElement(e);

      if (Array.isArray(t)) {
        var _i$classList;

        var s = t.filter(function (r) {
          return r !== void 0;
        });

        (_i$classList = i.classList).add.apply(_i$classList, _toConsumableArray(s));
      } else t && i.classList.add(t);

      for (var _s2 in o) {
        Object.prototype.hasOwnProperty.call(o, _s2) && (i[_s2] = o[_s2]);
      }

      return i;
    }
    /**
     * Creates Text Node with the passed content
     *
     * @param {string} content - text content
     * @returns {Text}
     */

  }, {
    key: "text",
    value: function text(e) {
      return document.createTextNode(e);
    }
    /**
     * Append one or several elements to the parent
     *
     * @param  {Element|DocumentFragment} parent - where to append
     * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
     */

  }, {
    key: "append",
    value: function append(e, t) {
      Array.isArray(t) ? t.forEach(function (o) {
        return e.appendChild(o);
      }) : e.appendChild(t);
    }
    /**
     * Append element or a couple to the beginning of the parent elements
     *
     * @param {Element} parent - where to append
     * @param {Element|Element[]} elements - element or elements list
     */

  }, {
    key: "prepend",
    value: function prepend(e, t) {
      Array.isArray(t) ? (t = t.reverse(), t.forEach(function (o) {
        return e.prepend(o);
      })) : e.prepend(t);
    }
    /**
     * Swap two elements in parent
     *
     * @param {HTMLElement} el1 - from
     * @param {HTMLElement} el2 - to
     * @deprecated
     */

  }, {
    key: "swap",
    value: function swap(e, t) {
      var o = document.createElement("div"),
          i = e.parentNode;
      i.insertBefore(o, e), i.insertBefore(e, t), i.insertBefore(t, o), i.removeChild(o);
    }
    /**
     * Selector Decorator
     *
     * Returns first match
     *
     * @param {Element} el - element we searching inside. Default - DOM Document
     * @param {string} selector - searching string
     * @returns {Element}
     */

  }, {
    key: "find",
    value: function find() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return e.querySelector(t);
    }
    /**
     * Get Element by Id
     *
     * @param {string} id - id to find
     * @returns {HTMLElement | null}
     */

  }, {
    key: "get",
    value: function get(e) {
      return document.getElementById(e);
    }
    /**
     * Selector Decorator.
     *
     * Returns all matches
     *
     * @param {Element|Document} el - element we searching inside. Default - DOM Document
     * @param {string} selector - searching string
     * @returns {NodeList}
     */

  }, {
    key: "findAll",
    value: function findAll() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return e.querySelectorAll(t);
    }
    /**
     * Returns CSS selector for all text inputs
     */

  }, {
    key: "allInputsSelector",
    get: function get() {
      return "[contenteditable=true], textarea, input:not([type]), " + ["text", "password", "email", "number", "search", "tel", "url"].map(function (t) {
        return "input[type=\"".concat(t, "\"]");
      }).join(", ");
    }
    /**
     * Find all contenteditable, textarea and editable input elements passed holder contains
     *
     * @param holder - element where to find inputs
     */

  }, {
    key: "findAllInputs",
    value: function findAllInputs(e) {
      return No(e.querySelectorAll(u.allInputsSelector)).reduce(function (t, o) {
        return u.isNativeInput(o) || u.containsOnlyInlineElements(o) ? [].concat(_toConsumableArray(t), [o]) : [].concat(_toConsumableArray(t), _toConsumableArray(u.getDeepestBlockElements(o)));
      }, []);
    }
    /**
     * Search for deepest node which is Leaf.
     * Leaf is the vertex that doesn't have any child nodes
     *
     * @description Method recursively goes throw the all Node until it finds the Leaf
     * @param {Node} node - root Node. From this vertex we start Deep-first search
     *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
     * @param {boolean} [atLast] - find last text node
     * @returns - it can be text Node or Element Node, so that caret will able to work with it
     *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
     */

  }, {
    key: "getDeepestNode",
    value: function getDeepestNode(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var o = t ? "lastChild" : "firstChild",
          i = t ? "previousSibling" : "nextSibling";

      if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
        var s = e[o];
        if (u.isSingleTag(s) && !u.isNativeInput(s) && !u.isLineBreakTag(s)) if (s[i]) s = s[i];else if (s.parentNode[i]) s = s.parentNode[i];else return s.parentNode;
        return this.getDeepestNode(s, t);
      }

      return e;
    }
    /**
     * Check if object is DOM node
     *
     * @param {*} node - object to check
     * @returns {boolean}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "isElement",
    value: function isElement(e) {
      return yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
     * Check if object is DocumentFragment node
     *
     * @param {object} node - object to check
     * @returns {boolean}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "isFragment",
    value: function isFragment(e) {
      return yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
     * Check if passed element is contenteditable
     *
     * @param {HTMLElement} element - html element to check
     * @returns {boolean}
     */

  }, {
    key: "isContentEditable",
    value: function isContentEditable(e) {
      return e.contentEditable === "true";
    }
    /**
     * Checks target if it is native input
     *
     * @param {*} target - HTML element or string
     * @returns {boolean}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "isNativeInput",
    value: function isNativeInput(e) {
      var t = ["INPUT", "TEXTAREA"];
      return e && e.tagName ? t.includes(e.tagName) : !1;
    }
    /**
     * Checks if we can set caret
     *
     * @param {HTMLElement} target - target to check
     * @returns {boolean}
     */

  }, {
    key: "canSetCaret",
    value: function canSetCaret(e) {
      var t = !0;
      if (u.isNativeInput(e)) switch (e.type) {
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
          t = !1;
          break;
      } else t = u.isContentEditable(e);
      return t;
    }
    /**
     * Checks node if it is empty
     *
     * @description Method checks simple Node without any childs for emptiness
     * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
     * @param {Node} node - node to check
     * @param {string} [ignoreChars] - char or substring to treat as empty
     * @returns {boolean} true if it is empty
     */

  }, {
    key: "isNodeEmpty",
    value: function isNodeEmpty(e, t) {
      var o;
      return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("​", ""), t && (o = o.replace(new RegExp(t, "g"), "")), o.length === 0);
    }
    /**
     * checks node if it is doesn't have any child nodes
     *
     * @param {Node} node - node to check
     * @returns {boolean}
     */

  }, {
    key: "isLeaf",
    value: function isLeaf(e) {
      return e ? e.childNodes.length === 0 : !1;
    }
    /**
     * breadth-first search (BFS)
     * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
     *
     * @description Pushes to stack all DOM leafs and checks for emptiness
     * @param {Node} node - node to check
     * @param {string} [ignoreChars] - char or substring to treat as empty
     * @returns {boolean}
     */

  }, {
    key: "isEmpty",
    value: function isEmpty(e, t) {
      var o = [e];

      for (; o.length > 0;) {
        if (e = o.shift(), !!e) {
          if (this.isLeaf(e) && !this.isNodeEmpty(e, t)) return !1;
          e.childNodes && o.push.apply(o, _toConsumableArray(Array.from(e.childNodes)));
        }
      }

      return !0;
    }
    /**
     * Check if string contains html elements
     *
     * @param {string} str - string to check
     * @returns {boolean}
     */

  }, {
    key: "isHTMLString",
    value: function isHTMLString(e) {
      var t = u.make("div");
      return t.innerHTML = e, t.childElementCount > 0;
    }
    /**
     * Return length of node`s text content
     *
     * @param {Node} node - node with content
     * @returns {number}
     */

  }, {
    key: "getContentLength",
    value: function getContentLength(e) {
      return u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
     * Return array of names of block html elements
     *
     * @returns {string[]}
     */

  }, {
    key: "blockElements",
    get: function get() {
      return ["address", "article", "aside", "blockquote", "canvas", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "li", "main", "nav", "noscript", "ol", "output", "p", "pre", "ruby", "section", "table", "tbody", "thead", "tr", "tfoot", "ul", "video"];
    }
    /**
     * Check if passed content includes only inline elements
     *
     * @param {string|HTMLElement} data - element or html string
     * @returns {boolean}
     */

  }, {
    key: "containsOnlyInlineElements",
    value: function containsOnlyInlineElements(e) {
      var t;
      te(e) ? (t = document.createElement("div"), t.innerHTML = e) : t = e;

      var o = function o(i) {
        return !u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
      };

      return Array.from(t.children).every(o);
    }
    /**
     * Find and return all block elements in the passed parent (including subtree)
     *
     * @param {HTMLElement} parent - root element
     * @returns {HTMLElement[]}
     */

  }, {
    key: "getDeepestBlockElements",
    value: function getDeepestBlockElements(e) {
      return u.containsOnlyInlineElements(e) ? [e] : Array.from(e.children).reduce(function (t, o) {
        return [].concat(_toConsumableArray(t), _toConsumableArray(u.getDeepestBlockElements(o)));
      }, []);
    }
    /**
     * Helper for get holder from {string} or return HTMLElement
     *
     * @param {string | HTMLElement} element - holder's id or holder's HTML Element
     * @returns {HTMLElement}
     */

  }, {
    key: "getHolder",
    value: function getHolder(e) {
      return te(e) ? document.getElementById(e) : e;
    }
    /**
     * Returns true if element is anchor (is A tag)
     *
     * @param {Element} element - element to check
     * @returns {boolean}
     */

  }, {
    key: "isAnchor",
    value: function isAnchor(e) {
      return e.tagName.toLowerCase() === "a";
    }
    /**
     * Return element's offset related to the document
     *
     * @todo handle case when editor initialized in scrollable popup
     * @param el - element to compute offset
     */

  }, {
    key: "offset",
    value: function offset(e) {
      var t = e.getBoundingClientRect(),
          o = window.pageXOffset || document.documentElement.scrollLeft,
          i = window.pageYOffset || document.documentElement.scrollTop,
          s = t.top + i,
          r = t.left + o;
      return {
        top: s,
        left: r,
        bottom: s + t.height,
        right: r + t.width
      };
    }
    /**
     * Find text node and offset by total content offset
     *
     * @param {Node} root - root node to start search from
     * @param {number} totalOffset - offset relative to the root node content
     * @returns {{node: Node | null, offset: number}} - node and offset inside node
     */

  }, {
    key: "getNodeByOffset",
    value: function getNodeByOffset(e, t) {
      var o = 0,
          i = null;
      var s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
      var r = s.nextNode();

      for (; r;) {
        var c = r.textContent,
            d = c === null ? 0 : c.length;
        if (i = r, o + d >= t) break;
        o += d, r = s.nextNode();
      }

      if (!i) return {
        node: null,
        offset: 0
      };
      var a = i.textContent;
      if (a === null || a.length === 0) return {
        node: null,
        offset: 0
      };
      var l = Math.min(t - o, a.length);
      return {
        node: i,
        offset: l
      };
    }
  }]);

  return u;
}();

function ai(n) {
  return !/[^\t\n\r ]/.test(n);
}

function li(n) {
  var e = window.getComputedStyle(n),
      t = parseFloat(e.fontSize),
      o = parseFloat(e.lineHeight) || t * 1.2,
      i = parseFloat(e.paddingTop),
      s = parseFloat(e.borderTopWidth),
      r = parseFloat(e.marginTop),
      a = t * 0.8,
      l = (o - t) / 2;
  return r + s + i + l + a;
}

function Do(n) {
  n.dataset.empty = u.isEmpty(n) ? "true" : "false";
}

var ci = {
  blockTunes: {
    toggler: {
      "Click to tune": "",
      "or drag to move": ""
    }
  },
  inlineToolbar: {
    converter: {
      "Convert to": ""
    }
  },
  toolbar: {
    toolbox: {
      Add: ""
    }
  },
  popover: {
    Filter: "",
    "Nothing found": "",
    "Convert to": ""
  }
},
    di = {
  Text: "",
  Link: "",
  Bold: "",
  Italic: ""
},
    ui = {
  link: {
    "Add a link": ""
  },
  stub: {
    "The block can not be displayed correctly.": ""
  }
},
    hi = {
  delete: {
    Delete: "",
    "Click to delete": ""
  },
  moveUp: {
    "Move up": ""
  },
  moveDown: {
    "Move down": ""
  }
},
    Fo = {
  ui: ci,
  toolNames: di,
  tools: ui,
  blockTunes: hi
},
    jo = /*#__PURE__*/function () {
  function he() {
    _classCallCheck(this, he);
  }

  _createClass(he, null, [{
    key: "ui",
    value:
    /**
     * Type-safe translation for internal UI texts:
     * Perform translation of the string by namespace and a key
     *
     * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
     * @param internalNamespace - path to translated string in dictionary
     * @param dictKey - dictionary key. Better to use default locale original text
     */
    function ui(e, t) {
      return he._t(e, t);
    }
    /**
     * Translate for external strings that is not presented in default dictionary.
     * For example, for user-specified tool names
     *
     * @param namespace - path to translated string in dictionary
     * @param dictKey - dictionary key. Better to use default locale original text
     */

  }, {
    key: "t",
    value: function t(e, _t2) {
      return he._t(e, _t2);
    }
    /**
     * Adjust module for using external dictionary
     *
     * @param dictionary - new messages list to override default
     */

  }, {
    key: "setDictionary",
    value: function setDictionary(e) {
      he.currentDictionary = e;
    }
    /**
     * Perform translation both for internal and external namespaces
     * If there is no translation found, returns passed key as a translated message
     *
     * @param namespace - path to translated string in dictionary
     * @param dictKey - dictionary key. Better to use default locale original text
     */

  }, {
    key: "_t",
    value: function _t(e, t) {
      var o = he.getNamespace(e);
      return !o || !o[t] ? t : o[t];
    }
    /**
     * Find messages section by namespace path
     *
     * @param namespace - path to section
     */

  }, {
    key: "getNamespace",
    value: function getNamespace(e) {
      return e.split(".").reduce(function (o, i) {
        return !o || !Object.keys(o).length ? {} : o[i];
      }, he.currentDictionary);
    }
  }]);

  return he;
}();

jo.currentDictionary = Fo;
var z = jo;

var Ho = /*#__PURE__*/function (_Error) {
  _inherits(Ho, _Error);

  var _super = _createSuper(Ho);

  function Ho() {
    _classCallCheck(this, Ho);

    return _super.apply(this, arguments);
  }

  return Ho;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Oe = /*#__PURE__*/function () {
  function Oe() {
    _classCallCheck(this, Oe);

    this.subscribers = {};
  }
  /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */


  _createClass(Oe, [{
    key: "on",
    value: function on(e, t) {
      e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t);
    }
    /**
     * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
     *
     * @param eventName - event name
     * @param callback - subscriber
     */

  }, {
    key: "once",
    value: function once(e, t) {
      var _this2 = this;

      e in this.subscribers || (this.subscribers[e] = []);

      var o = function o(i) {
        var s = t(i),
            r = _this2.subscribers[e].indexOf(o);

        return r !== -1 && _this2.subscribers[e].splice(r, 1), s;
      };

      this.subscribers[e].push(o);
    }
    /**
     * Emit callbacks with passed data
     *
     * @param eventName - event name
     * @param data - subscribers get this data when they were fired
     */

  }, {
    key: "emit",
    value: function emit(e, t) {
      V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce(function (o, i) {
        var s = i(o);
        return s !== void 0 ? s : o;
      }, t);
    }
    /**
     * Unsubscribe callback from event
     *
     * @param eventName - event name
     * @param callback - event handler
     */

  }, {
    key: "off",
    value: function off(e, t) {
      if (this.subscribers[e] === void 0) {
        console.warn("EventDispatcher .off(): there is no subscribers for event \"".concat(e.toString(), "\". Probably, .off() called before .on()"));
        return;
      }

      for (var o = 0; o < this.subscribers[e].length; o++) {
        if (this.subscribers[e][o] === t) {
          delete this.subscribers[e][o];
          break;
        }
      }
    }
    /**
     * Destroyer
     * clears subscribers list
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.subscribers = {};
    }
  }]);

  return Oe;
}();

function J(n) {
  Object.setPrototypeOf(this, {
    /**
     * Block id
     *
     * @returns {string}
     */
    get id() {
      return n.id;
    },

    /**
     * Tool name
     *
     * @returns {string}
     */
    get name() {
      return n.name;
    },

    /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */
    get config() {
      return n.config;
    },

    /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */
    get holder() {
      return n.holder;
    },

    /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */
    get isEmpty() {
      return n.isEmpty;
    },

    /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */
    get selected() {
      return n.selected;
    },

    /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */
    set stretched(t) {
      n.stretched = t;
    },

    /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */
    get stretched() {
      return n.stretched;
    },

    /**
     * True if Block has inputs to be focused
     */
    get focusable() {
      return n.focusable;
    },

    /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */
    call: function call(t, o) {
      return n.call(t, o);
    },

    /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */
    save: function save() {
      return n.save();
    },

    /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */
    validate: function validate(t) {
      return n.validate(t);
    },

    /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */
    dispatchChange: function dispatchChange() {
      n.dispatchChange();
    },

    /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */
    getActiveToolboxEntry: function getActiveToolboxEntry() {
      return n.getActiveToolboxEntry();
    }
  });
}

var _e = /*#__PURE__*/function () {
  function _e() {
    _classCallCheck(this, _e);

    this.allListeners = [];
  }
  /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */


  _createClass(_e, [{
    key: "on",
    value: function on(e, t, o) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var s = si("l"),
          r = {
        id: s,
        element: e,
        eventType: t,
        handler: o,
        options: i
      };
      if (!this.findOne(e, t, o)) return this.allListeners.push(r), e.addEventListener(t, o, i), s;
    }
    /**
     * Removes event listener from element
     *
     * @param {EventTarget} element - DOM element that we removing listener
     * @param {string} eventType - event type
     * @param {Function} handler - remove handler, if element listens several handlers on the same event type
     * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
     */

  }, {
    key: "off",
    value: function off(e, t, o, i) {
      var _this3 = this;

      var s = this.findAll(e, t, o);
      s.forEach(function (r, a) {
        var l = _this3.allListeners.indexOf(s[a]);

        l > -1 && (_this3.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
      });
    }
    /**
     * Removes listener by id
     *
     * @param {string} id - listener identifier
     */

  }, {
    key: "offById",
    value: function offById(e) {
      var t = this.findById(e);
      t && t.element.removeEventListener(t.eventType, t.handler, t.options);
    }
    /**
     * Finds and returns first listener by passed params
     *
     * @param {EventTarget} element - event target
     * @param {string} [eventType] - event type
     * @param {Function} [handler] - event handler
     * @returns {ListenerData|null}
     */

  }, {
    key: "findOne",
    value: function findOne(e, t, o) {
      var i = this.findAll(e, t, o);
      return i.length > 0 ? i[0] : null;
    }
    /**
     * Return all stored listeners by passed params
     *
     * @param {EventTarget} element - event target
     * @param {string} eventType - event type
     * @param {Function} handler - event handler
     * @returns {ListenerData[]}
     */

  }, {
    key: "findAll",
    value: function findAll(e, t, o) {
      var i;
      var s = e ? this.findByEventTarget(e) : [];
      return e && t && o ? i = s.filter(function (r) {
        return r.eventType === t && r.handler === o;
      }) : e && t ? i = s.filter(function (r) {
        return r.eventType === t;
      }) : i = s, i;
    }
    /**
     * Removes all listeners
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      this.allListeners.map(function (e) {
        e.element.removeEventListener(e.eventType, e.handler, e.options);
      }), this.allListeners = [];
    }
    /**
     * Module cleanup on destruction
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAll();
    }
    /**
     * Search method: looks for listener by passed element
     *
     * @param {EventTarget} element - searching element
     * @returns {Array} listeners that found on element
     */

  }, {
    key: "findByEventTarget",
    value: function findByEventTarget(e) {
      return this.allListeners.filter(function (t) {
        if (t.element === e) return t;
      });
    }
    /**
     * Search method: looks for listener by passed event type
     *
     * @param {string} eventType - event type
     * @returns {ListenerData[]} listeners that found on element
     */

  }, {
    key: "findByType",
    value: function findByType(e) {
      return this.allListeners.filter(function (t) {
        if (t.eventType === e) return t;
      });
    }
    /**
     * Search method: looks for listener by passed handler
     *
     * @param {Function} handler - event handler
     * @returns {ListenerData[]} listeners that found on element
     */

  }, {
    key: "findByHandler",
    value: function findByHandler(e) {
      return this.allListeners.filter(function (t) {
        if (t.handler === e) return t;
      });
    }
    /**
     * Returns listener data found by id
     *
     * @param {string} id - listener identifier
     * @returns {ListenerData}
     */

  }, {
    key: "findById",
    value: function findById(e) {
      return this.allListeners.find(function (t) {
        return t.id === e;
      });
    }
  }]);

  return _e;
}();

var E = /*#__PURE__*/function () {
  /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */
  function E(_ref) {
    var _this4 = this;

    var e = _ref.config,
        t = _ref.eventsDispatcher;

    _classCallCheck(this, E);

    if (this.nodes = {}, this.listeners = new _e(), this.readOnlyMutableListeners = {
      /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */
      on: function on(o, i, s) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

        _this4.mutableListenerIds.push(_this4.listeners.on(o, i, s, r));
      },

      /**
       * Clears all mutable listeners
       */
      clearAll: function clearAll() {
        var _iterator = _createForOfIteratorHelper(_this4.mutableListenerIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var o = _step.value;

            _this4.listeners.offById(o);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        _this4.mutableListenerIds = [];
      }
    }, this.mutableListenerIds = [], (this instanceof E ? this.constructor : void 0) === E) throw new TypeError("Constructors for abstract class Module are not allowed.");
    this.config = e, this.eventsDispatcher = t;
  }
  /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */


  _createClass(E, [{
    key: "state",
    set: function set(e) {
      this.Editor = e;
    }
    /**
     * Remove memorized nodes
     */

  }, {
    key: "removeAllNodes",
    value: function removeAllNodes() {
      for (var e in this.nodes) {
        var t = this.nodes[e];
        t instanceof HTMLElement && t.remove();
      }
    }
    /**
     * Returns true if current direction is RTL (Right-To-Left)
     */

  }, {
    key: "isRtl",
    get: function get() {
      return this.config.i18n.direction === "rtl";
    }
  }]);

  return E;
}();

var b = /*#__PURE__*/function () {
  function b() {
    _classCallCheck(this, b);

    this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor", this.commandRemoveFormat = "removeFormat";
  }
  /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */


  _createClass(b, [{
    key: "removeFakeBackground",
    value:
    /**
     * Removes fake background
     */
    function removeFakeBackground() {
      this.isFakeBackgroundEnabled && (this.isFakeBackgroundEnabled = !1, document.execCommand(this.commandRemoveFormat));
    }
    /**
     * Sets fake background
     */

  }, {
    key: "setFakeBackground",
    value: function setFakeBackground() {
      document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
     * Save SelectionUtils's range
     */

  }, {
    key: "save",
    value: function save() {
      this.savedSelectionRange = b.range;
    }
    /**
     * Restore saved SelectionUtils's range
     */

  }, {
    key: "restore",
    value: function restore() {
      if (!this.savedSelectionRange) return;
      var e = window.getSelection();
      e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
     * Clears saved selection
     */

  }, {
    key: "clearSaved",
    value: function clearSaved() {
      this.savedSelectionRange = null;
    }
    /**
     * Collapse current selection
     */

  }, {
    key: "collapseToEnd",
    value: function collapseToEnd() {
      var e = window.getSelection(),
          t = document.createRange();
      t.selectNodeContents(e.focusNode), t.collapse(!1), e.removeAllRanges(), e.addRange(t);
    }
    /**
     * Looks ahead to find passed tag from current selection
     *
     * @param  {string} tagName       - tag to found
     * @param  {string} [className]   - tag's class name
     * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
     * @returns {HTMLElement|null}
     */

  }, {
    key: "findParentTag",
    value: function findParentTag(e, t) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var i = window.getSelection();
      var s = null;
      return !i || !i.anchorNode || !i.focusNode ? null : ([
      /** the Node in which the selection begins */
      i.anchorNode,
      /** the Node in which the selection ends */
      i.focusNode].forEach(function (a) {
        var l = o;

        for (; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t && a.classList && !a.classList.contains(t) && (s = null), s));) {
          a = a.parentNode, l--;
        }
      }), s);
    }
    /**
     * Expands selection range to the passed parent node
     *
     * @param {HTMLElement} element - element which contents should be selected
     */

  }, {
    key: "expandToTag",
    value: function expandToTag(e) {
      var t = window.getSelection();
      t.removeAllRanges();
      var o = document.createRange();
      o.selectNodeContents(e), t.addRange(o);
    }
  }], [{
    key: "CSS",
    get: function get() {
      return {
        editorWrapper: "codex-editor",
        editorZone: "codex-editor__redactor"
      };
    }
    /**
     * Returns selected anchor
     * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
     *
     * @returns {Node|null}
     */

  }, {
    key: "anchorNode",
    get: function get() {
      var e = window.getSelection();
      return e ? e.anchorNode : null;
    }
    /**
     * Returns selected anchor element
     *
     * @returns {Element|null}
     */

  }, {
    key: "anchorElement",
    get: function get() {
      var e = window.getSelection();
      if (!e) return null;
      var t = e.anchorNode;
      return t ? u.isElement(t) ? t : t.parentElement : null;
    }
    /**
     * Returns selection offset according to the anchor node
     * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
     *
     * @returns {number|null}
     */

  }, {
    key: "anchorOffset",
    get: function get() {
      var e = window.getSelection();
      return e ? e.anchorOffset : null;
    }
    /**
     * Is current selection range collapsed
     *
     * @returns {boolean|null}
     */

  }, {
    key: "isCollapsed",
    get: function get() {
      var e = window.getSelection();
      return e ? e.isCollapsed : null;
    }
    /**
     * Check current selection if it is at Editor's zone
     *
     * @returns {boolean}
     */

  }, {
    key: "isAtEditor",
    get: function get() {
      return this.isSelectionAtEditor(b.get());
    }
    /**
     * Check if passed selection is at Editor's zone
     *
     * @param selection - Selection object to check
     */

  }, {
    key: "isSelectionAtEditor",
    value: function isSelectionAtEditor(e) {
      if (!e) return !1;
      var t = e.anchorNode || e.focusNode;
      t && t.nodeType === Node.TEXT_NODE && (t = t.parentNode);
      var o = null;
      return t && t instanceof Element && (o = t.closest(".".concat(b.CSS.editorZone))), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
     * Check if passed range at Editor zone
     *
     * @param range - range to check
     */

  }, {
    key: "isRangeAtEditor",
    value: function isRangeAtEditor(e) {
      if (!e) return;
      var t = e.startContainer;
      t && t.nodeType === Node.TEXT_NODE && (t = t.parentNode);
      var o = null;
      return t && t instanceof Element && (o = t.closest(".".concat(b.CSS.editorZone))), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
     * Methods return boolean that true if selection exists on the page
     */

  }, {
    key: "isSelectionExists",
    get: function get() {
      return !!b.get().anchorNode;
    }
    /**
     * Return first range
     *
     * @returns {Range|null}
     */

  }, {
    key: "range",
    get: function get() {
      return this.getRangeFromSelection(this.get());
    }
    /**
     * Returns range from passed Selection object
     *
     * @param selection - Selection object to get Range from
     */

  }, {
    key: "getRangeFromSelection",
    value: function getRangeFromSelection(e) {
      return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
     * Calculates position and size of selected text
     *
     * @returns {DOMRect | ClientRect}
     */

  }, {
    key: "rect",
    get: function get() {
      var e = document.selection,
          t,
          o = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
      if (e && e.type !== "Control") return e = e, t = e.createRange(), o.x = t.boundingLeft, o.y = t.boundingTop, o.width = t.boundingWidth, o.height = t.boundingHeight, o;
      if (!window.getSelection) return S("Method window.getSelection is not supported", "warn"), o;
      if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
      if (e.rangeCount === 0) return o;

      if (t = e.getRangeAt(0).cloneRange(), t.getBoundingClientRect && (o = t.getBoundingClientRect()), o.x === 0 && o.y === 0) {
        var i = document.createElement("span");

        if (i.getBoundingClientRect) {
          i.appendChild(document.createTextNode("​")), t.insertNode(i), o = i.getBoundingClientRect();
          var s = i.parentNode;
          s.removeChild(i), s.normalize();
        }
      }

      return o;
    }
    /**
     * Returns selected text as String
     *
     * @returns {string}
     */

  }, {
    key: "text",
    get: function get() {
      return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
     * Returns window SelectionUtils
     * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
     *
     * @returns {Selection}
     */

  }, {
    key: "get",
    value: function get() {
      return window.getSelection();
    }
    /**
     * Set focus to contenteditable or native input element
     *
     * @param element - element where to set focus
     * @param offset - offset of cursor
     */

  }, {
    key: "setCursor",
    value: function setCursor(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var o = document.createRange(),
          i = window.getSelection();
      return u.isNativeInput(e) ? u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t), o.setEnd(e, t), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
     * Check if current range exists and belongs to container
     *
     * @param container - where range should be
     */

  }, {
    key: "isRangeInsideContainer",
    value: function isRangeInsideContainer(e) {
      var t = b.range;
      return t === null ? !1 : e.contains(t.startContainer);
    }
    /**
     * Adds fake cursor to the current range
     */

  }, {
    key: "addFakeCursor",
    value: function addFakeCursor() {
      var e = b.range;
      if (e === null) return;
      var t = u.make("span", "codex-editor__fake-cursor");
      t.dataset.mutationFree = "true", e.collapse(), e.insertNode(t);
    }
    /**
     * Check if passed element contains a fake cursor
     *
     * @param el - where to check
     */

  }, {
    key: "isFakeCursorInsideContainer",
    value: function isFakeCursorInsideContainer(e) {
      return u.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
     * Removes fake cursor from a container
     *
     * @param container - container to look for
     */

  }, {
    key: "removeFakeCursor",
    value: function removeFakeCursor() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      var t = u.find(e, ".codex-editor__fake-cursor");
      t && t.remove();
    }
  }]);

  return b;
}();

function pi(n, e) {
  var t = n.type,
      o = n.target,
      i = n.addedNodes,
      s = n.removedNodes;
  return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t === "childList" && (Array.from(i).some(function (l) {
    return l === e;
  }) || Array.from(s).some(function (l) {
    return l === e;
  })));
}

var ft = "redactor dom changed",
    $o = "block changed",
    zo = "fake cursor is about to be toggled",
    Uo = "fake cursor have been set",
    Te = "editor mobile layout toggled";

function gt(n, e) {
  if (!n.conversionConfig) return !1;
  var t = n.conversionConfig[e];
  return A(t) || te(t);
}

function He(n, e) {
  return gt(n.tool, e);
}

function Wo(n, e) {
  return Object.entries(n).some(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        t = _ref3[0],
        o = _ref3[1];

    return e[t] && ri(e[t], o);
  });
}

function Yo(_x2, _x3) {
  return _Yo.apply(this, arguments);
}

function _Yo() {
  _Yo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(n, e) {
    var o, i;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            _context57.next = 2;
            return n.save();

          case 2:
            o = _context57.sent.data;
            i = e.find(function (s) {
              return s.name === n.name;
            });
            return _context57.abrupt("return", i !== void 0 && !gt(i, "export") ? [] : e.reduce(function (s, r) {
              if (!gt(r, "import") || r.toolbox === void 0) return s;
              var a = r.toolbox.filter(function (l) {
                if (V(l) || l.icon === void 0) return !1;

                if (l.data !== void 0) {
                  if (Wo(l.data, o)) return !1;
                } else if (r.name === n.name) return !1;

                return !0;
              });
              return s.push(_objectSpread(_objectSpread({}, r), {}, {
                toolbox: a
              })), s;
            }, []));

          case 5:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57);
  }));
  return _Yo.apply(this, arguments);
}

function xo(n, e) {
  return n.mergeable ? n.name === e.name ? !0 : He(e, "export") && He(n, "import") : !1;
}

function fi(n, e) {
  var t = e == null ? void 0 : e.export;
  return A(t) ? t(n) : te(t) ? n[t] : (t !== void 0 && S("Conversion «export» property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}

function Bo(n, e, t) {
  var o = e == null ? void 0 : e.import;
  return A(o) ? o(n, t) : te(o) ? _defineProperty({}, o, n) : (o !== void 0 && S("Conversion «import» property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}

var _ = /* @__PURE__ */function (n) {
  return n.Default = "default", n.Separator = "separator", n.Html = "html", n;
}(_ || {}),
    ee = /* @__PURE__ */function (n) {
  return n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n;
}(ee || {});

var R = /*#__PURE__*/function (_Oe) {
  _inherits(R, _Oe);

  var _super2 = _createSuper(R);

  /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */
  function R(_ref5, r) {
    var _this5;

    var _ref5$id = _ref5.id,
        e = _ref5$id === void 0 ? ni() : _ref5$id,
        t = _ref5.data,
        o = _ref5.tool,
        i = _ref5.readOnly,
        s = _ref5.tunesData;

    _classCallCheck(this, R);

    _this5 = _super2.call(this), _this5.cachedInputs = [], _this5.toolRenderedElement = null, _this5.tunesInstances = /* @__PURE__ */new Map(), _this5.defaultTunesInstances = /* @__PURE__ */new Map(), _this5.unavailableTunesData = {}, _this5.inputIndex = 0, _this5.editorEventBus = null, _this5.handleFocus = function () {
      _this5.dropInputsCache(), _this5.updateCurrentInput();
    }, _this5.didMutated = function () {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
      var l = a === void 0,
          c = a instanceof InputEvent;
      !l && !c && _this5.detectToolRootChange(a);
      var d;
      l || c ? d = !0 : d = !(a.length > 0 && a.every(function (p) {
        var g = p.addedNodes,
            f = p.removedNodes,
            v = p.target;
        return [].concat(_toConsumableArray(Array.from(g)), _toConsumableArray(Array.from(f)), [v]).some(function (T) {
          return u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null;
        });
      })), d && (_this5.dropInputsCache(), _this5.updateCurrentInput(), _this5.toggleInputsEmptyMark(), _this5.call("updated"
      /* UPDATED */
      ), _this5.emit("didMutated", _assertThisInitialized(_this5)));
    }, _this5.name = o.name, _this5.id = e, _this5.settings = o.settings, _this5.config = o.settings.config || {}, _this5.editorEventBus = r || null, _this5.blockAPI = new J(_assertThisInitialized(_this5)), _this5.tool = o, _this5.toolInstance = o.create(t, _this5.blockAPI, i), _this5.tunes = o.tunes, _this5.composeTunes(s), _this5.holder = _this5.compose(), window.requestIdleCallback(function () {
      _this5.watchBlockMutations(), _this5.addInputEvents(), _this5.toggleInputsEmptyMark();
    });
    return _this5;
  }
  /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */


  _createClass(R, [{
    key: "inputs",
    get:
    /**
     * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
     */
    function get() {
      if (this.cachedInputs.length !== 0) return this.cachedInputs;
      var e = u.findAllInputs(this.holder);
      return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
     * Return current Tool`s input
     * If Block doesn't contain inputs, return undefined
     */

  }, {
    key: "currentInput",
    get: function get() {
      return this.inputs[this.inputIndex];
    }
    /**
     * Set input index to the passed element
     *
     * @param element - HTML Element to set as current input
     */
    ,
    set: function set(e) {
      var t = this.inputs.findIndex(function (o) {
        return o === e || o.contains(e);
      });
      t !== -1 && (this.inputIndex = t);
    }
    /**
     * Return first Tool`s input
     * If Block doesn't contain inputs, return undefined
     */

  }, {
    key: "firstInput",
    get: function get() {
      return this.inputs[0];
    }
    /**
     * Return first Tool`s input
     * If Block doesn't contain inputs, return undefined
     */

  }, {
    key: "lastInput",
    get: function get() {
      var e = this.inputs;
      return e[e.length - 1];
    }
    /**
     * Return next Tool`s input or undefined if it doesn't exist
     * If Block doesn't contain inputs, return undefined
     */

  }, {
    key: "nextInput",
    get: function get() {
      return this.inputs[this.inputIndex + 1];
    }
    /**
     * Return previous Tool`s input or undefined if it doesn't exist
     * If Block doesn't contain inputs, return undefined
     */

  }, {
    key: "previousInput",
    get: function get() {
      return this.inputs[this.inputIndex - 1];
    }
    /**
     * Get Block's JSON data
     *
     * @returns {object}
     */

  }, {
    key: "data",
    get: function get() {
      return this.save().then(function (e) {
        return e && !V(e.data) ? e.data : {};
      });
    }
    /**
     * Returns tool's sanitizer config
     *
     * @returns {object}
     */

  }, {
    key: "sanitize",
    get: function get() {
      return this.tool.sanitizeConfig;
    }
    /**
     * is block mergeable
     * We plugin have merge function then we call it mergeable
     *
     * @returns {boolean}
     */

  }, {
    key: "mergeable",
    get: function get() {
      return A(this.toolInstance.merge);
    }
    /**
     * If Block contains inputs, it is focusable
     */

  }, {
    key: "focusable",
    get: function get() {
      return this.inputs.length !== 0;
    }
    /**
     * Check block for emptiness
     *
     * @returns {boolean}
     */

  }, {
    key: "isEmpty",
    get: function get() {
      var e = u.isEmpty(this.pluginsContent, "/"),
          t = !this.hasMedia;
      return e && t;
    }
    /**
     * Check if block has a media content such as images, iframe and other
     *
     * @returns {boolean}
     */

  }, {
    key: "hasMedia",
    get: function get() {
      var e = ["img", "iframe", "video", "audio", "source", "input", "textarea", "twitterwidget"];
      return !!this.holder.querySelector(e.join(","));
    }
    /**
     * Set selected state
     * We don't need to mark Block as Selected when it is empty
     *
     * @param {boolean} state - 'true' to select, 'false' to remove selection
     */

  }, {
    key: "selected",
    get:
    /**
     * Returns True if it is Selected
     *
     * @returns {boolean}
     */
    function get() {
      return this.holder.classList.contains(R.CSS.selected);
    }
    /**
     * Set stretched state
     *
     * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
     */
    ,
    set: function set(e) {
      var i, s;
      this.holder.classList.toggle(R.CSS.selected, e);
      var t = e === !0 && b.isRangeInsideContainer(this.holder),
          o = e === !1 && b.isFakeCursorInsideContainer(this.holder);
      (t || o) && ((i = this.editorEventBus) == null || i.emit(zo, {
        state: e
      }), t ? b.addFakeCursor() : b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit(Uo, {
        state: e
      }));
    }
  }, {
    key: "stretched",
    get:
    /**
     * Return Block's stretched state
     *
     * @returns {boolean}
     */
    function get() {
      return this.holder.classList.contains(R.CSS.wrapperStretched);
    }
    /**
     * Toggle drop target state
     *
     * @param {boolean} state - 'true' if block is drop target, false otherwise
     */
    ,
    set: function set(e) {
      this.holder.classList.toggle(R.CSS.wrapperStretched, e);
    }
  }, {
    key: "dropTarget",
    set: function set(e) {
      this.holder.classList.toggle(R.CSS.dropTarget, e);
    }
    /**
     * Returns Plugins content
     *
     * @returns {HTMLElement}
     */

  }, {
    key: "pluginsContent",
    get: function get() {
      return this.toolRenderedElement;
    }
    /**
     * Calls Tool's method
     *
     * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
     *
     * @param {string} methodName - method to call
     * @param {object} params - method argument
     */

  }, {
    key: "call",
    value: function call(e, t) {
      if (A(this.toolInstance[e])) {
        e === "appendCallback" && S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");

        try {
          this.toolInstance[e].call(this.toolInstance, t);
        } catch (o) {
          S("Error during '".concat(e, "' call: ").concat(o.message), "error");
        }
      }
    }
    /**
     * Call plugins merge method
     *
     * @param {BlockToolData} data - data to merge
     */

  }, {
    key: "mergeWith",
    value: function () {
      var _mergeWith = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.toolInstance.merge(e);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mergeWith(_x4) {
        return _mergeWith.apply(this, arguments);
      }

      return mergeWith;
    }()
    /**
     * Extracts data from Block
     * Groups Tool's save processing time
     *
     * @returns {object}
     */

  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this6 = this;

        var e, t, o, i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.toolInstance.save(this.pluginsContent);

              case 2:
                e = _context2.sent;
                t = this.unavailableTunesData;
                [].concat(_toConsumableArray(this.tunesInstances.entries()), _toConsumableArray(this.defaultTunesInstances.entries())).forEach(function (_ref6) {
                  var _ref7 = _slicedToArray(_ref6, 2),
                      s = _ref7[0],
                      r = _ref7[1];

                  if (A(r.save)) try {
                    t[s] = r.save();
                  } catch (a) {
                    S("Tune ".concat(r.constructor.name, " save method throws an Error %o"), "warn", a);
                  }
                });
                o = window.performance.now();
                return _context2.abrupt("return", Promise.resolve(e).then(function (s) {
                  return i = window.performance.now(), {
                    id: _this6.id,
                    tool: _this6.name,
                    data: s,
                    tunes: t,
                    time: i - o
                  };
                }).catch(function (s) {
                  S("Saving process for ".concat(_this6.name, " tool failed due to the ").concat(s), "log", "red");
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
    /**
     * Uses Tool's validation method to check the correctness of output data
     * Tool's validation method is optional
     *
     * @description Method returns true|false whether data passed the validation or not
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>} valid
     */

  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = !0;
                _context3.t0 = this.toolInstance.validate instanceof Function;

                if (!_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 5;
                return this.toolInstance.validate(e);

              case 5:
                t = _context3.sent;

              case 6:
                return _context3.abrupt("return", t);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validate(_x5) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
    /**
     * Returns data to render in Block Tunes menu.
     * Splits block tunes into 2 groups: block specific tunes and common tunes
     */

  }, {
    key: "getTunes",
    value: function getTunes() {
      var e = [],
          t = [],
          o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
      return u.isElement(o) ? e.push({
        type: _.Html,
        element: o
      }) : Array.isArray(o) ? e.push.apply(e, _toConsumableArray(o)) : e.push(o), [].concat(_toConsumableArray(this.tunesInstances.values()), _toConsumableArray(this.defaultTunesInstances.values())).map(function (s) {
        return s.render();
      }).forEach(function (s) {
        u.isElement(s) ? t.push({
          type: _.Html,
          element: s
        }) : Array.isArray(s) ? t.push.apply(t, _toConsumableArray(s)) : t.push(s);
      }), {
        toolTunes: e,
        commonTunes: t
      };
    }
    /**
     * Update current input index with selection anchor node
     */

  }, {
    key: "updateCurrentInput",
    value: function updateCurrentInput() {
      this.currentInput = u.isNativeInput(document.activeElement) || !b.anchorNode ? document.activeElement : b.anchorNode;
    }
    /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */

  }, {
    key: "dispatchChange",
    value: function dispatchChange() {
      this.didMutated();
    }
    /**
     * Call Tool instance destroy method
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.unwatchBlockMutations(), this.removeInputEvents(), _get(_getPrototypeOf(R.prototype), "destroy", this).call(this), A(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */

  }, {
    key: "getActiveToolboxEntry",
    value: function () {
      var _getActiveToolboxEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var e, t, o;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e = this.tool.toolbox;

                if (!(e.length === 1)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", Promise.resolve(this.tool.toolbox[0]));

              case 3:
                _context4.next = 5;
                return this.data;

              case 5:
                t = _context4.sent;
                o = e;
                return _context4.abrupt("return", o == null ? void 0 : o.find(function (i) {
                  return Wo(i.data, t);
                }));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getActiveToolboxEntry() {
        return _getActiveToolboxEntry.apply(this, arguments);
      }

      return getActiveToolboxEntry;
    }()
    /**
     * Exports Block data as string using conversion config
     */

  }, {
    key: "exportDataAsString",
    value: function () {
      var _exportDataAsString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var e;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.data;

              case 2:
                e = _context5.sent;
                return _context5.abrupt("return", fi(e, this.tool.conversionConfig));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function exportDataAsString() {
        return _exportDataAsString.apply(this, arguments);
      }

      return exportDataAsString;
    }()
    /**
     * Make default Block wrappers and put Tool`s content there
     *
     * @returns {HTMLDivElement}
     */

  }, {
    key: "compose",
    value: function compose() {
      var e = u.make("div", R.CSS.wrapper),
          t = u.make("div", R.CSS.content),
          o = this.toolInstance.render();
      e.dataset.id = this.id, this.toolRenderedElement = o, t.appendChild(this.toolRenderedElement);
      var i = t;
      return [].concat(_toConsumableArray(this.tunesInstances.values()), _toConsumableArray(this.defaultTunesInstances.values())).forEach(function (s) {
        if (A(s.wrap)) try {
          i = s.wrap(i);
        } catch (r) {
          S("Tune ".concat(s.constructor.name, " wrap method throws an Error %o"), "warn", r);
        }
      }), e.appendChild(i), e;
    }
    /**
     * Instantiate Block Tunes
     *
     * @param tunesData - current Block tunes data
     * @private
     */

  }, {
    key: "composeTunes",
    value: function composeTunes(e) {
      var _this7 = this;

      Array.from(this.tunes.values()).forEach(function (t) {
        (t.isInternal ? _this7.defaultTunesInstances : _this7.tunesInstances).set(t.name, t.create(e[t.name], _this7.blockAPI));
      }), Object.entries(e).forEach(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            t = _ref9[0],
            o = _ref9[1];

        _this7.tunesInstances.has(t) || (_this7.unavailableTunesData[t] = o);
      });
    }
    /**
     * Adds focus event listeners to all inputs and contenteditable
     */

  }, {
    key: "addInputEvents",
    value: function addInputEvents() {
      var _this8 = this;

      this.inputs.forEach(function (e) {
        e.addEventListener("focus", _this8.handleFocus), u.isNativeInput(e) && e.addEventListener("input", _this8.didMutated);
      });
    }
    /**
     * removes focus event listeners from all inputs and contenteditable
     */

  }, {
    key: "removeInputEvents",
    value: function removeInputEvents() {
      var _this9 = this;

      this.inputs.forEach(function (e) {
        e.removeEventListener("focus", _this9.handleFocus), u.isNativeInput(e) && e.removeEventListener("input", _this9.didMutated);
      });
    }
    /**
     * Listen common editor Dom Changed event and detect mutations related to the  Block
     */

  }, {
    key: "watchBlockMutations",
    value: function watchBlockMutations() {
      var _this10 = this;

      var e;
      this.redactorDomChangedCallback = function (t) {
        var o = t.mutations;
        o.some(function (s) {
          return pi(s, _this10.toolRenderedElement);
        }) && _this10.didMutated(o);
      }, (e = this.editorEventBus) == null || e.on(ft, this.redactorDomChangedCallback);
    }
    /**
     * Remove redactor dom change event listener
     */

  }, {
    key: "unwatchBlockMutations",
    value: function unwatchBlockMutations() {
      var e;
      (e = this.editorEventBus) == null || e.off(ft, this.redactorDomChangedCallback);
    }
    /**
     * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
     * We need to detect such changes and update a link to tools main element with the new one
     *
     * @param mutations - records of block content mutations
     */

  }, {
    key: "detectToolRootChange",
    value: function detectToolRootChange(e) {
      var _this11 = this;

      e.forEach(function (t) {
        if (Array.from(t.removedNodes).includes(_this11.toolRenderedElement)) {
          var i = t.addedNodes[t.addedNodes.length - 1];
          _this11.toolRenderedElement = i;
        }
      });
    }
    /**
     * Clears inputs cached value
     */

  }, {
    key: "dropInputsCache",
    value: function dropInputsCache() {
      this.cachedInputs = [];
    }
    /**
     * Mark inputs with 'data-empty' attribute with the empty state
     */

  }, {
    key: "toggleInputsEmptyMark",
    value: function toggleInputsEmptyMark() {
      this.inputs.forEach(Do);
    }
  }], [{
    key: "CSS",
    get: function get() {
      return {
        wrapper: "ce-block",
        wrapperStretched: "ce-block--stretched",
        content: "ce-block__content",
        selected: "ce-block--selected",
        dropTarget: "ce-block--drop-target"
      };
    }
  }]);

  return R;
}(Oe);

var gi = /*#__PURE__*/function (_E) {
  _inherits(gi, _E);

  var _super3 = _createSuper(gi);

  function gi() {
    var _this12;

    _classCallCheck(this, gi);

    _this12 = _super3.apply(this, arguments), _this12.insert = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this12.config.defaultBlock;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = arguments.length > 3 ? arguments[3] : undefined;
      var s = arguments.length > 4 ? arguments[4] : undefined;
      var r = arguments.length > 5 ? arguments[5] : undefined;
      var a = arguments.length > 6 ? arguments[6] : undefined;

      var l = _this12.Editor.BlockManager.insert({
        id: a,
        tool: e,
        data: t,
        index: i,
        needToFocus: s,
        replace: r
      });

      return new J(l);
    }, _this12.composeBlockData = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                t = _this12.Editor.Tools.blockTools.get(e);
                return _context6.abrupt("return", new R({
                  tool: t,
                  api: _this12.Editor.API,
                  readOnly: !0,
                  data: {},
                  tunesData: {}
                }).data);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref10.apply(this, arguments);
      };
    }(), _this12.update = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, t, o) {
        var i, s, r;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                i = _this12.Editor.BlockManager, s = i.getBlockById(e);

                if (!(s === void 0)) {
                  _context7.next = 3;
                  break;
                }

                throw new Error("Block with id \"".concat(e, "\" not found"));

              case 3:
                _context7.next = 5;
                return i.update(s, t, o);

              case 5:
                r = _context7.sent;
                return _context7.abrupt("return", new J(r));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x7, _x8, _x9) {
        return _ref11.apply(this, arguments);
      };
    }(), _this12.convert = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, t, o) {
        var h, p, _this12$Editor, i, s, r, a, l, c, d, g, _g;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this12$Editor = _this12.Editor, i = _this12$Editor.BlockManager, s = _this12$Editor.Tools, r = i.getBlockById(e);

                if (r) {
                  _context8.next = 3;
                  break;
                }

                throw new Error("Block with id \"".concat(e, "\" not found"));

              case 3:
                a = s.blockTools.get(r.name), l = s.blockTools.get(t);

                if (l) {
                  _context8.next = 6;
                  break;
                }

                throw new Error("Block Tool with type \"".concat(t, "\" not found"));

              case 6:
                c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;

                if (!(c && d)) {
                  _context8.next = 14;
                  break;
                }

                _context8.next = 10;
                return i.convert(r, t, o);

              case 10:
                g = _context8.sent;
                return _context8.abrupt("return", new J(g));

              case 14:
                _g = [c ? !1 : je(r.name), d ? !1 : je(t)].filter(Boolean).join(" and ");
                throw new Error("Conversion from \"".concat(r.name, "\" to \"").concat(t, "\" is not possible. ").concat(_g, " tool(s) should provide a \"conversionConfig\""));

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x10, _x11, _x12) {
        return _ref12.apply(this, arguments);
      };
    }(), _this12.insertMany = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this12.Editor.BlockManager.blocks.length - 1;

      _this12.validateIndex(t);

      var o = e.map(function (_ref13) {
        var i = _ref13.id,
            s = _ref13.type,
            r = _ref13.data;
        return _this12.Editor.BlockManager.composeBlock({
          id: i,
          tool: s || _this12.config.defaultBlock,
          data: r
        });
      });
      return _this12.Editor.BlockManager.insertMany(o, t), o.map(function (i) {
        return new J(i);
      });
    };
    return _this12;
  }
  /**
   * Available methods
   *
   * @returns {Blocks}
   */


  _createClass(gi, [{
    key: "methods",
    get: function get() {
      var _this13 = this;

      return {
        clear: function clear() {
          return _this13.clear();
        },
        render: function render(e) {
          return _this13.render(e);
        },
        renderFromHTML: function renderFromHTML(e) {
          return _this13.renderFromHTML(e);
        },
        delete: function _delete(e) {
          return _this13.delete(e);
        },
        swap: function swap(e, t) {
          return _this13.swap(e, t);
        },
        move: function move(e, t) {
          return _this13.move(e, t);
        },
        getBlockByIndex: function getBlockByIndex(e) {
          return _this13.getBlockByIndex(e);
        },
        getById: function getById(e) {
          return _this13.getById(e);
        },
        getCurrentBlockIndex: function getCurrentBlockIndex() {
          return _this13.getCurrentBlockIndex();
        },
        getBlockIndex: function getBlockIndex(e) {
          return _this13.getBlockIndex(e);
        },
        getBlocksCount: function getBlocksCount() {
          return _this13.getBlocksCount();
        },
        getBlockByElement: function getBlockByElement(e) {
          return _this13.getBlockByElement(e);
        },
        stretchBlock: function stretchBlock(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          return _this13.stretchBlock(e, t);
        },
        insertNewBlock: function insertNewBlock() {
          return _this13.insertNewBlock();
        },
        insert: this.insert,
        insertMany: this.insertMany,
        update: this.update,
        composeBlockData: this.composeBlockData,
        convert: this.convert
      };
    }
    /**
     * Returns Blocks count
     *
     * @returns {number}
     */

  }, {
    key: "getBlocksCount",
    value: function getBlocksCount() {
      return this.Editor.BlockManager.blocks.length;
    }
    /**
     * Returns current block index
     *
     * @returns {number}
     */

  }, {
    key: "getCurrentBlockIndex",
    value: function getCurrentBlockIndex() {
      return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
     * Returns the index of Block by id;
     *
     * @param id - block id
     */

  }, {
    key: "getBlockIndex",
    value: function getBlockIndex(e) {
      var t = this.Editor.BlockManager.getBlockById(e);

      if (!t) {
        X("There is no block with id `" + e + "`", "warn");
        return;
      }

      return this.Editor.BlockManager.getBlockIndex(t);
    }
    /**
     * Returns BlockAPI object by Block index
     *
     * @param {number} index - index to get
     */

  }, {
    key: "getBlockByIndex",
    value: function getBlockByIndex(e) {
      var t = this.Editor.BlockManager.getBlockByIndex(e);

      if (t === void 0) {
        X("There is no block at index `" + e + "`", "warn");
        return;
      }

      return new J(t);
    }
    /**
     * Returns BlockAPI object by Block id
     *
     * @param id - id of block to get
     */

  }, {
    key: "getById",
    value: function getById(e) {
      var t = this.Editor.BlockManager.getBlockById(e);
      return t === void 0 ? (X("There is no block with id `" + e + "`", "warn"), null) : new J(t);
    }
    /**
     * Get Block API object by any child html element
     *
     * @param element - html element to get Block by
     */

  }, {
    key: "getBlockByElement",
    value: function getBlockByElement(e) {
      var t = this.Editor.BlockManager.getBlock(e);

      if (t === void 0) {
        X("There is no block corresponding to element `" + e + "`", "warn");
        return;
      }

      return new J(t);
    }
    /**
     * Call Block Manager method that swap Blocks
     *
     * @param {number} fromIndex - position of first Block
     * @param {number} toIndex - position of second Block
     * @deprecated — use 'move' instead
     */

  }, {
    key: "swap",
    value: function swap(e, t) {
      S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t);
    }
    /**
     * Move block from one index to another
     *
     * @param {number} toIndex - index to move to
     * @param {number} fromIndex - index to move from
     */

  }, {
    key: "move",
    value: function move(e, t) {
      this.Editor.BlockManager.move(e, t);
    }
    /**
     * Deletes Block
     *
     * @param {number} blockIndex - index of Block to delete
     */

  }, {
    key: "delete",
    value: function _delete() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.Editor.BlockManager.currentBlockIndex;

      try {
        var t = this.Editor.BlockManager.getBlockByIndex(e);
        this.Editor.BlockManager.removeBlock(t);
      } catch (t) {
        X(t, "warn");
        return;
      }

      this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
     * Clear Editor's area
     */

  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.Editor.BlockManager.clear(!0);

              case 2:
                this.Editor.InlineToolbar.close();

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function clear() {
        return _clear.apply(this, arguments);
      }

      return clear;
    }()
    /**
     * Fills Editor with Blocks data
     *
     * @param {OutputData} data — Saved Editor data
     */

  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(e === void 0 || e.blocks === void 0)) {
                  _context10.next = 2;
                  break;
                }

                throw new Error("Incorrect data passed to the render() method");

              case 2:
                this.Editor.ModificationsObserver.disable();
                _context10.next = 5;
                return this.Editor.BlockManager.clear();

              case 5:
                _context10.next = 7;
                return this.Editor.Renderer.render(e.blocks);

              case 7:
                this.Editor.ModificationsObserver.enable();

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function render(_x13) {
        return _render.apply(this, arguments);
      }

      return render;
    }()
    /**
     * Render passed HTML string
     *
     * @param {string} data - HTML string to render
     * @returns {Promise<void>}
     */

  }, {
    key: "renderFromHTML",
    value: function () {
      var _renderFromHTML = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.Editor.BlockManager.clear();

              case 2:
                return _context11.abrupt("return", this.Editor.Paste.processText(e, !0));

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function renderFromHTML(_x14) {
        return _renderFromHTML.apply(this, arguments);
      }

      return renderFromHTML;
    }()
    /**
     * Stretch Block's content
     *
     * @param {number} index - index of Block to stretch
     * @param {boolean} status - true to enable, false to disable
     * @deprecated Use BlockAPI interface to stretch Blocks
     */

  }, {
    key: "stretchBlock",
    value: function stretchBlock(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      ht(!0, "blocks.stretchBlock()", "BlockAPI");
      var o = this.Editor.BlockManager.getBlockByIndex(e);
      o && (o.stretched = t);
    }
    /**
     * Insert new Block
     * After set caret to this Block
     *
     * @todo remove in 3.0.0
     * @deprecated with insert() method
     */

  }, {
    key: "insertNewBlock",
    value: function insertNewBlock() {
      S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
     * Validated block index and throws an error if it's invalid
     *
     * @param index - index to validate
     */

  }, {
    key: "validateIndex",
    value: function validateIndex(e) {
      if (typeof e != "number") throw new Error("Index should be a number");
      if (e < 0) throw new Error("Index should be greater than or equal to 0");
      if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
  }]);

  return gi;
}(E);

function mi(n, e) {
  return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}

var bi = /*#__PURE__*/function (_E2) {
  _inherits(bi, _E2);

  var _super4 = _createSuper(bi);

  function bi() {
    var _this14;

    _classCallCheck(this, bi);

    _this14 = _super4.apply(this, arguments), _this14.setToFirstBlock = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this14.Editor.Caret.positions.DEFAULT;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _this14.Editor.BlockManager.firstBlock ? (_this14.Editor.Caret.setToBlock(_this14.Editor.BlockManager.firstBlock, e, t), !0) : !1;
    }, _this14.setToLastBlock = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this14.Editor.Caret.positions.DEFAULT;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _this14.Editor.BlockManager.lastBlock ? (_this14.Editor.Caret.setToBlock(_this14.Editor.BlockManager.lastBlock, e, t), !0) : !1;
    }, _this14.setToPreviousBlock = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this14.Editor.Caret.positions.DEFAULT;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _this14.Editor.BlockManager.previousBlock ? (_this14.Editor.Caret.setToBlock(_this14.Editor.BlockManager.previousBlock, e, t), !0) : !1;
    }, _this14.setToNextBlock = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this14.Editor.Caret.positions.DEFAULT;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _this14.Editor.BlockManager.nextBlock ? (_this14.Editor.Caret.setToBlock(_this14.Editor.BlockManager.nextBlock, e, t), !0) : !1;
    }, _this14.setToBlock = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this14.Editor.Caret.positions.DEFAULT;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = mi(e, _this14.Editor);
      return i === void 0 ? !1 : (_this14.Editor.Caret.setToBlock(i, t, o), !0);
    }, _this14.focus = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return e ? _this14.setToLastBlock(_this14.Editor.Caret.positions.END) : _this14.setToFirstBlock(_this14.Editor.Caret.positions.START);
    };
    return _this14;
  }
  /**
   * Available methods
   *
   * @returns {Caret}
   */


  _createClass(bi, [{
    key: "methods",
    get: function get() {
      return {
        setToFirstBlock: this.setToFirstBlock,
        setToLastBlock: this.setToLastBlock,
        setToPreviousBlock: this.setToPreviousBlock,
        setToNextBlock: this.setToNextBlock,
        setToBlock: this.setToBlock,
        focus: this.focus
      };
    }
  }]);

  return bi;
}(E);

var vi = /*#__PURE__*/function (_E3) {
  _inherits(vi, _E3);

  var _super5 = _createSuper(vi);

  function vi() {
    _classCallCheck(this, vi);

    return _super5.apply(this, arguments);
  }

  _createClass(vi, [{
    key: "methods",
    get:
    /**
     * Available methods
     *
     * @returns {Events}
     */
    function get() {
      var _this15 = this;

      return {
        emit: function emit(e, t) {
          return _this15.emit(e, t);
        },
        off: function off(e, t) {
          return _this15.off(e, t);
        },
        on: function on(e, t) {
          return _this15.on(e, t);
        }
      };
    }
    /**
     * Subscribe on Events
     *
     * @param {string} eventName - event name to subscribe
     * @param {Function} callback - event handler
     */

  }, {
    key: "on",
    value: function on(e, t) {
      this.eventsDispatcher.on(e, t);
    }
    /**
     * Emit event with data
     *
     * @param {string} eventName - event to emit
     * @param {object} data - event's data
     */

  }, {
    key: "emit",
    value: function emit(e, t) {
      this.eventsDispatcher.emit(e, t);
    }
    /**
     * Unsubscribe from Event
     *
     * @param {string} eventName - event to unsubscribe
     * @param {Function} callback - event handler
     */

  }, {
    key: "off",
    value: function off(e, t) {
      this.eventsDispatcher.off(e, t);
    }
  }]);

  return vi;
}(E);

var kt = /*#__PURE__*/function (_E4) {
  _inherits(kt, _E4);

  var _super6 = _createSuper(kt);

  function kt() {
    _classCallCheck(this, kt);

    return _super6.apply(this, arguments);
  }

  _createClass(kt, [{
    key: "methods",
    get:
    /**
     * Return I18n API methods with global dictionary access
     */
    function get() {
      return {
        t: function t() {
          X("I18n.t() method can be accessed only from Tools", "warn");
        }
      };
    }
    /**
     * Return I18n API methods with tool namespaced dictionary
     *
     * @param toolName - tool name
     * @param isTune - is tool a block tune
     */

  }, {
    key: "getMethodsForTool",
    value: function getMethodsForTool(e, _t3) {
      return Object.assign(this.methods, {
        t: function t(o) {
          return z.t(kt.getNamespace(e, _t3), o);
        }
      });
    }
  }], [{
    key: "getNamespace",
    value:
    /**
     * Return namespace section for tool or block tune
     *
     * @param toolName - tool name
     * @param isTune - is tool a block tune
     */
    function getNamespace(e, t) {
      return t ? "blockTunes.".concat(e) : "tools.".concat(e);
    }
  }]);

  return kt;
}(E);

var ki = /*#__PURE__*/function (_E5) {
  _inherits(ki, _E5);

  var _super7 = _createSuper(ki);

  function ki() {
    _classCallCheck(this, ki);

    return _super7.apply(this, arguments);
  }

  _createClass(ki, [{
    key: "methods",
    get:
    /**
     * Editor.js Core API modules
     */
    function get() {
      return {
        blocks: this.Editor.BlocksAPI.methods,
        caret: this.Editor.CaretAPI.methods,
        tools: this.Editor.ToolsAPI.methods,
        events: this.Editor.EventsAPI.methods,
        listeners: this.Editor.ListenersAPI.methods,
        notifier: this.Editor.NotifierAPI.methods,
        sanitizer: this.Editor.SanitizerAPI.methods,
        saver: this.Editor.SaverAPI.methods,
        selection: this.Editor.SelectionAPI.methods,
        styles: this.Editor.StylesAPI.classes,
        toolbar: this.Editor.ToolbarAPI.methods,
        inlineToolbar: this.Editor.InlineToolbarAPI.methods,
        tooltip: this.Editor.TooltipAPI.methods,
        i18n: this.Editor.I18nAPI.methods,
        readOnly: this.Editor.ReadOnlyAPI.methods,
        ui: this.Editor.UiAPI.methods
      };
    }
    /**
     * Returns Editor.js Core API methods for passed tool
     *
     * @param toolName - tool name
     * @param isTune - is tool a block tune
     */

  }, {
    key: "getMethodsForTool",
    value: function getMethodsForTool(e, t) {
      return Object.assign(this.methods, {
        i18n: this.Editor.I18nAPI.getMethodsForTool(e, t)
      });
    }
  }]);

  return ki;
}(E);

var yi = /*#__PURE__*/function (_E6) {
  _inherits(yi, _E6);

  var _super8 = _createSuper(yi);

  function yi() {
    _classCallCheck(this, yi);

    return _super8.apply(this, arguments);
  }

  _createClass(yi, [{
    key: "methods",
    get:
    /**
     * Available methods
     *
     * @returns {InlineToolbar}
     */
    function get() {
      var _this16 = this;

      return {
        close: function close() {
          return _this16.close();
        },
        open: function open() {
          return _this16.open();
        }
      };
    }
    /**
     * Open Inline Toolbar
     */

  }, {
    key: "open",
    value: function open() {
      this.Editor.InlineToolbar.tryToShow();
    }
    /**
     * Close Inline Toolbar
     */

  }, {
    key: "close",
    value: function close() {
      this.Editor.InlineToolbar.close();
    }
  }]);

  return yi;
}(E);

var wi = /*#__PURE__*/function (_E7) {
  _inherits(wi, _E7);

  var _super9 = _createSuper(wi);

  function wi() {
    _classCallCheck(this, wi);

    return _super9.apply(this, arguments);
  }

  _createClass(wi, [{
    key: "methods",
    get:
    /**
     * Available methods
     *
     * @returns {Listeners}
     */
    function get() {
      var _this17 = this;

      return {
        on: function on(e, t, o, i) {
          return _this17.on(e, t, o, i);
        },
        off: function off(e, t, o, i) {
          return _this17.off(e, t, o, i);
        },
        offById: function offById(e) {
          return _this17.offById(e);
        }
      };
    }
    /**
     * Ads a DOM event listener. Return it's id.
     *
     * @param {HTMLElement} element - Element to set handler to
     * @param {string} eventType - event type
     * @param {() => void} handler - event handler
     * @param {boolean} useCapture - capture event or not
     */

  }, {
    key: "on",
    value: function on(e, t, o, i) {
      return this.listeners.on(e, t, o, i);
    }
    /**
     * Removes DOM listener from element
     *
     * @param {Element} element - Element to remove handler from
     * @param eventType - event type
     * @param handler - event handler
     * @param {boolean} useCapture - capture event or not
     */

  }, {
    key: "off",
    value: function off(e, t, o, i) {
      this.listeners.off(e, t, o, i);
    }
    /**
     * Removes DOM listener by the listener id
     *
     * @param id - id of the listener to remove
     */

  }, {
    key: "offById",
    value: function offById(e) {
      this.listeners.offById(e);
    }
  }]);

  return wi;
}(E);

var Ko = {
  exports: {}
};

(function (n, e) {
  (function (t, o) {
    n.exports = o();
  })(window, function () {
    return function (t) {
      var o = {};

      function i(s) {
        if (o[s]) return o[s].exports;
        var r = o[s] = {
          i: s,
          l: !1,
          exports: {}
        };
        return t[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
      }

      return i.m = t, i.c = o, i.d = function (s, r, a) {
        i.o(s, r) || Object.defineProperty(s, r, {
          enumerable: !0,
          get: a
        });
      }, i.r = function (s) {
        (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(s, "__esModule", {
          value: !0
        });
      }, i.t = function (s, r) {
        if (1 & r && (s = i(s)), 8 & r || 4 & r && _typeof(s) == "object" && s && s.__esModule) return s;
        var a = /* @__PURE__ */Object.create(null);
        if (i.r(a), Object.defineProperty(a, "default", {
          enumerable: !0,
          value: s
        }), 2 & r && typeof s != "string") for (var l in s) {
          i.d(a, l, function (c) {
            return s[c];
          }.bind(null, l));
        }
        return a;
      }, i.n = function (s) {
        var r = s && s.__esModule ? function () {
          return s.default;
        } : function () {
          return s;
        };
        return i.d(r, "a", r), r;
      }, i.o = function (s, r) {
        return Object.prototype.hasOwnProperty.call(s, r);
      }, i.p = "/", i(i.s = 0);
    }([function (t, o, i) {
      i(1),
      /*!
      * Codex JavaScript Notification module
      * https://github.com/codex-team/js-notifier
      */
      t.exports = function () {
        var s = i(6),
            r = "cdx-notify--bounce-in",
            a = null;
        return {
          show: function show(l) {
            if (l.message) {
              (function () {
                if (a) return !0;
                a = s.getWrapper(), document.body.appendChild(a);
              })();

              var c = null,
                  d = l.time || 8e3;

              switch (l.type) {
                case "confirm":
                  c = s.confirm(l);
                  break;

                case "prompt":
                  c = s.prompt(l);
                  break;

                default:
                  c = s.alert(l), window.setTimeout(function () {
                    c.remove();
                  }, d);
              }

              a.appendChild(c), c.classList.add(r);
            }
          }
        };
      }();
    }, function (t, o, i) {
      var s = i(2);
      typeof s == "string" && (s = [[t.i, s, ""]]);
      var r = {
        hmr: !0,
        transform: void 0,
        insertInto: void 0
      };
      i(4)(s, r), s.locals && (t.exports = s.locals);
    }, function (t, o, i) {
      (t.exports = i(3)(!1)).push([t.i, ".cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}", ""]);
    }, function (t, o) {
      t.exports = function (i) {
        var s = [];
        return s.toString = function () {
          return this.map(function (r) {
            var a = function (l, c) {
              var d = l[1] || "",
                  h = l[3];
              if (!h) return d;

              if (c && typeof btoa == "function") {
                var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"),
                    g = h.sources.map(function (v) {
                  return "/*# sourceURL=" + h.sourceRoot + v + " */";
                });
                return [d].concat(g).concat([p]).join("\n");
              }

              var f;
              return [d].join("\n");
            }(r, i);

            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
          }).join("");
        }, s.i = function (r, a) {
          typeof r == "string" && (r = [[null, r, ""]]);

          for (var l = {}, c = 0; c < this.length; c++) {
            var d = this[c][0];
            typeof d == "number" && (l[d] = !0);
          }

          for (c = 0; c < r.length; c++) {
            var h = r[c];
            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
          }
        }, s;
      };
    }, function (t, o, i) {
      var s,
          r,
          a = {},
          l = (s = function s() {
        return window && document && document.all && !window.atob;
      }, function () {
        return r === void 0 && (r = s.apply(this, arguments)), r;
      }),
          c = function (k) {
        var m = {};
        return function (w) {
          if (typeof w == "function") return w();

          if (m[w] === void 0) {
            var x = function (I) {
              return document.querySelector(I);
            }.call(this, w);

            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
              x = x.contentDocument.head;
            } catch (_unused3) {
              x = null;
            }
            m[w] = x;
          }

          return m[w];
        };
      }(),
          d = null,
          h = 0,
          p = [],
          g = i(5);

      function f(k, m) {
        for (var w = 0; w < k.length; w++) {
          var x = k[w],
              I = a[x.id];

          if (I) {
            I.refs++;

            for (var C = 0; C < I.parts.length; C++) {
              I.parts[C](x.parts[C]);
            }

            for (; C < x.parts.length; C++) {
              I.parts.push(F(x.parts[C], m));
            }
          } else {
            var N = [];

            for (C = 0; C < x.parts.length; C++) {
              N.push(F(x.parts[C], m));
            }

            a[x.id] = {
              id: x.id,
              refs: 1,
              parts: N
            };
          }
        }
      }

      function v(k, m) {
        for (var w = [], x = {}, I = 0; I < k.length; I++) {
          var C = k[I],
              N = m.base ? C[0] + m.base : C[0],
              B = {
            css: C[1],
            media: C[2],
            sourceMap: C[3]
          };
          x[N] ? x[N].parts.push(B) : w.push(x[N] = {
            id: N,
            parts: [B]
          });
        }

        return w;
      }

      function O(k, m) {
        var w = c(k.insertInto);
        if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
        var x = p[p.length - 1];
        if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);else if (k.insertAt === "bottom") w.appendChild(m);else {
          if (_typeof(k.insertAt) != "object" || !k.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
          var I = c(k.insertInto + " " + k.insertAt.before);
          w.insertBefore(m, I);
        }
      }

      function T(k) {
        if (k.parentNode === null) return !1;
        k.parentNode.removeChild(k);
        var m = p.indexOf(k);
        m >= 0 && p.splice(m, 1);
      }

      function M(k) {
        var m = document.createElement("style");
        return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
      }

      function q(k, m) {
        Object.keys(m).forEach(function (w) {
          k.setAttribute(w, m[w]);
        });
      }

      function F(k, m) {
        var w, x, I, C;

        if (m.transform && k.css) {
          if (!(C = m.transform(k.css))) return function () {};
          k.css = C;
        }

        if (m.singleton) {
          var N = h++;
          w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
        } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function (B) {
          var W = document.createElement("link");
          return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
        }(m), x = function (B, W, ve) {
          var se = ve.css,
              tt = ve.sourceMap,
              Yn = W.convertToAbsoluteUrls === void 0 && tt;
          (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
          var Kn = new Blob([se], {
            type: "text/css"
          }),
              ko = B.href;
          B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
        }.bind(null, w, m), I = function I() {
          T(w), w.href && URL.revokeObjectURL(w.href);
        }) : (w = M(m), x = function (B, W) {
          var ve = W.css,
              se = W.media;
          if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;else {
            for (; B.firstChild;) {
              B.removeChild(B.firstChild);
            }

            B.appendChild(document.createTextNode(ve));
          }
        }.bind(null, w), I = function I() {
          T(w);
        });

        return x(k), function (B) {
          if (B) {
            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
            x(k = B);
          } else I();
        };
      }

      t.exports = function (k, m) {
        if ((typeof DEBUG === "undefined" ? "undefined" : _typeof(DEBUG)) < "u" && DEBUG && (typeof document === "undefined" ? "undefined" : _typeof(document)) != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
        (m = m || {}).attrs = _typeof(m.attrs) == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
        var w = v(k, m);
        return f(w, m), function (x) {
          for (var I = [], C = 0; C < w.length; C++) {
            var N = w[C];
            (B = a[N.id]).refs--, I.push(B);
          }

          for (x && f(v(x, m), m), C = 0; C < I.length; C++) {
            var B;

            if ((B = I[C]).refs === 0) {
              for (var W = 0; W < B.parts.length; W++) {
                B.parts[W]();
              }

              delete a[B.id];
            }
          }
        };
      };

      var H,
          Q = (H = [], function (k, m) {
        return H[k] = m, H.filter(Boolean).join("\n");
      });

      function ie(k, m, w, x) {
        var I = w ? "" : x.css;
        if (k.styleSheet) k.styleSheet.cssText = Q(m, I);else {
          var C = document.createTextNode(I),
              N = k.childNodes;
          N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
        }
      }
    }, function (t, o) {
      t.exports = function (i) {
        var s = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.location;
        if (!s) throw new Error("fixUrls requires window.location");
        if (!i || typeof i != "string") return i;
        var r = s.protocol + "//" + s.host,
            a = r + s.pathname.replace(/\/[^\/]*$/, "/");
        return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (l, c) {
          var d,
              h = c.trim().replace(/^"(.*)"$/, function (p, g) {
            return g;
          }).replace(/^'(.*)'$/, function (p, g) {
            return g;
          });
          return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
        });
      };
    }, function (t, o, i) {
      var s, r, a, l, c, d, h, p, g;
      t.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
        alert: g = function g(f) {
          var v = document.createElement("DIV"),
              O = document.createElement("DIV"),
              T = f.message,
              M = f.style;
          return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
        },
        confirm: function confirm(f) {
          var v = g(f),
              O = document.createElement("div"),
              T = document.createElement("button"),
              M = document.createElement("button"),
              q = v.querySelector("." + a),
              F = f.cancelHandler,
              H = f.okHandler;
          return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
        },
        prompt: function prompt(f) {
          var v = g(f),
              O = document.createElement("div"),
              T = document.createElement("button"),
              M = document.createElement("input"),
              q = v.querySelector("." + a),
              F = f.cancelHandler,
              H = f.okHandler;
          return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function () {
            H(M.value);
          }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
        },
        getWrapper: function getWrapper() {
          var f = document.createElement("DIV");
          return f.classList.add(s), f;
        }
      });
    }]);
  });
})(Ko);

var Ei = Ko.exports;
var xi = /* @__PURE__ */Ke(Ei);

var Bi = /*#__PURE__*/function () {
  function Bi() {
    _classCallCheck(this, Bi);
  }

  _createClass(Bi, [{
    key: "show",
    value:
    /**
     * Show web notification
     *
     * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
     */
    function show(e) {
      xi.show(e);
    }
  }]);

  return Bi;
}();

var Ci = /*#__PURE__*/function (_E8) {
  _inherits(Ci, _E8);

  var _super10 = _createSuper(Ci);

  /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */
  function Ci(_ref14) {
    var _this18;

    var e = _ref14.config,
        t = _ref14.eventsDispatcher;

    _classCallCheck(this, Ci);

    _this18 = _super10.call(this, {
      config: e,
      eventsDispatcher: t
    }), _this18.notifier = new Bi();
    return _this18;
  }
  /**
   * Available methods
   */


  _createClass(Ci, [{
    key: "methods",
    get: function get() {
      var _this19 = this;

      return {
        show: function show(e) {
          return _this19.show(e);
        }
      };
    }
    /**
     * Show notification
     *
     * @param {NotifierOptions} options - message option
     */

  }, {
    key: "show",
    value: function show(e) {
      return this.notifier.show(e);
    }
  }]);

  return Ci;
}(E);

var Ti = /*#__PURE__*/function (_E9) {
  _inherits(Ti, _E9);

  var _super11 = _createSuper(Ti);

  function Ti() {
    _classCallCheck(this, Ti);

    return _super11.apply(this, arguments);
  }

  _createClass(Ti, [{
    key: "methods",
    get:
    /**
     * Available methods
     */
    function get() {
      var _this20 = this;

      var e = function e() {
        return _this20.isEnabled;
      };

      return {
        toggle: function toggle(t) {
          return _this20.toggle(t);
        },

        get isEnabled() {
          return e();
        }

      };
    }
    /**
     * Set or toggle read-only state
     *
     * @param {boolean|undefined} state - set or toggle state
     * @returns {boolean} current value
     */

  }, {
    key: "toggle",
    value: function toggle(e) {
      return this.Editor.ReadOnly.toggle(e);
    }
    /**
     * Returns current read-only state
     */

  }, {
    key: "isEnabled",
    get: function get() {
      return this.Editor.ReadOnly.isEnabled;
    }
  }]);

  return Ti;
}(E);

var Xo = {
  exports: {}
};

(function (n, e) {
  (function (t, o) {
    n.exports = o();
  })(Ce, function () {
    function t(h) {
      var p = h.tags,
          g = Object.keys(p),
          f = g.map(function (v) {
        return _typeof(p[v]);
      }).every(function (v) {
        return v === "object" || v === "boolean" || v === "function";
      });
      if (!f) throw new Error("The configuration was invalid");
      this.config = h;
    }

    var o = ["P", "LI", "TD", "TH", "DIV", "H1", "H2", "H3", "H4", "H5", "H6", "PRE"];

    function i(h) {
      return o.indexOf(h.nodeName) !== -1;
    }

    var s = ["A", "B", "STRONG", "I", "EM", "SUB", "SUP", "U", "STRIKE"];

    function r(h) {
      return s.indexOf(h.nodeName) !== -1;
    }

    t.prototype.clean = function (h) {
      var p = document.implementation.createHTMLDocument(),
          g = p.createElement("div");
      return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
    }, t.prototype._sanitize = function (h, p) {
      var g = a(h, p),
          f = g.firstChild();
      if (f) do {
        if (f.nodeType === Node.TEXT_NODE) if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
          p.removeChild(f), this._sanitize(h, p);
          break;
        } else continue;

        if (f.nodeType === Node.COMMENT_NODE) {
          p.removeChild(f), this._sanitize(h, p);
          break;
        }

        var v = r(f),
            O;
        v && (O = Array.prototype.some.call(f.childNodes, i));
        var T = !!p.parentNode,
            M = i(p) && i(f) && T,
            q = f.nodeName.toLowerCase(),
            F = l(this.config, q, f),
            H = v && O;

        if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
          if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for (; f.childNodes.length > 0;) {
            p.insertBefore(f.childNodes[0], f);
          }
          p.removeChild(f), this._sanitize(h, p);
          break;
        }

        for (var Q = 0; Q < f.attributes.length; Q += 1) {
          var ie = f.attributes[Q];
          d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
        }

        this._sanitize(h, f);
      } while (f = g.nextSibling());
    };

    function a(h, p) {
      return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
    }

    function l(h, p, g) {
      return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
    }

    function c(h, p) {
      return _typeof(p) > "u" ? !0 : typeof p == "boolean" ? !p : !1;
    }

    function d(h, p, g) {
      var f = h.name.toLowerCase();
      return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : _typeof(p[f]) > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
    }

    return t;
  });
})(Xo);

var Si = Xo.exports;
var Ii = /* @__PURE__ */Ke(Si);

function yt(n, e) {
  return n.map(function (t) {
    var o = A(e) ? e(t.tool) : e;
    return V(o) || (t.data = wt(t.data, o)), t;
  });
}

function Z(n) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var t = {
    tags: e
  };
  return new Ii(t).clean(n);
}

function wt(n, e) {
  return Array.isArray(n) ? Oi(n, e) : D(n) ? _i(n, e) : te(n) ? Mi(n, e) : n;
}

function Oi(n, e) {
  return n.map(function (t) {
    return wt(t, e);
  });
}

function _i(n, e) {
  var t = {};

  for (var o in n) {
    if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
    var i = n[o],
        s = Ai(e[o]) ? e[o] : e;
    t[o] = wt(i, s);
  }

  return t;
}

function Mi(n, e) {
  return D(e) ? Z(n, e) : e === !1 ? Z(n, {}) : n;
}

function Ai(n) {
  return D(n) || Gn(n) || A(n);
}

var Li = /*#__PURE__*/function (_E10) {
  _inherits(Li, _E10);

  var _super12 = _createSuper(Li);

  function Li() {
    _classCallCheck(this, Li);

    return _super12.apply(this, arguments);
  }

  _createClass(Li, [{
    key: "methods",
    get:
    /**
     * Available methods
     *
     * @returns {SanitizerConfig}
     */
    function get() {
      var _this21 = this;

      return {
        clean: function clean(e, t) {
          return _this21.clean(e, t);
        }
      };
    }
    /**
     * Perform sanitizing of a string
     *
     * @param {string} taintString - what to sanitize
     * @param {SanitizerConfig} config - sanitizer config
     * @returns {string}
     */

  }, {
    key: "clean",
    value: function clean(e, t) {
      return Z(e, t);
    }
  }]);

  return Li;
}(E);

var Pi = /*#__PURE__*/function (_E11) {
  _inherits(Pi, _E11);

  var _super13 = _createSuper(Pi);

  function Pi() {
    _classCallCheck(this, Pi);

    return _super13.apply(this, arguments);
  }

  _createClass(Pi, [{
    key: "methods",
    get:
    /**
     * Available methods
     *
     * @returns {Saver}
     */
    function get() {
      var _this22 = this;

      return {
        save: function save() {
          return _this22.save();
        }
      };
    }
    /**
     * Return Editor's data
     *
     * @returns {OutputData}
     */

  }, {
    key: "save",
    value: function save() {
      var e = "Editor's content can not be saved in read-only mode";
      return this.Editor.ReadOnly.isEnabled ? (X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
  }]);

  return Pi;
}(E);

var Ni = /*#__PURE__*/function (_E12) {
  _inherits(Ni, _E12);

  var _super14 = _createSuper(Ni);

  function Ni() {
    var _this23;

    _classCallCheck(this, Ni);

    _this23 = _super14.apply(this, arguments), _this23.selectionUtils = new b();
    return _this23;
  }
  /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */


  _createClass(Ni, [{
    key: "methods",
    get: function get() {
      var _this24 = this;

      return {
        findParentTag: function findParentTag(e, t) {
          return _this24.findParentTag(e, t);
        },
        expandToTag: function expandToTag(e) {
          return _this24.expandToTag(e);
        },
        save: function save() {
          return _this24.selectionUtils.save();
        },
        restore: function restore() {
          return _this24.selectionUtils.restore();
        },
        setFakeBackground: function setFakeBackground() {
          return _this24.selectionUtils.setFakeBackground();
        },
        removeFakeBackground: function removeFakeBackground() {
          return _this24.selectionUtils.removeFakeBackground();
        }
      };
    }
    /**
     * Looks ahead from selection and find passed tag with class name
     *
     * @param {string} tagName - tag to find
     * @param {string} className - tag's class name
     * @returns {HTMLElement|null}
     */

  }, {
    key: "findParentTag",
    value: function findParentTag(e, t) {
      return this.selectionUtils.findParentTag(e, t);
    }
    /**
     * Expand selection to passed tag
     *
     * @param {HTMLElement} node - tag that should contain selection
     */

  }, {
    key: "expandToTag",
    value: function expandToTag(e) {
      this.selectionUtils.expandToTag(e);
    }
  }]);

  return Ni;
}(E);

var Ri = /*#__PURE__*/function (_E13) {
  _inherits(Ri, _E13);

  var _super15 = _createSuper(Ri);

  function Ri() {
    _classCallCheck(this, Ri);

    return _super15.apply(this, arguments);
  }

  _createClass(Ri, [{
    key: "methods",
    get:
    /**
     * Available methods
     */
    function get() {
      var _this25 = this;

      return {
        getBlockTools: function getBlockTools() {
          return Array.from(_this25.Editor.Tools.blockTools.values());
        }
      };
    }
  }]);

  return Ri;
}(E);

var Di = /*#__PURE__*/function (_E14) {
  _inherits(Di, _E14);

  var _super16 = _createSuper(Di);

  function Di() {
    _classCallCheck(this, Di);

    return _super16.apply(this, arguments);
  }

  _createClass(Di, [{
    key: "classes",
    get:
    /**
     * Exported classes
     */
    function get() {
      return {
        /**
         * Base Block styles
         */
        block: "cdx-block",

        /**
         * Inline Tools styles
         */
        inlineToolButton: "ce-inline-tool",
        inlineToolButtonActive: "ce-inline-tool--active",

        /**
         * UI elements
         */
        input: "cdx-input",
        loader: "cdx-loader",
        button: "cdx-button",

        /**
         * Settings styles
         */
        settingsButton: "cdx-settings-button",
        settingsButtonActive: "cdx-settings-button--active"
      };
    }
  }]);

  return Di;
}(E);

var Fi = /*#__PURE__*/function (_E15) {
  _inherits(Fi, _E15);

  var _super17 = _createSuper(Fi);

  function Fi() {
    _classCallCheck(this, Fi);

    return _super17.apply(this, arguments);
  }

  _createClass(Fi, [{
    key: "methods",
    get:
    /**
     * Available methods
     *
     * @returns {Toolbar}
     */
    function get() {
      var _this26 = this;

      return {
        close: function close() {
          return _this26.close();
        },
        open: function open() {
          return _this26.open();
        },
        toggleBlockSettings: function toggleBlockSettings(e) {
          return _this26.toggleBlockSettings(e);
        },
        toggleToolbox: function toggleToolbox(e) {
          return _this26.toggleToolbox(e);
        }
      };
    }
    /**
     * Open toolbar
     */

  }, {
    key: "open",
    value: function open() {
      this.Editor.Toolbar.moveAndOpen();
    }
    /**
     * Close toolbar and all included elements
     */

  }, {
    key: "close",
    value: function close() {
      this.Editor.Toolbar.close();
    }
    /**
     * Toggles Block Setting of the current block
     *
     * @param {boolean} openingState —  opening state of Block Setting
     */

  }, {
    key: "toggleBlockSettings",
    value: function toggleBlockSettings(e) {
      if (this.Editor.BlockManager.currentBlockIndex === -1) {
        X("Could't toggle the Toolbar because there is no block selected ", "warn");
        return;
      }

      (e !== null && e !== void 0 ? e : !this.Editor.BlockSettings.opened) ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
     * Open toolbox
     *
     * @param {boolean} openingState - Opening state of toolbox
     */

  }, {
    key: "toggleToolbox",
    value: function toggleToolbox(e) {
      if (this.Editor.BlockManager.currentBlockIndex === -1) {
        X("Could't toggle the Toolbox because there is no block selected ", "warn");
        return;
      }

      (e !== null && e !== void 0 ? e : !this.Editor.Toolbar.toolbox.opened) ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
  }]);

  return Fi;
}(E);

var Vo = {
  exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */

(function (n, e) {
  (function (t, o) {
    n.exports = o();
  })(window, function () {
    return function (t) {
      var o = {};

      function i(s) {
        if (o[s]) return o[s].exports;
        var r = o[s] = {
          i: s,
          l: !1,
          exports: {}
        };
        return t[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
      }

      return i.m = t, i.c = o, i.d = function (s, r, a) {
        i.o(s, r) || Object.defineProperty(s, r, {
          enumerable: !0,
          get: a
        });
      }, i.r = function (s) {
        (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(s, "__esModule", {
          value: !0
        });
      }, i.t = function (s, r) {
        if (1 & r && (s = i(s)), 8 & r || 4 & r && _typeof(s) == "object" && s && s.__esModule) return s;
        var a = /* @__PURE__ */Object.create(null);
        if (i.r(a), Object.defineProperty(a, "default", {
          enumerable: !0,
          value: s
        }), 2 & r && typeof s != "string") for (var l in s) {
          i.d(a, l, function (c) {
            return s[c];
          }.bind(null, l));
        }
        return a;
      }, i.n = function (s) {
        var r = s && s.__esModule ? function () {
          return s.default;
        } : function () {
          return s;
        };
        return i.d(r, "a", r), r;
      }, i.o = function (s, r) {
        return Object.prototype.hasOwnProperty.call(s, r);
      }, i.p = "", i(i.s = 0);
    }([function (t, o, i) {
      t.exports = i(1);
    }, function (t, o, i) {
      i.r(o), i.d(o, "default", function () {
        return s;
      });

      var s = /*#__PURE__*/function () {
        function s() {
          var _this27 = this;

          _classCallCheck(this, s);

          this.nodes = {
            wrapper: null,
            content: null
          }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = function () {
            _this27.showed && _this27.hide(!0);
          }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
            passive: !0
          });
        }

        _createClass(s, [{
          key: "CSS",
          get: function get() {
            return {
              tooltip: "ct",
              tooltipContent: "ct__content",
              tooltipShown: "ct--shown",
              placement: {
                left: "ct--left",
                bottom: "ct--bottom",
                right: "ct--right",
                top: "ct--top"
              }
            };
          }
        }, {
          key: "show",
          value: function show(a, l, c) {
            var _this$nodes$wrapper$c,
                _this28 = this;

            this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
            var d = Object.assign({
              placement: "bottom",
              marginTop: 0,
              marginLeft: 0,
              marginRight: 0,
              marginBottom: 0,
              delay: 70,
              hidingDelay: 0
            }, c);
            if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));else {
              if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of «content» passed. It should be an instance of Node or String. But " + _typeof(l) + " given.");
              this.nodes.content.appendChild(l);
            }

            switch ((_this$nodes$wrapper$c = this.nodes.wrapper.classList).remove.apply(_this$nodes$wrapper$c, _toConsumableArray(Object.values(this.CSS.placement))), d.placement) {
              case "top":
                this.placeTop(a, d);
                break;

              case "left":
                this.placeLeft(a, d);
                break;

              case "right":
                this.placeRight(a, d);
                break;

              case "bottom":
              default:
                this.placeBottom(a, d);
            }

            d && d.delay ? this.showingTimeout = setTimeout(function () {
              _this28.nodes.wrapper.classList.add(_this28.CSS.tooltipShown), _this28.showed = !0;
            }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
          }
        }, {
          key: "hide",
          value: function hide() {
            var _this29 = this;

            var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(function () {
              _this29.hide(!0);
            }, this.hidingDelay));
            this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
          }
        }, {
          key: "onHover",
          value: function onHover(a, l, c) {
            var _this30 = this;

            a.addEventListener("mouseenter", function () {
              _this30.show(a, l, c);
            }), a.addEventListener("mouseleave", function () {
              _this30.hide();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
          }
        }, {
          key: "prepare",
          value: function prepare() {
            this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
          }
        }, {
          key: "loadStyles",
          value: function loadStyles() {
            var a = "codex-tooltips-style";
            if (document.getElementById(a)) return;
            var l = i(2),
                c = this.make("style", null, {
              textContent: l.toString(),
              id: a
            });
            this.prepend(document.head, c);
          }
        }, {
          key: "placeBottom",
          value: function placeBottom(a, l) {
            var c = a.getBoundingClientRect(),
                d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2,
                h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
            this.applyPlacement("bottom", d, h);
          }
        }, {
          key: "placeTop",
          value: function placeTop(a, l) {
            var c = a.getBoundingClientRect(),
                d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2,
                h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
            this.applyPlacement("top", d, h);
          }
        }, {
          key: "placeLeft",
          value: function placeLeft(a, l) {
            var c = a.getBoundingClientRect(),
                d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft,
                h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
            this.applyPlacement("left", d, h);
          }
        }, {
          key: "placeRight",
          value: function placeRight(a, l) {
            var c = a.getBoundingClientRect(),
                d = c.right + this.offsetRight + l.marginRight,
                h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
            this.applyPlacement("right", d, h);
          }
        }, {
          key: "applyPlacement",
          value: function applyPlacement(a, l, c) {
            this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
          }
        }, {
          key: "make",
          value: function make(a) {
            var _d$classList;

            var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var d = document.createElement(a);
            Array.isArray(l) ? (_d$classList = d.classList).add.apply(_d$classList, _toConsumableArray(l)) : l && d.classList.add(l);

            for (var h in c) {
              c.hasOwnProperty(h) && (d[h] = c[h]);
            }

            return d;
          }
        }, {
          key: "append",
          value: function append(a, l) {
            Array.isArray(l) ? l.forEach(function (c) {
              return a.appendChild(c);
            }) : a.appendChild(l);
          }
        }, {
          key: "prepend",
          value: function prepend(a, l) {
            Array.isArray(l) ? (l = l.reverse()).forEach(function (c) {
              return a.prepend(c);
            }) : a.prepend(l);
          }
        }]);

        return s;
      }();
    }, function (t, o) {
      t.exports = ".ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:\"\";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url(\"\")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path d=\"M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z\"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:\"\";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}";
    }]).default;
  });
})(Vo);

var ji = Vo.exports;
var Hi = /* @__PURE__ */Ke(ji);
var U = null;

function Et() {
  U || (U = new Hi());
}

function $i(n, e, t) {
  Et(), U == null || U.show(n, e, t);
}

function $e() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  Et(), U == null || U.hide(n);
}

function ze(n, e, t) {
  Et(), U == null || U.onHover(n, e, t);
}

function zi() {
  U == null || U.destroy(), U = null;
}

var Ui = /*#__PURE__*/function (_E16) {
  _inherits(Ui, _E16);

  var _super18 = _createSuper(Ui);

  /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */
  function Ui(_ref15) {
    var e = _ref15.config,
        t = _ref15.eventsDispatcher;

    _classCallCheck(this, Ui);

    return _super18.call(this, {
      config: e,
      eventsDispatcher: t
    });
  }
  /**
   * Available methods
   */


  _createClass(Ui, [{
    key: "methods",
    get: function get() {
      var _this31 = this;

      return {
        show: function show(e, t, o) {
          return _this31.show(e, t, o);
        },
        hide: function hide() {
          return _this31.hide();
        },
        onHover: function onHover(e, t, o) {
          return _this31.onHover(e, t, o);
        }
      };
    }
    /**
     * Method show tooltip on element with passed HTML content
     *
     * @param {HTMLElement} element - element on which tooltip should be shown
     * @param {TooltipContent} content - tooltip content
     * @param {TooltipOptions} options - tooltip options
     */

  }, {
    key: "show",
    value: function show(e, t, o) {
      $i(e, t, o);
    }
    /**
     * Method hides tooltip on HTML page
     */

  }, {
    key: "hide",
    value: function hide() {
      $e();
    }
    /**
     * Decorator for showing Tooltip by mouseenter/mouseleave
     *
     * @param {HTMLElement} element - element on which tooltip should be shown
     * @param {TooltipContent} content - tooltip content
     * @param {TooltipOptions} options - tooltip options
     */

  }, {
    key: "onHover",
    value: function onHover(e, t, o) {
      ze(e, t, o);
    }
  }]);

  return Ui;
}(E);

var Wi = /*#__PURE__*/function (_E17) {
  _inherits(Wi, _E17);

  var _super19 = _createSuper(Wi);

  function Wi() {
    _classCallCheck(this, Wi);

    return _super19.apply(this, arguments);
  }

  _createClass(Wi, [{
    key: "methods",
    get:
    /**
     * Available methods / getters
     */
    function get() {
      return {
        nodes: this.editorNodes
        /**
         * There can be added some UI methods, like toggleThinMode() etc
         */

      };
    }
    /**
     * Exported classes
     */

  }, {
    key: "editorNodes",
    get: function get() {
      return {
        /**
         * Top-level editor instance wrapper
         */
        wrapper: this.Editor.UI.nodes.wrapper,

        /**
         * Element that holds all the Blocks
         */
        redactor: this.Editor.UI.nodes.redactor
      };
    }
  }]);

  return Wi;
}(E);

function qo(n, e) {
  var t = {};
  return Object.entries(n).forEach(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
        o = _ref17[0],
        i = _ref17[1];

    if (D(i)) {
      var s = e ? "".concat(e, ".").concat(o) : o;
      Object.values(i).every(function (a) {
        return te(a);
      }) ? t[o] = s : t[o] = qo(i, s);
      return;
    }

    t[o] = i;
  }), t;
}

var K = qo(Fo);

function Yi(n, e) {
  var t = {};
  return Object.keys(n).forEach(function (o) {
    var i = e[o];
    i !== void 0 ? t[i] = n[o] : t[o] = n[o];
  }), t;
}

var Zo = /*#__PURE__*/function () {
  /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */
  function Ee(e, t) {
    _classCallCheck(this, Ee);

    this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t;
  }
  /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */


  _createClass(Ee, [{
    key: "currentItem",
    get: function get() {
      return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
     * Sets cursor to specified position
     *
     * @param cursorPosition - new cursor position
     */

  }, {
    key: "setCursor",
    value: function setCursor(e) {
      e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
     * Sets items. Can be used when iterable items changed dynamically
     *
     * @param {HTMLElement[]} nodeList - nodes to iterate
     */

  }, {
    key: "setItems",
    value: function setItems(e) {
      this.items = e;
    }
    /**
     * Sets cursor next to the current
     */

  }, {
    key: "next",
    value: function next() {
      this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
    }
    /**
     * Sets cursor before current
     */

  }, {
    key: "previous",
    value: function previous() {
      this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
    }
    /**
     * Sets cursor to the default position and removes CSS-class from previously focused item
     */

  }, {
    key: "dropCursor",
    value: function dropCursor() {
      this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
     * Leafs nodes inside the target list from active element
     *
     * @param {string} direction - leaf direction. Can be 'left' or 'right'
     * @returns {number} index of focused node
     */

  }, {
    key: "leafNodesAndReturnIndex",
    value: function leafNodesAndReturnIndex(e) {
      var _this32 = this;

      if (this.items.length === 0) return this.cursor;
      var t = this.cursor;
      return t === -1 ? t = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t = (t + 1) % this.items.length : t = (this.items.length + t - 1) % this.items.length, u.canSetCaret(this.items[t]) && Fe(function () {
        return b.setCursor(_this32.items[t]);
      }, 50)(), this.items[t].classList.add(this.focusedCssClass), t;
    }
  }]);

  return Ee;
}();

Zo.directions = {
  RIGHT: "right",
  LEFT: "left"
};
var ke = Zo;

var ce = /*#__PURE__*/function () {
  /**
   * @param options - different constructing settings
   */
  function ce(e) {
    var _this33 = this;

    _classCallCheck(this, ce);

    this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = function (t) {
      if (!(!_this33.isEventReadyForHandling(t) || t.shiftKey === !0)) switch (ce.usedKeys.includes(t.keyCode) && t.preventDefault(), t.keyCode) {
        case y.TAB:
          _this33.handleTabPress(t);

          break;

        case y.LEFT:
        case y.UP:
          _this33.flipLeft();

          break;

        case y.RIGHT:
        case y.DOWN:
          _this33.flipRight();

          break;

        case y.ENTER:
          _this33.handleEnterPress(t);

          break;
      }
    }, this.iterator = new ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || ce.usedKeys;
  }
  /**
   * True if flipper is currently activated
   */


  _createClass(ce, [{
    key: "isActivated",
    get: function get() {
      return this.activated;
    }
    /**
     * Array of keys (codes) that is handled by Flipper
     * Used to:
     *  - preventDefault only for this keys, not all keydowns (@see constructor)
     *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
     */

  }, {
    key: "activate",
    value:
    /**
     * Active tab/arrows handling by flipper
     *
     * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
     * @param cursorPosition - index of the item that should be focused once flipper is activated
     */
    function activate(e, t) {
      this.activated = !0, e && this.iterator.setItems(e), t !== void 0 && this.iterator.setCursor(t), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
     * Disable tab/arrows handling by flipper
     */

  }, {
    key: "deactivate",
    value: function deactivate() {
      this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
     * Focus first item
     */

  }, {
    key: "focusFirst",
    value: function focusFirst() {
      this.dropCursor(), this.flipRight();
    }
    /**
     * Focuses previous flipper iterator item
     */

  }, {
    key: "flipLeft",
    value: function flipLeft() {
      this.iterator.previous(), this.flipCallback();
    }
    /**
     * Focuses next flipper iterator item
     */

  }, {
    key: "flipRight",
    value: function flipRight() {
      this.iterator.next(), this.flipCallback();
    }
    /**
     * Return true if some button is focused
     */

  }, {
    key: "hasFocus",
    value: function hasFocus() {
      return !!this.iterator.currentItem;
    }
    /**
     * Registeres function that should be executed on each navigation action
     *
     * @param cb - function to execute
     */

  }, {
    key: "onFlip",
    value: function onFlip(e) {
      this.flipCallbacks.push(e);
    }
    /**
     * Unregisteres function that is executed on each navigation action
     *
     * @param cb - function to stop executing
     */

  }, {
    key: "removeOnFlip",
    value: function removeOnFlip(e) {
      this.flipCallbacks = this.flipCallbacks.filter(function (t) {
        return t !== e;
      });
    }
    /**
     * Drops flipper's iterator cursor
     *
     * @see DomIterator#dropCursor
     */

  }, {
    key: "dropCursor",
    value: function dropCursor() {
      this.iterator.dropCursor();
    }
    /**
     * This function is fired before handling flipper keycodes
     * The result of this function defines if it is need to be handled or not
     *
     * @param {KeyboardEvent} event - keydown keyboard event
     * @returns {boolean}
     */

  }, {
    key: "isEventReadyForHandling",
    value: function isEventReadyForHandling(e) {
      return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
     * When flipper is activated tab press will leaf the items
     *
     * @param {KeyboardEvent} event - tab keydown event
     */

  }, {
    key: "handleTabPress",
    value: function handleTabPress(e) {
      switch (e.shiftKey ? ke.directions.LEFT : ke.directions.RIGHT) {
        case ke.directions.RIGHT:
          this.flipRight();
          break;

        case ke.directions.LEFT:
          this.flipLeft();
          break;
      }
    }
    /**
     * Enter press will click current item if flipper is activated
     *
     * @param {KeyboardEvent} event - enter keydown event
     */

  }, {
    key: "handleEnterPress",
    value: function handleEnterPress(e) {
      this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
     * Fired after flipping in any direction
     */

  }, {
    key: "flipCallback",
    value: function flipCallback() {
      this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach(function (e) {
        return e();
      });
    }
  }], [{
    key: "usedKeys",
    get: function get() {
      return [y.TAB, y.LEFT, y.RIGHT, y.ENTER, y.UP, y.DOWN];
    }
  }]);

  return ce;
}();

var Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>',
    Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>',
    Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>',
    qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>',
    Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>',
    Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>',
    Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>',
    Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>',
    Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>',
    es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>',
    ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>',
    Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>',
    os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>',
    ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>',
    is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>',
    ss = "__",
    rs = "--";

function ne(n) {
  return function (e, t) {
    return [[n, e].filter(function (i) {
      return !!i;
    }).join(ss), t].filter(function (i) {
      return !!i;
    }).join(rs);
  };
}

var ye = ne("ce-hint"),
    we = {
  root: ye(),
  alignedStart: ye(null, "align-left"),
  alignedCenter: ye(null, "align-center"),
  title: ye("title"),
  description: ye("description")
};

var as = /*#__PURE__*/function () {
  /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */
  function as(e) {
    _classCallCheck(this, as);

    this.nodes = {
      root: u.make("div", [we.root, e.alignment === "center" ? we.alignedCenter : we.alignedStart]),
      title: u.make("div", we.title, {
        textContent: e.title
      })
    }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = u.make("div", we.description, {
      textContent: e.description
    }), this.nodes.root.appendChild(this.nodes.description));
  }
  /**
   * Returns the root element of the hint content
   */


  _createClass(as, [{
    key: "getElement",
    value: function getElement() {
      return this.nodes.root;
    }
  }]);

  return as;
}();

var xt = /*#__PURE__*/function () {
  /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */
  function xt(e) {
    _classCallCheck(this, xt);

    this.params = e;
  }
  /**
   * Item name if exists
   */


  _createClass(xt, [{
    key: "name",
    get: function get() {
      if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
     * Destroys the instance
     */

  }, {
    key: "destroy",
    value: function destroy() {
      $e();
    }
    /**
     * Called when children popover is opened (if exists)
     */

  }, {
    key: "onChildrenOpen",
    value: function onChildrenOpen() {
      var e;
      this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
     * Called when children popover is closed (if exists)
     */

  }, {
    key: "onChildrenClose",
    value: function onChildrenClose() {
      var e;
      this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
     * Called on popover item click
     */

  }, {
    key: "handleClick",
    value: function handleClick() {
      var e, t;
      this.params !== void 0 && "onActivate" in this.params && ((t = (e = this.params).onActivate) == null || t.call(e, this.params));
    }
    /**
     * Adds hint to the item element if hint data is provided
     *
     * @param itemElement - popover item root element to add hint to
     * @param hintData - hint data
     */

  }, {
    key: "addHint",
    value: function addHint(e, t) {
      var o = new as(t);
      ze(e, o.getElement(), {
        placement: t.position,
        hidingDelay: 100
      });
    }
    /**
     * Returns item children that are represented as popover items
     */

  }, {
    key: "children",
    get: function get() {
      var e;
      return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
     * Returns true if item has any type of children
     */

  }, {
    key: "hasChildren",
    get: function get() {
      return this.children.length > 0;
    }
    /**
     * Returns true if item children should be open instantly after popover is opened and not on item click/hover
     */

  }, {
    key: "isChildrenOpen",
    get: function get() {
      var e;
      return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
     * True if item children items should be navigatable via keyboard
     */

  }, {
    key: "isChildrenFlippable",
    get: function get() {
      var e;
      return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
     * Returns true if item has children that should be searchable
     */

  }, {
    key: "isChildrenSearchable",
    get: function get() {
      var e;
      return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
     * True if popover should close once item is activated
     */

  }, {
    key: "closeOnActivate",
    get: function get() {
      return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
     * True if item is active
     */

  }, {
    key: "isActive",
    get: function get() {
      return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
  }]);

  return xt;
}();

var Y = ne("ce-popover-item"),
    L = {
  container: Y(),
  active: Y(null, "active"),
  disabled: Y(null, "disabled"),
  focused: Y(null, "focused"),
  hidden: Y(null, "hidden"),
  confirmationState: Y(null, "confirmation"),
  noHover: Y(null, "no-hover"),
  noFocus: Y(null, "no-focus"),
  title: Y("title"),
  secondaryTitle: Y("secondary-title"),
  icon: Y("icon"),
  iconTool: Y("icon", "tool"),
  iconChevronRight: Y("icon", "chevron-right"),
  wobbleAnimation: ne("wobble")()
};

var re = /*#__PURE__*/function (_xt) {
  _inherits(re, _xt);

  var _super20 = _createSuper(re);

  /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */
  function re(e, t) {
    var _this34;

    _classCallCheck(this, re);

    _this34 = _super20.call(this, e), _this34.params = e, _this34.nodes = {
      root: null,
      icon: null
    }, _this34.confirmationState = null, _this34.removeSpecialFocusBehavior = function () {
      var o;
      (o = _this34.nodes.root) == null || o.classList.remove(L.noFocus);
    }, _this34.removeSpecialHoverBehavior = function () {
      var o;
      (o = _this34.nodes.root) == null || o.classList.remove(L.noHover);
    }, _this34.onErrorAnimationEnd = function () {
      var o, i;
      (o = _this34.nodes.icon) == null || o.classList.remove(L.wobbleAnimation), (i = _this34.nodes.icon) == null || i.removeEventListener("animationend", _this34.onErrorAnimationEnd);
    }, _this34.nodes.root = _this34.make(e, t);
    return _this34;
  }
  /**
   * True if item is disabled and hence not clickable
   */


  _createClass(re, [{
    key: "isDisabled",
    get: function get() {
      return this.params.isDisabled === !0;
    }
    /**
     * Exposes popover item toggle parameter
     */

  }, {
    key: "toggle",
    get: function get() {
      return this.params.toggle;
    }
    /**
     * Item title
     */

  }, {
    key: "title",
    get: function get() {
      return this.params.title;
    }
    /**
     * True if confirmation state is enabled for popover item
     */

  }, {
    key: "isConfirmationStateEnabled",
    get: function get() {
      return this.confirmationState !== null;
    }
    /**
     * True if item is focused in keyboard navigation process
     */

  }, {
    key: "isFocused",
    get: function get() {
      return this.nodes.root === null ? !1 : this.nodes.root.classList.contains(L.focused);
    }
    /**
     * Returns popover item root element
     */

  }, {
    key: "getElement",
    value: function getElement() {
      return this.nodes.root;
    }
    /**
     * Called on popover item click
     */

  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
        this.activateOrEnableConfirmationMode(this.confirmationState);
        return;
      }

      this.activateOrEnableConfirmationMode(this.params);
    }
    /**
     * Toggles item active state
     *
     * @param isActive - true if item should strictly should become active
     */

  }, {
    key: "toggleActive",
    value: function toggleActive(e) {
      var t;
      (t = this.nodes.root) == null || t.classList.toggle(L.active, e);
    }
    /**
     * Toggles item hidden state
     *
     * @param isHidden - true if item should be hidden
     */

  }, {
    key: "toggleHidden",
    value: function toggleHidden(e) {
      var t;
      (t = this.nodes.root) == null || t.classList.toggle(L.hidden, e);
    }
    /**
     * Resets popover item to its original state
     */

  }, {
    key: "reset",
    value: function reset() {
      this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
     * Method called once item becomes focused during keyboard navigation
     */

  }, {
    key: "onFocus",
    value: function onFocus() {
      this.disableSpecialHoverAndFocusBehavior();
    }
    /**
     * Constructs HTML element corresponding to popover item params
     *
     * @param params - item construction params
     * @param renderParams - popover item render params
     */

  }, {
    key: "make",
    value: function make(e, t) {
      var s, r;
      var o = (t == null ? void 0 : t.wrapperTag) || "div",
          i = u.make(o, L.container, {
        type: o === "button" ? "button" : void 0
      });
      return e.name && (i.dataset.itemName = e.name), this.nodes.icon = u.make("div", [L.icon, L.iconTool], {
        innerHTML: e.icon || Qi
      }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild(u.make("div", L.title, {
        innerHTML: e.title || ""
      })), e.secondaryLabel && i.appendChild(u.make("div", L.secondaryTitle, {
        textContent: e.secondaryLabel
      })), this.hasChildren && i.appendChild(u.make("div", [L.icon, L.iconChevronRight], {
        innerHTML: qi
      })), this.isActive && i.classList.add(L.active), e.isDisabled && i.classList.add(L.disabled), e.hint !== void 0 && ((s = t == null ? void 0 : t.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, _objectSpread(_objectSpread({}, e.hint), {}, {
        position: ((r = t == null ? void 0 : t.hint) == null ? void 0 : r.position) || "right"
      })), i;
    }
    /**
     * Activates confirmation mode for the item.
     *
     * @param newState - new popover item params that should be applied
     */

  }, {
    key: "enableConfirmationMode",
    value: function enableConfirmationMode(e) {
      if (this.nodes.root === null) return;

      var t = _objectSpread(_objectSpread(_objectSpread({}, this.params), e), {}, {
        confirmation: "confirmation" in e ? e.confirmation : void 0
      }),
          o = this.make(t);

      this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add(L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
     * Returns item to its original state
     */

  }, {
    key: "disableConfirmationMode",
    value: function disableConfirmationMode() {
      if (this.nodes.root === null) return;
      var e = this.make(this.params);
      this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove(L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
     * Enables special focus and hover behavior for item in confirmation state.
     * This is needed to prevent item from being highlighted as hovered/focused just after click.
     */

  }, {
    key: "enableSpecialHoverAndFocusBehavior",
    value: function enableSpecialHoverAndFocusBehavior() {
      var e, t, o;
      (e = this.nodes.root) == null || e.classList.add(L.noHover), (t = this.nodes.root) == null || t.classList.add(L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
        once: !0
      });
    }
    /**
     * Disables special focus and hover behavior
     */

  }, {
    key: "disableSpecialHoverAndFocusBehavior",
    value: function disableSpecialHoverAndFocusBehavior() {
      var e;
      this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
     * Executes item's onActivate callback if the item has no confirmation configured
     *
     * @param item - item to activate or bring to confirmation mode
     */

  }, {
    key: "activateOrEnableConfirmationMode",
    value: function activateOrEnableConfirmationMode(e) {
      var t;
      if (!("confirmation" in e) || e.confirmation === void 0) try {
        (t = e.onActivate) == null || t.call(e, e), this.disableConfirmationMode();
      } catch (_unused4) {
        this.animateError();
      } else this.enableConfirmationMode(e.confirmation);
    }
    /**
     * Animates item which symbolizes that error occured while executing 'onActivate()' callback
     */

  }, {
    key: "animateError",
    value: function animateError() {
      var e, t, o;
      (e = this.nodes.icon) != null && e.classList.contains(L.wobbleAnimation) || ((t = this.nodes.icon) == null || t.classList.add(L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
  }]);

  return re;
}(xt);

var nt = ne("ce-popover-item-separator"),
    it = {
  container: nt(),
  line: nt("line"),
  hidden: nt(null, "hidden")
};

var Qo = /*#__PURE__*/function (_xt2) {
  _inherits(Qo, _xt2);

  var _super21 = _createSuper(Qo);

  /**
   * Constructs the instance
   */
  function Qo() {
    var _this35;

    _classCallCheck(this, Qo);

    _this35 = _super21.call(this), _this35.nodes = {
      root: u.make("div", it.container),
      line: u.make("div", it.line)
    }, _this35.nodes.root.appendChild(_this35.nodes.line);
    return _this35;
  }
  /**
   * Returns popover separator root element
   */


  _createClass(Qo, [{
    key: "getElement",
    value: function getElement() {
      return this.nodes.root;
    }
    /**
     * Toggles item hidden state
     *
     * @param isHidden - true if item should be hidden
     */

  }, {
    key: "toggleHidden",
    value: function toggleHidden(e) {
      var t;
      (t = this.nodes.root) == null || t.classList.toggle(it.hidden, e);
    }
  }]);

  return Qo;
}(xt);

var G = /* @__PURE__ */function (n) {
  return n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n;
}(G || {});

var $ = ne("ce-popover"),
    P = {
  popover: $(),
  popoverContainer: $("container"),
  popoverOpenTop: $(null, "open-top"),
  popoverOpenLeft: $(null, "open-left"),
  popoverOpened: $(null, "opened"),
  search: $("search"),
  nothingFoundMessage: $("nothing-found-message"),
  nothingFoundMessageDisplayed: $("nothing-found-message", "displayed"),
  items: $("items"),
  overlay: $("overlay"),
  overlayHidden: $("overlay", "hidden"),
  popoverNested: $(null, "nested"),
  getPopoverNestedClass: function getPopoverNestedClass(n) {
    return $(null, "nested-level-".concat(n.toString()));
  },
  popoverInline: $(null, "inline"),
  popoverHeader: $("header")
};

var fe = /* @__PURE__ */function (n) {
  return n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n;
}(fe || {});

var To = ne("ce-popover-item-html"),
    So = {
  root: To(),
  hidden: To(null, "hidden")
};

var Se = /*#__PURE__*/function (_xt3) {
  _inherits(Se, _xt3);

  var _super22 = _createSuper(Se);

  /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */
  function Se(e, t) {
    var _this36;

    _classCallCheck(this, Se);

    var o, i;
    _this36 = _super22.call(this, e), _this36.nodes = {
      root: u.make("div", So.root)
    }, _this36.nodes.root.appendChild(e.element), e.name && (_this36.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t == null ? void 0 : t.hint) == null ? void 0 : o.enabled) !== !1 && _this36.addHint(_this36.nodes.root, _objectSpread(_objectSpread({}, e.hint), {}, {
      position: ((i = t == null ? void 0 : t.hint) == null ? void 0 : i.position) || "right"
    }));
    return _this36;
  }
  /**
   * Returns popover item root element
   */


  _createClass(Se, [{
    key: "getElement",
    value: function getElement() {
      return this.nodes.root;
    }
    /**
     * Toggles item hidden state
     *
     * @param isHidden - true if item should be hidden
     */

  }, {
    key: "toggleHidden",
    value: function toggleHidden(e) {
      var t;
      (t = this.nodes.root) == null || t.classList.toggle(So.hidden, e);
    }
    /**
     * Returns list of buttons and inputs inside custom content
     */

  }, {
    key: "getControls",
    value: function getControls() {
      var e = this.nodes.root.querySelectorAll("button, ".concat(u.allInputsSelector));
      return Array.from(e);
    }
  }]);

  return Se;
}(xt);

var Jo = /*#__PURE__*/function (_Oe2) {
  _inherits(Jo, _Oe2);

  var _super23 = _createSuper(Jo);

  /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */
  function Jo(e) {
    var _this37;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Jo);

    _this37 = _super23.call(this), _this37.params = e, _this37.itemsRenderParams = t, _this37.listeners = new _e(), _this37.messages = {
      nothingFound: "Nothing found",
      search: "Search"
    }, _this37.items = _this37.buildItems(e.items), e.messages && (_this37.messages = _objectSpread(_objectSpread({}, _this37.messages), e.messages)), _this37.nodes = {}, _this37.nodes.popoverContainer = u.make("div", [P.popoverContainer]), _this37.nodes.nothingFoundMessage = u.make("div", [P.nothingFoundMessage], {
      textContent: _this37.messages.nothingFound
    }), _this37.nodes.popoverContainer.appendChild(_this37.nodes.nothingFoundMessage), _this37.nodes.items = u.make("div", [P.items]), _this37.items.forEach(function (o) {
      var i = o.getElement();
      i !== null && _this37.nodes.items.appendChild(i);
    }), _this37.nodes.popoverContainer.appendChild(_this37.nodes.items), _this37.listeners.on(_this37.nodes.popoverContainer, "click", function (o) {
      return _this37.handleClick(o);
    }), _this37.nodes.popover = u.make("div", [P.popover, _this37.params.class]), _this37.nodes.popover.appendChild(_this37.nodes.popoverContainer);
    return _this37;
  }
  /**
   * List of default popover items that are searchable and may have confirmation state
   */


  _createClass(Jo, [{
    key: "itemsDefault",
    get: function get() {
      return this.items.filter(function (e) {
        return e instanceof re;
      });
    }
    /**
     * Returns HTML element corresponding to the popover
     */

  }, {
    key: "getElement",
    value: function getElement() {
      return this.nodes.popover;
    }
    /**
     * Open popover
     */

  }, {
    key: "show",
    value: function show() {
      this.nodes.popover.classList.add(P.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
     * Closes popover
     */

  }, {
    key: "hide",
    value: function hide() {
      this.nodes.popover.classList.remove(P.popoverOpened), this.nodes.popover.classList.remove(P.popoverOpenTop), this.itemsDefault.forEach(function (e) {
        return e.reset();
      }), this.search !== void 0 && this.search.clear(), this.emit(G.Closed);
    }
    /**
     * Clears memory
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var e;
      this.items.forEach(function (t) {
        return t.destroy();
      }), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
     * Looks for the item by name and imitates click on it
     *
     * @param name - name of the item to activate
     */

  }, {
    key: "activateItemByName",
    value: function activateItemByName(e) {
      var t = this.items.find(function (o) {
        return o.name === e;
      });
      this.handleItemClick(t);
    }
    /**
     * Factory method for creating popover items
     *
     * @param items - list of items params
     */

  }, {
    key: "buildItems",
    value: function buildItems(e) {
      var _this38 = this;

      return e.map(function (t) {
        switch (t.type) {
          case _.Separator:
            return new Qo();

          case _.Html:
            return new Se(t, _this38.itemsRenderParams[_.Html]);

          default:
            return new re(t, _this38.itemsRenderParams[_.Default]);
        }
      });
    }
    /**
     * Retrieves popover item that is the target of the specified event
     *
     * @param event - event to retrieve popover item from
     */

  }, {
    key: "getTargetItem",
    value: function getTargetItem(e) {
      return this.items.filter(function (t) {
        return t instanceof re || t instanceof Se;
      }).find(function (t) {
        var o = t.getElement();
        return o === null ? !1 : e.composedPath().includes(o);
      });
    }
    /**
     * Handles popover item click
     *
     * @param item - item to handle click of
     */

  }, {
    key: "handleItemClick",
    value: function handleItemClick(e) {
      if (!("isDisabled" in e && e.isDisabled)) {
        if (e.hasChildren) {
          this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
          return;
        }

        this.itemsDefault.filter(function (t) {
          return t !== e;
        }).forEach(function (t) {
          return t.reset();
        }), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit(G.ClosedOnActivate));
      }
    }
    /**
     * Handles clicks inside popover
     *
     * @param event - item to handle click of
     */

  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var t = this.getTargetItem(e);
      t !== void 0 && this.handleItemClick(t);
    }
    /**
     * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
     *
     * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
     * (All the other items with the same key get inactive, and the item gets active)
     *
     * @param clickedItem - popover item that was clicked
     */

  }, {
    key: "toggleItemActivenessIfNeeded",
    value: function toggleItemActivenessIfNeeded(e) {
      if (e instanceof re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
        var t = this.itemsDefault.filter(function (o) {
          return o.toggle === e.toggle;
        });

        if (t.length === 1) {
          e.toggleActive();
          return;
        }

        t.forEach(function (o) {
          o.toggleActive(o === e);
        });
      }
    }
  }]);

  return Jo;
}(Oe);

var Ue = /* @__PURE__ */function (n) {
  return n.Search = "search", n;
}(Ue || {});

var st = ne("cdx-search-field"),
    rt = {
  wrapper: st(),
  icon: st("icon"),
  input: st("input")
};

var ls = /*#__PURE__*/function (_Oe3) {
  _inherits(ls, _Oe3);

  var _super24 = _createSuper(ls);

  /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */
  function ls(_ref18) {
    var _this39;

    var e = _ref18.items,
        t = _ref18.placeholder;

    _classCallCheck(this, ls);

    _this39 = _super24.call(this), _this39.listeners = new _e(), _this39.items = e, _this39.wrapper = u.make("div", rt.wrapper);
    var o = u.make("div", rt.icon, {
      innerHTML: os
    });
    _this39.input = u.make("input", rt.input, {
      placeholder: t,

      /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */
      tabIndex: -1
    }), _this39.wrapper.appendChild(o), _this39.wrapper.appendChild(_this39.input), _this39.listeners.on(_this39.input, "input", function () {
      _this39.searchQuery = _this39.input.value, _this39.emit(Ue.Search, {
        query: _this39.searchQuery,
        items: _this39.foundItems
      });
    });
    return _this39;
  }
  /**
   * Returns search field element
   */


  _createClass(ls, [{
    key: "getElement",
    value: function getElement() {
      return this.wrapper;
    }
    /**
     * Sets focus to the input
     */

  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
    /**
     * Clears search query and results
     */

  }, {
    key: "clear",
    value: function clear() {
      this.input.value = "", this.searchQuery = "", this.emit(Ue.Search, {
        query: "",
        items: this.foundItems
      });
    }
    /**
     * Clears memory
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners.removeAll();
    }
    /**
     * Returns list of found items for the current search query
     */

  }, {
    key: "foundItems",
    get: function get() {
      var _this40 = this;

      return this.items.filter(function (e) {
        return _this40.checkItem(e);
      });
    }
    /**
     * Contains logic for checking whether passed item conforms the search query
     *
     * @param item - item to be checked
     */

  }, {
    key: "checkItem",
    value: function checkItem(e) {
      var i, s;
      var t = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "",
          o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
      return o !== void 0 ? t.includes(o) : !1;
    }
  }]);

  return ls;
}(Oe);

var cs = Object.defineProperty,
    ds = Object.getOwnPropertyDescriptor,
    us = function us(n, e, t, o) {
  for (var i = o > 1 ? void 0 : o ? ds(e, t) : e, s = n.length - 1, r; s >= 0; s--) {
    (r = n[s]) && (i = (o ? r(e, t, i) : r(i)) || i);
  }

  return o && i && cs(e, t, i), i;
};

var en = /*#__PURE__*/function (_Jo) {
  _inherits(tn, _Jo);

  var _super25 = _createSuper(tn);

  /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */
  function tn(e, t) {
    var _thisSuper, _this41;

    _classCallCheck(this, tn);

    _this41 = _super25.call(this, e, t), _this41.nestingLevel = 0, _this41.nestedPopoverTriggerItem = null, _this41.previouslyHoveredItem = null, _this41.scopeElement = document.body, _this41.hide = function () {
      var o;
      _get((_thisSuper = _assertThisInitialized(_this41), _getPrototypeOf(tn.prototype)), "hide", _thisSuper).call(_thisSuper), _this41.destroyNestedPopoverIfExists(), (o = _this41.flipper) == null || o.deactivate(), _this41.previouslyHoveredItem = null;
    }, _this41.onFlip = function () {
      var o = _this41.itemsDefault.find(function (i) {
        return i.isFocused;
      });

      o == null || o.onFocus();
    }, _this41.onSearch = function (o) {
      var a;
      var i = o.query === "",
          s = o.items.length === 0;
      _this41.items.forEach(function (l) {
        var c = !1;
        l instanceof re ? c = !o.items.includes(l) : (l instanceof Qo || l instanceof Se) && (c = s || !i), l.toggleHidden(c);
      }), _this41.toggleNothingFoundMessage(s);
      var r = o.query === "" ? _this41.flippableElements : o.items.map(function (l) {
        return l.getElement();
      });
      (a = _this41.flipper) != null && a.isActivated && (_this41.flipper.deactivate(), _this41.flipper.activate(r));
    }, e.nestingLevel !== void 0 && (_this41.nestingLevel = e.nestingLevel), _this41.nestingLevel > 0 && _this41.nodes.popover.classList.add(P.popoverNested), e.scopeElement !== void 0 && (_this41.scopeElement = e.scopeElement), _this41.nodes.popoverContainer !== null && _this41.listeners.on(_this41.nodes.popoverContainer, "mouseover", function (o) {
      return _this41.handleHover(o);
    }), e.searchable && _this41.addSearch(), e.flippable !== !1 && (_this41.flipper = new ce({
      items: _this41.flippableElements,
      focusedItemClass: L.focused,
      allowedKeys: [y.TAB, y.UP, y.DOWN, y.ENTER]
    }), _this41.flipper.onFlip(_this41.onFlip));
    return _this41;
  }
  /**
   * Returns true if some item inside popover is focused
   */


  _createClass(tn, [{
    key: "hasFocus",
    value: function hasFocus() {
      return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
     * Scroll position inside items container of the popover
     */

  }, {
    key: "scrollTop",
    get: function get() {
      return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
     * Returns visible element offset top
     */

  }, {
    key: "offsetTop",
    get: function get() {
      return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
     * Open popover
     */

  }, {
    key: "show",
    value: function show() {
      var e;
      this.nodes.popover.style.setProperty(fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add(P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add(P.popoverOpenLeft), _get(_getPrototypeOf(tn.prototype), "show", this).call(this), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
     * Clears memory
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.hide(), _get(_getPrototypeOf(tn.prototype), "destroy", this).call(this);
    }
    /**
     * Handles displaying nested items for the item.
     *
     * @param item – item to show nested popover for
     */

  }, {
    key: "showNestedItems",
    value: function showNestedItems(e) {
      this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
     * Handles hover events inside popover items container
     *
     * @param event - hover event data
     */

  }, {
    key: "handleHover",
    value: function handleHover(e) {
      var t = this.getTargetItem(e);
      t !== void 0 && this.previouslyHoveredItem !== t && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t, t.hasChildren && this.showNestedPopoverForItem(t));
    }
    /**
     * Sets CSS variable with position of item near which nested popover should be displayed.
     * Is used for correct positioning of the nested popover
     *
     * @param nestedPopoverEl - nested popover element
     * @param item – item near which nested popover should be displayed
     */

  }, {
    key: "setTriggerItemPosition",
    value: function setTriggerItemPosition(e, t) {
      var o = t.getElement(),
          i = (o ? o.offsetTop : 0) - this.scrollTop,
          s = this.offsetTop + i;
      e.style.setProperty(fe.TriggerItemTop, s + "px");
    }
    /**
     * Destroys existing nested popover
     */

  }, {
    key: "destroyNestedPopoverIfExists",
    value: function destroyNestedPopoverIfExists() {
      var e, t;
      this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off(G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t = this.nestedPopoverTriggerItem) == null || t.onChildrenClose());
    }
    /**
     * Creates and displays nested popover for specified item.
     * Is used only on desktop
     *
     * @param item - item to display nested popover by
     */

  }, {
    key: "showNestedPopoverForItem",
    value: function showNestedPopoverForItem(e) {
      var o;
      this.nestedPopover = new tn({
        searchable: e.isChildrenSearchable,
        items: e.children,
        nestingLevel: this.nestingLevel + 1,
        flippable: e.isChildrenFlippable,
        messages: this.messages
      }), e.onChildrenOpen(), this.nestedPopover.on(G.ClosedOnActivate, this.hide);
      var t = this.nestedPopover.getElement();
      return this.nodes.popover.appendChild(t), this.setTriggerItemPosition(t, e), t.style.setProperty(fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
     * Checks if popover should be opened bottom.
     * It should happen when there is enough space below or not enough space above
     */

  }, {
    key: "shouldOpenBottom",
    get: function get() {
      if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
      var e = this.nodes.popoverContainer.getBoundingClientRect(),
          t = this.scopeElement.getBoundingClientRect(),
          o = this.size.height,
          i = e.top + o,
          s = e.top - o,
          r = Math.min(window.innerHeight, t.bottom);
      return s < t.top || i <= r;
    }
    /**
     * Checks if popover should be opened left.
     * It should happen when there is enough space in the right or not enough space in the left
     */

  }, {
    key: "shouldOpenRight",
    get: function get() {
      if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
      var e = this.nodes.popover.getBoundingClientRect(),
          t = this.scopeElement.getBoundingClientRect(),
          o = this.size.width,
          i = e.right + o,
          s = e.left - o,
          r = Math.min(window.innerWidth, t.right);
      return s < t.left || i <= r;
    }
  }, {
    key: "size",
    get: function get() {
      var i;
      var e = {
        height: 0,
        width: 0
      };
      if (this.nodes.popover === null) return e;
      var t = this.nodes.popover.cloneNode(!0);
      t.style.visibility = "hidden", t.style.position = "absolute", t.style.top = "-1000px", t.classList.add(P.popoverOpened), (i = t.querySelector("." + P.popoverNested)) == null || i.remove(), document.body.appendChild(t);
      var o = t.querySelector("." + P.popoverContainer);
      return e.height = o.offsetHeight, e.width = o.offsetWidth, t.remove(), e;
    }
    /**
     * Returns list of elements available for keyboard navigation.
     */

  }, {
    key: "flippableElements",
    get: function get() {
      return this.items.map(function (t) {
        if (t instanceof re) return t.getElement();
        if (t instanceof Se) return t.getControls();
      }).flat().filter(function (t) {
        return t != null;
      });
    }
    /**
     * Adds search to the popover
     */

  }, {
    key: "addSearch",
    value: function addSearch() {
      this.search = new ls({
        items: this.itemsDefault,
        placeholder: this.messages.search
      }), this.search.on(Ue.Search, this.onSearch);
      var e = this.search.getElement();
      e.classList.add(P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
     * Toggles nothing found message visibility
     *
     * @param isDisplayed - true if the message should be displayed
     */

  }, {
    key: "toggleNothingFoundMessage",
    value: function toggleNothingFoundMessage(e) {
      this.nodes.nothingFoundMessage.classList.toggle(P.nothingFoundMessageDisplayed, e);
    }
  }]);

  return tn;
}(Jo);

us([me], en.prototype, "size", 1);
var Bt = en;

var hs = /*#__PURE__*/function (_Bt) {
  _inherits(hs, _Bt);

  var _super26 = _createSuper(hs);

  /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */
  function hs(e) {
    var _super26$call;

    var _this42;

    _classCallCheck(this, hs);

    var t = !be();
    _this42 = _super26.call(this, _objectSpread(_objectSpread({}, e), {}, {
      class: P.popoverInline
    }), (_super26$call = {}, _defineProperty(_super26$call, _.Default, {
      /**
       * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
       *
       * @todo figure out better way to solve the issue
       */
      wrapperTag: "button",
      hint: {
        position: "top",
        alignment: "center",
        enabled: t
      }
    }), _defineProperty(_super26$call, _.Html, {
      hint: {
        position: "top",
        alignment: "center",
        enabled: t
      }
    }), _super26$call)), _this42.items.forEach(function (o) {
      !(o instanceof re) && !(o instanceof Se) || o.hasChildren && o.isChildrenOpen && _this42.showNestedItems(o);
    });
    return _this42;
  }
  /**
   * Returns visible element offset top
   */


  _createClass(hs, [{
    key: "offsetLeft",
    get: function get() {
      return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
     * Open popover
     */

  }, {
    key: "show",
    value: function show() {
      this.nestingLevel === 0 && this.nodes.popover.style.setProperty(fe.InlinePopoverWidth, this.size.width + "px"), _get(_getPrototypeOf(hs.prototype), "show", this).call(this);
    }
    /**
     * Disable hover event handling.
     * Overrides parent's class behavior
     */

  }, {
    key: "handleHover",
    value: function handleHover() {}
    /**
     * Sets CSS variable with position of item near which nested popover should be displayed.
     * Is used to position nested popover right below clicked item
     *
     * @param nestedPopoverEl - nested popover element
     * @param item – item near which nested popover should be displayed
     */

  }, {
    key: "setTriggerItemPosition",
    value: function setTriggerItemPosition(e, t) {
      var o = t.getElement(),
          i = o ? o.offsetLeft : 0,
          s = this.offsetLeft + i;
      e.style.setProperty(fe.TriggerItemLeft, s + "px");
    }
    /**
     * Handles displaying nested items for the item.
     * Overriding in order to add toggling behaviour
     *
     * @param item – item to toggle nested popover for
     */

  }, {
    key: "showNestedItems",
    value: function showNestedItems(e) {
      if (this.nestedPopoverTriggerItem === e) {
        this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
        return;
      }

      _get(_getPrototypeOf(hs.prototype), "showNestedItems", this).call(this, e);
    }
    /**
     * Creates and displays nested popover for specified item.
     * Is used only on desktop
     *
     * @param item - item to display nested popover by
     */

  }, {
    key: "showNestedPopoverForItem",
    value: function showNestedPopoverForItem(e) {
      var t = _get(_getPrototypeOf(hs.prototype), "showNestedPopoverForItem", this).call(this, e);

      return t.getElement().classList.add(P.getPopoverNestedClass(t.nestingLevel)), t;
    }
    /**
     * Overrides default item click handling.
     * Helps to close nested popover once other item is clicked.
     *
     * @param item - clicked item
     */

  }, {
    key: "handleItemClick",
    value: function handleItemClick(e) {
      var t;
      e !== this.nestedPopoverTriggerItem && ((t = this.nestedPopoverTriggerItem) == null || t.handleClick(), _get(_getPrototypeOf(hs.prototype), "destroyNestedPopoverIfExists", this).call(this)), _get(_getPrototypeOf(hs.prototype), "handleItemClick", this).call(this, e);
    }
  }]);

  return hs;
}(Bt);

var on = /*#__PURE__*/function () {
  function xe() {
    _classCallCheck(this, xe);

    this.scrollPosition = null;
  }
  /**
   * Locks body element scroll
   */


  _createClass(xe, [{
    key: "lock",
    value: function lock() {
      pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
    }
    /**
     * Unlocks body element scroll
     */

  }, {
    key: "unlock",
    value: function unlock() {
      pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
    }
    /**
     * Locks scroll in a hard way (via setting fixed position to body element)
     */

  }, {
    key: "lockHard",
    value: function lockHard() {
      this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", "".concat(this.scrollPosition, "px")), document.body.classList.add(xe.CSS.scrollLockedHard);
    }
    /**
     * Unlocks hard scroll lock
     */

  }, {
    key: "unlockHard",
    value: function unlockHard() {
      document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
  }]);

  return xe;
}();

on.CSS = {
  scrollLocked: "ce-scroll-locked",
  scrollLockedHard: "ce-scroll-locked--hard"
};
var ps = on;
var at = ne("ce-popover-header"),
    lt = {
  root: at(),
  text: at("text"),
  backButton: at("back-button")
};

var fs = /*#__PURE__*/function () {
  /**
   * Constructs the instance
   *
   * @param params - popover header params
   */
  function fs(_ref19) {
    var e = _ref19.text,
        t = _ref19.onBackButtonClick;

    _classCallCheck(this, fs);

    this.listeners = new _e(), this.text = e, this.onBackButtonClick = t, this.nodes = {
      root: u.make("div", [lt.root]),
      backButton: u.make("button", [lt.backButton]),
      text: u.make("div", [lt.text])
    }, this.nodes.backButton.innerHTML = Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
  }
  /**
   * Returns popover header root html element
   */


  _createClass(fs, [{
    key: "getElement",
    value: function getElement() {
      return this.nodes.root;
    }
    /**
     * Destroys the instance
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.nodes.root.remove(), this.listeners.destroy();
    }
  }]);

  return fs;
}();

var gs = /*#__PURE__*/function () {
  function gs() {
    _classCallCheck(this, gs);

    this.history = [];
  }
  /**
   * Push new popover state
   *
   * @param state - new state
   */


  _createClass(gs, [{
    key: "push",
    value: function push(e) {
      this.history.push(e);
    }
    /**
     * Pop last popover state
     */

  }, {
    key: "pop",
    value: function pop() {
      return this.history.pop();
    }
    /**
     * Title retrieved from the current state
     */

  }, {
    key: "currentTitle",
    get: function get() {
      return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
     * Items list retrieved from the current state
     */

  }, {
    key: "currentItems",
    get: function get() {
      return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
     * Returns history to initial popover state
     */

  }, {
    key: "reset",
    value: function reset() {
      for (; this.history.length > 1;) {
        this.pop();
      }
    }
  }]);

  return gs;
}();

var nn = /*#__PURE__*/function (_Jo2) {
  _inherits(nn, _Jo2);

  var _super27 = _createSuper(nn);

  /**
   * Construct the instance
   *
   * @param params - popover params
   */
  function nn(e) {
    var _super27$call;

    var _this43;

    _classCallCheck(this, nn);

    _this43 = _super27.call(this, e, (_super27$call = {}, _defineProperty(_super27$call, _.Default, {
      hint: {
        enabled: !1
      }
    }), _defineProperty(_super27$call, _.Html, {
      hint: {
        enabled: !1
      }
    }), _super27$call)), _this43.scrollLocker = new ps(), _this43.history = new gs(), _this43.isHidden = !0, _this43.nodes.overlay = u.make("div", [P.overlay, P.overlayHidden]), _this43.nodes.popover.insertBefore(_this43.nodes.overlay, _this43.nodes.popover.firstChild), _this43.listeners.on(_this43.nodes.overlay, "click", function () {
      _this43.hide();
    }), _this43.history.push({
      items: e.items
    });
    return _this43;
  }
  /**
   * Open popover
   */


  _createClass(nn, [{
    key: "show",
    value: function show() {
      this.nodes.overlay.classList.remove(P.overlayHidden), _get(_getPrototypeOf(nn.prototype), "show", this).call(this), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
     * Closes popover
     */

  }, {
    key: "hide",
    value: function hide() {
      this.isHidden || (_get(_getPrototypeOf(nn.prototype), "hide", this).call(this), this.nodes.overlay.classList.add(P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
     * Clears memory
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(nn.prototype), "destroy", this).call(this), this.scrollLocker.unlock();
    }
    /**
     * Handles displaying nested items for the item
     *
     * @param item – item to show nested popover for
     */

  }, {
    key: "showNestedItems",
    value: function showNestedItems(e) {
      this.updateItemsAndHeader(e.children, e.title), this.history.push({
        title: e.title,
        items: e.children
      });
    }
    /**
     * Removes rendered popover items and header and displays new ones
     *
     * @param items - new popover items
     * @param title - new popover header text
     */

  }, {
    key: "updateItemsAndHeader",
    value: function updateItemsAndHeader(e, t) {
      var _this44 = this;

      if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t !== void 0) {
        this.header = new fs({
          text: t,
          onBackButtonClick: function onBackButtonClick() {
            _this44.history.pop(), _this44.updateItemsAndHeader(_this44.history.currentItems, _this44.history.currentTitle);
          }
        });
        var o = this.header.getElement();
        o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
      }

      this.items.forEach(function (o) {
        var i;
        return (i = o.getElement()) == null ? void 0 : i.remove();
      }), this.items = this.buildItems(e), this.items.forEach(function (o) {
        var s;
        var i = o.getElement();
        i !== null && ((s = _this44.nodes.items) == null || s.appendChild(i));
      });
    }
  }]);

  return nn;
}(Jo);

var ms = /*#__PURE__*/function (_E18) {
  _inherits(ms, _E18);

  var _super28 = _createSuper(ms);

  function ms() {
    var _this45;

    _classCallCheck(this, ms);

    _this45 = _super28.apply(this, arguments), _this45.opened = !1, _this45.selection = new b(), _this45.popover = null, _this45.close = function () {
      _this45.opened && (_this45.opened = !1, b.isAtEditor || _this45.selection.restore(), _this45.selection.clearSaved(), !_this45.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && _this45.Editor.BlockManager.currentBlock && _this45.Editor.BlockSelection.unselectBlock(_this45.Editor.BlockManager.currentBlock), _this45.eventsDispatcher.emit(_this45.events.closed), _this45.popover && (_this45.popover.off(G.Closed, _this45.onPopoverClose), _this45.popover.destroy(), _this45.popover.getElement().remove(), _this45.popover = null));
    }, _this45.onPopoverClose = function () {
      _this45.close();
    };
    return _this45;
  }
  /**
   * Module Events
   */


  _createClass(ms, [{
    key: "events",
    get: function get() {
      return {
        opened: "block-settings-opened",
        closed: "block-settings-closed"
      };
    }
    /**
     * Block Settings CSS
     */

  }, {
    key: "CSS",
    get: function get() {
      return {
        settings: "ce-settings"
      };
    }
    /**
     * Getter for inner popover's flipper instance
     *
     * @todo remove once BlockSettings becomes standalone non-module class
     */

  }, {
    key: "flipper",
    get: function get() {
      var e;
      if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
     * Panel with block settings with 2 sections:
     *  - Tool's Settings
     *  - Default Settings [Move, Remove, etc]
     */

  }, {
    key: "make",
    value: function make() {
      this.nodes.wrapper = u.make("div", [this.CSS.settings]), this.eventsDispatcher.on(Te, this.close);
    }
    /**
     * Destroys module
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAllNodes(), this.listeners.destroy(), this.eventsDispatcher.off(Te, this.close);
    }
    /**
     * Open Block Settings pane
     *
     * @param targetBlock - near which Block we should open BlockSettings
     */

  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var e,
            s,
            _e$getTunes,
            t,
            o,
            i,
            _args12 = arguments;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                e = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : this.Editor.BlockManager.currentBlock;
                this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
                _e$getTunes = e.getTunes(), t = _e$getTunes.toolTunes, o = _e$getTunes.commonTunes;
                this.eventsDispatcher.emit(this.events.opened);
                i = be() ? nn : Bt;
                _context12.t0 = i;
                _context12.t1 = !0;
                _context12.next = 9;
                return this.getTunesItems(e, o, t);

              case 9:
                _context12.t2 = _context12.sent;
                _context12.t3 = this.Editor.API.methods.ui.nodes.redactor;
                _context12.t4 = {
                  nothingFound: z.ui(K.ui.popover, "Nothing found"),
                  search: z.ui(K.ui.popover, "Filter")
                };
                _context12.t5 = {
                  searchable: _context12.t1,
                  items: _context12.t2,
                  scopeElement: _context12.t3,
                  messages: _context12.t4
                };
                this.popover = new _context12.t0(_context12.t5);
                this.popover.on(G.Closed, this.onPopoverClose);
                (s = this.nodes.wrapper) == null || s.append(this.popover.getElement());
                this.popover.show();

              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
    /**
     * Returns root block settings element
     */

  }, {
    key: "getElement",
    value: function getElement() {
      return this.nodes.wrapper;
    }
    /**
     * Returns list of items to be displayed in block tunes menu.
     * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
     *
     * @param currentBlock –  block we are about to open block tunes for
     * @param commonTunes – common tunes
     * @param toolTunes - tool specific tunes
     */

  }, {
    key: "getTunesItems",
    value: function () {
      var _getTunesItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e, t, o) {
        var _this46 = this;

        var i, s, a;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                i = [];
                o !== void 0 && o.length > 0 && (i.push.apply(i, _toConsumableArray(o)), i.push({
                  type: _.Separator
                }));
                s = Array.from(this.Editor.Tools.blockTools.values());
                _context14.next = 5;
                return Yo(e, s);

              case 5:
                a = _context14.sent.reduce(function (l, c) {
                  return c.toolbox.forEach(function (d) {
                    l.push({
                      icon: d.icon,
                      title: z.t(K.toolNames, d.title),
                      name: c.name,
                      closeOnActivate: !0,
                      onActivate: function () {
                        var _onActivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                          var _this46$Editor, h, p, g, f;

                          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                            while (1) {
                              switch (_context13.prev = _context13.next) {
                                case 0:
                                  _this46$Editor = _this46.Editor;
                                  h = _this46$Editor.BlockManager;
                                  p = _this46$Editor.Caret;
                                  g = _this46$Editor.Toolbar;
                                  _context13.next = 6;
                                  return h.convert(e, c.name, d.data);

                                case 6:
                                  f = _context13.sent;
                                  g.close(), p.setToBlock(f, p.positions.END);

                                case 8:
                                case "end":
                                  return _context13.stop();
                              }
                            }
                          }, _callee13);
                        }));

                        function onActivate() {
                          return _onActivate.apply(this, arguments);
                        }

                        return onActivate;
                      }()
                    });
                  }), l;
                }, []);
                return _context14.abrupt("return", (a.length > 0 && (i.push({
                  icon: Go,
                  name: "convert-to",
                  title: z.ui(K.ui.popover, "Convert to"),
                  children: {
                    searchable: !0,
                    items: a
                  }
                }), i.push({
                  type: _.Separator
                })), i.push.apply(i, _toConsumableArray(t)), i.map(function (l) {
                  return _this46.resolveTuneAliases(l);
                })));

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getTunesItems(_x15, _x16, _x17) {
        return _getTunesItems.apply(this, arguments);
      }

      return getTunesItems;
    }()
    /**
     * Resolves aliases in tunes menu items
     *
     * @param item - item with resolved aliases
     */

  }, {
    key: "resolveTuneAliases",
    value: function resolveTuneAliases(e) {
      if (e.type === _.Separator || e.type === _.Html) return e;
      var t = Yi(e, {
        label: "title"
      });
      return e.confirmation && (t.confirmation = this.resolveTuneAliases(e.confirmation)), t;
    }
  }]);

  return ms;
}(E);

var sn = {
  exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */

(function (n, e) {
  (function (t, o) {
    n.exports = o();
  })(window, function () {
    return function (t) {
      var o = {};

      function i(s) {
        if (o[s]) return o[s].exports;
        var r = o[s] = {
          i: s,
          l: !1,
          exports: {}
        };
        return t[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
      }

      return i.m = t, i.c = o, i.d = function (s, r, a) {
        i.o(s, r) || Object.defineProperty(s, r, {
          enumerable: !0,
          get: a
        });
      }, i.r = function (s) {
        (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(s, "__esModule", {
          value: !0
        });
      }, i.t = function (s, r) {
        if (1 & r && (s = i(s)), 8 & r || 4 & r && _typeof(s) == "object" && s && s.__esModule) return s;
        var a = /* @__PURE__ */Object.create(null);
        if (i.r(a), Object.defineProperty(a, "default", {
          enumerable: !0,
          value: s
        }), 2 & r && typeof s != "string") for (var l in s) {
          i.d(a, l, function (c) {
            return s[c];
          }.bind(null, l));
        }
        return a;
      }, i.n = function (s) {
        var r = s && s.__esModule ? function () {
          return s.default;
        } : function () {
          return s;
        };
        return i.d(r, "a", r), r;
      }, i.o = function (s, r) {
        return Object.prototype.hasOwnProperty.call(s, r);
      }, i.p = "", i(i.s = 0);
    }([function (t, o, i) {
      function s(l, c) {
        for (var d = 0; d < c.length; d++) {
          var h = c[d];
          h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
        }
      }

      function r(l, c, d) {
        return c && s(l.prototype, c), d && s(l, d), l;
      }

      i.r(o);

      var a = function () {
        function l(c) {
          var d = this;
          (function (h, p) {
            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
          })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function (h) {
            d.execute(h);
          }, this.element.addEventListener("keydown", this.executeShortcut, !1);
        }

        return r(l, null, [{
          key: "supportedCommands",
          get: function get() {
            return {
              SHIFT: ["SHIFT"],
              CMD: ["CMD", "CONTROL", "COMMAND", "WINDOWS", "CTRL"],
              ALT: ["ALT", "OPTION"]
            };
          }
        }, {
          key: "keyCodes",
          get: function get() {
            return {
              0: 48,
              1: 49,
              2: 50,
              3: 51,
              4: 52,
              5: 53,
              6: 54,
              7: 55,
              8: 56,
              9: 57,
              A: 65,
              B: 66,
              C: 67,
              D: 68,
              E: 69,
              F: 70,
              G: 71,
              H: 72,
              I: 73,
              J: 74,
              K: 75,
              L: 76,
              M: 77,
              N: 78,
              O: 79,
              P: 80,
              Q: 81,
              R: 82,
              S: 83,
              T: 84,
              U: 85,
              V: 86,
              W: 87,
              X: 88,
              Y: 89,
              Z: 90,
              BACKSPACE: 8,
              ENTER: 13,
              ESCAPE: 27,
              LEFT: 37,
              UP: 38,
              RIGHT: 39,
              DOWN: 40,
              INSERT: 45,
              DELETE: 46,
              ".": 190
            };
          }
        }]), r(l, [{
          key: "parseShortcutName",
          value: function value(c) {
            c = c.split("+");

            for (var d = 0; d < c.length; d++) {
              c[d] = c[d].toUpperCase();
              var h = !1;

              for (var p in l.supportedCommands) {
                if (l.supportedCommands[p].includes(c[d])) {
                  h = this.commands[p] = !0;
                  break;
                }
              }

              h || (this.keys[c[d]] = !0);
            }

            for (var g in l.supportedCommands) {
              this.commands[g] || (this.commands[g] = !1);
            }
          }
        }, {
          key: "execute",
          value: function value(c) {
            var d,
                h = {
              CMD: c.ctrlKey || c.metaKey,
              SHIFT: c.shiftKey,
              ALT: c.altKey
            },
                p = !0;

            for (d in this.commands) {
              this.commands[d] !== h[d] && (p = !1);
            }

            var g,
                f = !0;

            for (g in this.keys) {
              f = f && c.keyCode === l.keyCodes[g];
            }

            p && f && this.callback(c);
          }
        }, {
          key: "remove",
          value: function value() {
            this.element.removeEventListener("keydown", this.executeShortcut);
          }
        }]), l;
      }();

      o.default = a;
    }]).default;
  });
})(sn);

var bs = sn.exports;
var vs = /* @__PURE__ */Ke(bs);

var ks = /*#__PURE__*/function () {
  function ks() {
    _classCallCheck(this, ks);

    this.registeredShortcuts = /* @__PURE__ */new Map();
  }
  /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */


  _createClass(ks, [{
    key: "add",
    value: function add(e) {
      if (this.findShortcut(e.on, e.name)) throw Error("Shortcut ".concat(e.name, " is already registered for ").concat(e.on, ". Please remove it before add a new handler."));
      var o = new vs({
        name: e.name,
        on: e.on,
        callback: e.handler
      }),
          i = this.registeredShortcuts.get(e.on) || [];
      this.registeredShortcuts.set(e.on, [].concat(_toConsumableArray(i), [o]));
    }
    /**
     * Remove shortcut
     *
     * @param element - Element shortcut is set for
     * @param name - shortcut name
     */

  }, {
    key: "remove",
    value: function remove(e, t) {
      var o = this.findShortcut(e, t);
      if (!o) return;
      o.remove();
      var s = this.registeredShortcuts.get(e).filter(function (r) {
        return r !== o;
      });

      if (s.length === 0) {
        this.registeredShortcuts.delete(e);
        return;
      }

      this.registeredShortcuts.set(e, s);
    }
    /**
     * Get Shortcut instance if exist
     *
     * @param element - Element shorcut is set for
     * @param shortcut - shortcut name
     * @returns {number} index - shortcut index if exist
     */

  }, {
    key: "findShortcut",
    value: function findShortcut(e, t) {
      return (this.registeredShortcuts.get(e) || []).find(function (_ref20) {
        var i = _ref20.name;
        return i === t;
      });
    }
  }]);

  return ks;
}();

var ge = new ks();

var ys = Object.defineProperty,
    ws = Object.getOwnPropertyDescriptor,
    rn = function rn(n, e, t, o) {
  for (var i = o > 1 ? void 0 : o ? ws(e, t) : e, s = n.length - 1, r; s >= 0; s--) {
    (r = n[s]) && (i = (o ? r(e, t, i) : r(i)) || i);
  }

  return o && i && ys(e, t, i), i;
},
    Le = /* @__PURE__ */function (n) {
  return n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n;
}(Le || {});

var Ct = /*#__PURE__*/function (_Oe4) {
  _inherits(an, _Oe4);

  var _super29 = _createSuper(an);

  /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */
  function an(_ref21) {
    var _this47;

    var e = _ref21.api,
        t = _ref21.tools,
        o = _ref21.i18nLabels;

    _classCallCheck(this, an);

    _this47 = _super29.call(this), _this47.opened = !1, _this47.listeners = new _e(), _this47.popover = null, _this47.handleMobileLayoutToggle = function () {
      _this47.destroyPopover(), _this47.initPopover();
    }, _this47.onPopoverClose = function () {
      _this47.opened = !1, _this47.emit("toolbox-closed"
      /* Closed */
      );
    }, _this47.api = e, _this47.tools = t, _this47.i18nLabels = o, _this47.enableShortcuts(), _this47.nodes = {
      toolbox: u.make("div", an.CSS.toolbox)
    }, _this47.initPopover(), _this47.api.events.on(Te, _this47.handleMobileLayoutToggle);
    return _this47;
  }
  /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */


  _createClass(an, [{
    key: "isEmpty",
    get: function get() {
      return this.toolsToBeDisplayed.length === 0;
    }
    /**
     * CSS styles
     */

  }, {
    key: "getElement",
    value:
    /**
     * Returns root block settings element
     */
    function getElement() {
      return this.nodes.toolbox;
    }
    /**
     * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
     */

  }, {
    key: "hasFocus",
    value: function hasFocus() {
      if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
     * Destroy Module
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var e;
      _get(_getPrototypeOf(an.prototype), "destroy", this).call(this), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off(G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off(Te, this.handleMobileLayoutToggle);
    }
    /**
     * Toolbox Tool's button click handler
     *
     * @param toolName - tool type to be activated
     * @param blockDataOverrides - Block data predefined by the activated Toolbox item
     */

  }, {
    key: "toolButtonActivated",
    value: function toolButtonActivated(e, t) {
      this.insertNewBlock(e, t);
    }
    /**
     * Open Toolbox with Tools
     */

  }, {
    key: "open",
    value: function open() {
      var e;
      this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"
      /* Opened */
      ));
    }
    /**
     * Close Toolbox
     */

  }, {
    key: "close",
    value: function close() {
      var e;
      (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed"
      /* Closed */
      );
    }
    /**
     * Close Toolbox
     */

  }, {
    key: "toggle",
    value: function toggle() {
      this.opened ? this.close() : this.open();
    }
    /**
     * Creates toolbox popover and appends it inside wrapper element
     */

  }, {
    key: "initPopover",
    value: function initPopover() {
      var t;
      var e = be() ? nn : Bt;
      this.popover = new e({
        scopeElement: this.api.ui.nodes.redactor,
        searchable: !0,
        messages: {
          nothingFound: this.i18nLabels.nothingFound,
          search: this.i18nLabels.filter
        },
        items: this.toolboxItemsToBeDisplayed
      }), this.popover.on(G.Closed, this.onPopoverClose), (t = this.nodes.toolbox) == null || t.append(this.popover.getElement());
    }
    /**
     * Destroys popover instance and removes it from DOM
     */

  }, {
    key: "destroyPopover",
    value: function destroyPopover() {
      this.popover !== null && (this.popover.hide(), this.popover.off(G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
  }, {
    key: "toolsToBeDisplayed",
    get: function get() {
      var e = [];
      return this.tools.forEach(function (t) {
        t.toolbox && e.push(t);
      }), e;
    }
  }, {
    key: "toolboxItemsToBeDisplayed",
    get: function get() {
      var _this48 = this;

      var e = function e(t, o) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        return {
          icon: t.icon,
          title: z.t(K.toolNames, t.title || je(o.name)),
          name: o.name,
          onActivate: function onActivate() {
            _this48.toolButtonActivated(o.name, t.data);
          },
          secondaryLabel: o.shortcut && i ? vt(o.shortcut) : ""
        };
      };

      return this.toolsToBeDisplayed.reduce(function (t, o) {
        return Array.isArray(o.toolbox) ? o.toolbox.forEach(function (i, s) {
          t.push(e(i, o, s === 0));
        }) : o.toolbox !== void 0 && t.push(e(o.toolbox, o)), t;
      }, []);
    }
    /**
     * Iterate all tools and enable theirs shortcuts if specified
     */

  }, {
    key: "enableShortcuts",
    value: function enableShortcuts() {
      var _this49 = this;

      this.toolsToBeDisplayed.forEach(function (e) {
        var t = e.shortcut;
        t && _this49.enableShortcutForTool(e.name, t);
      });
    }
    /**
     * Enable shortcut Block Tool implemented shortcut
     *
     * @param {string} toolName - Tool name
     * @param {string} shortcut - shortcut according to the ShortcutData Module format
     */

  }, {
    key: "enableShortcutForTool",
    value: function enableShortcutForTool(e, t) {
      var _this50 = this;

      ge.add({
        name: t,
        on: this.api.ui.nodes.redactor,
        handler: function () {
          var _handler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(o) {
            var i, s, r;
            return _regeneratorRuntime.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    o.preventDefault();
                    i = _this50.api.blocks.getCurrentBlockIndex(), s = _this50.api.blocks.getBlockByIndex(i);

                    if (!s) {
                      _context15.next = 13;
                      break;
                    }

                    _context15.prev = 3;
                    _context15.next = 6;
                    return _this50.api.blocks.convert(s.id, e);

                  case 6:
                    r = _context15.sent;

                    _this50.api.caret.setToBlock(r, "end");

                    return _context15.abrupt("return");

                  case 11:
                    _context15.prev = 11;
                    _context15.t0 = _context15["catch"](3);

                  case 13:
                    _this50.insertNewBlock(e);

                  case 14:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15, null, [[3, 11]]);
          }));

          function handler(_x18) {
            return _handler.apply(this, arguments);
          }

          return handler;
        }()
      });
    }
    /**
     * Removes all added shortcuts
     * Fired when the Read-Only mode is activated
     */

  }, {
    key: "removeAllShortcuts",
    value: function removeAllShortcuts() {
      var _this51 = this;

      this.toolsToBeDisplayed.forEach(function (e) {
        var t = e.shortcut;
        t && ge.remove(_this51.api.ui.nodes.redactor, t);
      });
    }
    /**
     * Inserts new block
     * Can be called when button clicked on Toolbox or by ShortcutData
     *
     * @param {string} toolName - Tool name
     * @param blockDataOverrides - predefined Block data
     */

  }, {
    key: "insertNewBlock",
    value: function () {
      var _insertNewBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e, t) {
        var o, i, s, r, l, a;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);

                if (i) {
                  _context16.next = 3;
                  break;
                }

                return _context16.abrupt("return");

              case 3:
                s = i.isEmpty ? o : o + 1;

                if (!t) {
                  _context16.next = 9;
                  break;
                }

                _context16.next = 7;
                return this.api.blocks.composeBlockData(e);

              case 7:
                l = _context16.sent;
                r = Object.assign(l, t);

              case 9:
                a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
                a.call(ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
                  block: a
                }), this.api.toolbar.close();

              case 11:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function insertNewBlock(_x19, _x20) {
        return _insertNewBlock.apply(this, arguments);
      }

      return insertNewBlock;
    }()
  }], [{
    key: "CSS",
    get: function get() {
      return {
        toolbox: "ce-toolbox"
      };
    }
  }]);

  return an;
}(Oe);

rn([me], Ct.prototype, "toolsToBeDisplayed", 1);
rn([me], Ct.prototype, "toolboxItemsToBeDisplayed", 1);
var Es = Ct;
var ln = "block hovered";

function xs(_x21, _x22) {
  return _xs.apply(this, arguments);
}

function _xs() {
  _xs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(n, e) {
    var t;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            t = navigator.keyboard;

            if (t) {
              _context58.next = 3;
              break;
            }

            return _context58.abrupt("return", e);

          case 3:
            _context58.prev = 3;
            _context58.next = 6;
            return t.getLayoutMap();

          case 6:
            _context58.t0 = _context58.sent.get(n);

            if (_context58.t0) {
              _context58.next = 9;
              break;
            }

            _context58.t0 = e;

          case 9:
            return _context58.abrupt("return", _context58.t0);

          case 12:
            _context58.prev = 12;
            _context58.t1 = _context58["catch"](3);
            return _context58.abrupt("return", (console.error(_context58.t1), e));

          case 15:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58, null, [[3, 12]]);
  }));
  return _xs.apply(this, arguments);
}

var Bs = /*#__PURE__*/function (_E19) {
  _inherits(Bs, _E19);

  var _super30 = _createSuper(Bs);

  /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */
  function Bs(_ref22) {
    var _this52;

    var e = _ref22.config,
        t = _ref22.eventsDispatcher;

    _classCallCheck(this, Bs);

    _this52 = _super30.call(this, {
      config: e,
      eventsDispatcher: t
    }), _this52.toolboxInstance = null;
    return _this52;
  }
  /**
   * CSS styles
   *
   * @returns {object}
   */


  _createClass(Bs, [{
    key: "CSS",
    get: function get() {
      return {
        toolbar: "ce-toolbar",
        content: "ce-toolbar__content",
        actions: "ce-toolbar__actions",
        actionsOpened: "ce-toolbar__actions--opened",
        toolbarOpened: "ce-toolbar--opened",
        openedToolboxHolderModifier: "codex-editor--toolbox-opened",
        plusButton: "ce-toolbar__plus",
        plusButtonShortcut: "ce-toolbar__plus-shortcut",
        settingsToggler: "ce-toolbar__settings-btn",
        settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
      };
    }
    /**
     * Returns the Toolbar opening state
     *
     * @returns {boolean}
     */

  }, {
    key: "opened",
    get: function get() {
      return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
     * Public interface for accessing the Toolbox
     */

  }, {
    key: "toolbox",
    get: function get() {
      var _this53 = this;

      var e;
      return {
        opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
        close: function close() {
          var t;
          (t = _this53.toolboxInstance) == null || t.close();
        },
        open: function open() {
          if (_this53.toolboxInstance === null) {
            S("toolbox.open() called before initialization is finished", "warn");
            return;
          }

          _this53.Editor.BlockManager.currentBlock = _this53.hoveredBlock, _this53.toolboxInstance.open();
        },
        toggle: function toggle() {
          if (_this53.toolboxInstance === null) {
            S("toolbox.toggle() called before initialization is finished", "warn");
            return;
          }

          _this53.toolboxInstance.toggle();
        },
        hasFocus: function hasFocus() {
          var t;
          return (t = _this53.toolboxInstance) == null ? void 0 : t.hasFocus();
        }
      };
    }
    /**
     * Block actions appearance manipulations
     */

  }, {
    key: "blockActions",
    get: function get() {
      var _this54 = this;

      return {
        hide: function hide() {
          _this54.nodes.actions.classList.remove(_this54.CSS.actionsOpened);
        },
        show: function show() {
          _this54.nodes.actions.classList.add(_this54.CSS.actionsOpened);
        }
      };
    }
    /**
     * Methods for working with Block Tunes toggler
     */

  }, {
    key: "blockTunesToggler",
    get: function get() {
      var _this55 = this;

      return {
        hide: function hide() {
          return _this55.nodes.settingsToggler.classList.add(_this55.CSS.settingsTogglerHidden);
        },
        show: function show() {
          return _this55.nodes.settingsToggler.classList.remove(_this55.CSS.settingsTogglerHidden);
        }
      };
    }
    /**
     * Toggles read-only mode
     *
     * @param {boolean} readOnlyEnabled - read-only mode
     */

  }, {
    key: "toggleReadOnly",
    value: function toggleReadOnly(e) {
      var _this56 = this;

      e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(function () {
        _this56.drawUI(), _this56.enableModuleBindings();
      }, {
        timeout: 2e3
      });
    }
    /**
     * Move Toolbar to the passed (or current) Block
     *
     * @param block - block to move Toolbar near it
     */

  }, {
    key: "moveAndOpen",
    value: function moveAndOpen() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.Editor.BlockManager.currentBlock;

      if (this.toolboxInstance === null) {
        S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
        return;
      }

      if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
      this.hoveredBlock = e;
      var t = e.holder,
          o = this.Editor.UI.isMobile;
      var i;
      var s = 20,
          r = e.firstInput,
          a = t.getBoundingClientRect(),
          l = r !== void 0 ? r.getBoundingClientRect() : null,
          c = l !== null ? l.top - a.top : null,
          d = c !== null ? c > s : void 0;
      if (o) i = t.offsetTop + t.offsetHeight;else if (r === void 0 || d) {
        var h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
        i = t.offsetTop + h;
      } else {
        var _h = li(r),
            p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10),
            g = 8;

        i = t.offsetTop + _h - p + g + c;
      }
      this.nodes.wrapper.style.top = "".concat(Math.floor(i), "px"), this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
     * Close the Toolbar
     */

  }, {
    key: "close",
    value: function close() {
      var e, t;
      this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t = this.toolboxInstance) == null || t.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
     * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
     */

  }, {
    key: "reset",
    value: function reset() {
      this.nodes.wrapper.style.top = "unset";
    }
    /**
     * Open Toolbar with Plus Button and Actions
     *
     * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
     *                                     This flag allows to open Toolbar without Actions.
     */

  }, {
    key: "open",
    value: function open() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
     * Draws Toolbar elements
     */

  }, {
    key: "make",
    value: function () {
      var _make = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this57 = this;

        var e, t, o, i;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.nodes.wrapper = u.make("div", this.CSS.toolbar), ["content", "actions"].forEach(function (s) {
                  _this57.nodes[s] = u.make("div", _this57.CSS[s]);
                }), u.append(this.nodes.wrapper, this.nodes.content), u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = u.make("div", this.CSS.plusButton, {
                  innerHTML: ts
                }), u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", function () {
                  $e(!0), _this57.plusButtonClicked();
                }, !1);
                e = u.make("div");
                e.appendChild(document.createTextNode(z.ui(K.ui.toolbar.toolbox, "Add"))), e.appendChild(u.make("div", this.CSS.plusButtonShortcut, {
                  textContent: "/"
                })), ze(this.nodes.plusButton, e, {
                  hidingDelay: 400
                }), this.nodes.settingsToggler = u.make("span", this.CSS.settingsToggler, {
                  innerHTML: es
                }), u.append(this.nodes.actions, this.nodes.settingsToggler);
                t = u.make("div");
                o = u.text(z.ui(K.ui.blockTunes.toggler, "Click to tune"));
                _context17.next = 7;
                return xs("Slash", "/");

              case 7:
                i = _context17.sent;
                t.appendChild(o), t.appendChild(u.make("div", this.CSS.plusButtonShortcut, {
                  textContent: vt("CMD + ".concat(i))
                })), ze(this.nodes.settingsToggler, t, {
                  hidingDelay: 400
                }), u.append(this.nodes.actions, this.makeToolbox()), u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function make() {
        return _make.apply(this, arguments);
      }

      return make;
    }()
    /**
     * Creates the Toolbox instance and return it's rendered element
     */

  }, {
    key: "makeToolbox",
    value: function makeToolbox() {
      var _this58 = this;

      return this.toolboxInstance = new Es({
        api: this.Editor.API.methods,
        tools: this.Editor.Tools.blockTools,
        i18nLabels: {
          filter: z.ui(K.ui.popover, "Filter"),
          nothingFound: z.ui(K.ui.popover, "Nothing found")
        }
      }), this.toolboxInstance.on(Le.Opened, function () {
        _this58.Editor.UI.nodes.wrapper.classList.add(_this58.CSS.openedToolboxHolderModifier);
      }), this.toolboxInstance.on(Le.Closed, function () {
        _this58.Editor.UI.nodes.wrapper.classList.remove(_this58.CSS.openedToolboxHolderModifier);
      }), this.toolboxInstance.on(Le.BlockAdded, function (_ref23) {
        var e = _ref23.block;
        var _this58$Editor = _this58.Editor,
            t = _this58$Editor.BlockManager,
            o = _this58$Editor.Caret,
            i = t.getBlockById(e.id);
        i.inputs.length === 0 && (i === t.lastBlock ? (t.insertAtEnd(), o.setToBlock(t.lastBlock)) : o.setToBlock(t.nextBlock));
      }), this.toolboxInstance.getElement();
    }
    /**
     * Handler for Plus Button
     */

  }, {
    key: "plusButtonClicked",
    value: function plusButtonClicked() {
      var e;
      this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
     * Enable bindings
     */

  }, {
    key: "enableModuleBindings",
    value: function enableModuleBindings() {
      var _this59 = this;

      this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", function (e) {
        var t;
        e.stopPropagation(), _this59.settingsTogglerClicked(), (t = _this59.toolboxInstance) != null && t.opened && _this59.toolboxInstance.close(), $e(!0);
      }, !0), be() || this.eventsDispatcher.on(ln, function (e) {
        var t;
        _this59.Editor.BlockSettings.opened || (t = _this59.toolboxInstance) != null && t.opened || _this59.moveAndOpen(e.block);
      });
    }
    /**
     * Disable bindings
     */

  }, {
    key: "disableModuleBindings",
    value: function disableModuleBindings() {
      this.readOnlyMutableListeners.clearAll();
    }
    /**
     * Clicks on the Block Settings toggler
     */

  }, {
    key: "settingsTogglerClicked",
    value: function settingsTogglerClicked() {
      this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
     * Draws Toolbar UI
     *
     * Toolbar contains BlockSettings and Toolbox.
     * That's why at first we draw its components and then Toolbar itself
     *
     * Steps:
     *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
     *  - Make itself and append dependent nodes to itself
     *
     */

  }, {
    key: "drawUI",
    value: function drawUI() {
      this.Editor.BlockSettings.make(), this.make();
    }
    /**
     * Removes all created and saved HTMLElements
     * It is used in Read-Only mode
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
  }]);

  return Bs;
}(E);

var ae = /* @__PURE__ */function (n) {
  return n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n;
}(ae || {}),
    Pe = /* @__PURE__ */function (n) {
  return n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n;
}(Pe || {}),
    cn = /* @__PURE__ */function (n) {
  return n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n;
}(cn || {}),
    pe = /* @__PURE__ */function (n) {
  return n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n;
}(pe || {}),
    We = /* @__PURE__ */function (n) {
  return n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n;
}(We || {}),
    mt = /* @__PURE__ */function (n) {
  return n.IsTune = "isTune", n;
}(mt || {});

var Tt = /*#__PURE__*/function () {
  /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */
  function Tt(_ref24) {
    var e = _ref24.name,
        t = _ref24.constructable,
        o = _ref24.config,
        i = _ref24.api,
        s = _ref24.isDefault,
        _ref24$isInternal = _ref24.isInternal,
        r = _ref24$isInternal === void 0 ? !1 : _ref24$isInternal,
        a = _ref24.defaultPlaceholder;

    _classCallCheck(this, Tt);

    this.api = i, this.name = e, this.constructable = t, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
  }
  /**
   * Returns Tool user configuration
   */


  _createClass(Tt, [{
    key: "settings",
    get: function get() {
      var e = this.config.config || {};
      return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
     * Calls Tool's reset method
     */

  }, {
    key: "reset",
    value: function reset() {
      if (A(this.constructable.reset)) return this.constructable.reset();
    }
    /**
     * Calls Tool's prepare method
     */

  }, {
    key: "prepare",
    value: function prepare() {
      if (A(this.constructable.prepare)) return this.constructable.prepare({
        toolName: this.name,
        config: this.settings
      });
    }
    /**
     * Returns shortcut for Tool (internal or specified by user)
     */

  }, {
    key: "shortcut",
    get: function get() {
      var e = this.constructable.shortcut;
      return this.config.shortcut || e;
    }
    /**
     * Returns Tool's sanitizer configuration
     */

  }, {
    key: "sanitizeConfig",
    get: function get() {
      return this.constructable.sanitize || {};
    }
    /**
     * Returns true if Tools is inline
     */

  }, {
    key: "isInline",
    value: function isInline() {
      return this.type === ae.Inline;
    }
    /**
     * Returns true if Tools is block
     */

  }, {
    key: "isBlock",
    value: function isBlock() {
      return this.type === ae.Block;
    }
    /**
     * Returns true if Tools is tune
     */

  }, {
    key: "isTune",
    value: function isTune() {
      return this.type === ae.Tune;
    }
  }]);

  return Tt;
}();

var Cs = /*#__PURE__*/function (_E20) {
  _inherits(Cs, _E20);

  var _super31 = _createSuper(Cs);

  /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */
  function Cs(_ref25) {
    var _this60;

    var e = _ref25.config,
        t = _ref25.eventsDispatcher;

    _classCallCheck(this, Cs);

    _this60 = _super31.call(this, {
      config: e,
      eventsDispatcher: t
    }), _this60.CSS = {
      inlineToolbar: "ce-inline-toolbar"
    }, _this60.opened = !1, _this60.popover = null, _this60.toolbarVerticalMargin = be() ? 20 : 6, _this60.tools = /* @__PURE__ */new Map(), window.requestIdleCallback(function () {
      _this60.make();
    }, {
      timeout: 2e3
    });
    return _this60;
  }
  /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */

  /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */


  _createClass(Cs, [{
    key: "tryToShow",
    value: function () {
      var _tryToShow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var e,
            _args18 = arguments;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                e = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : !1;
                e && this.close();
                _context18.t0 = this.allowedToShow();

                if (!_context18.t0) {
                  _context18.next = 7;
                  break;
                }

                _context18.next = 6;
                return this.open();

              case 6:
                this.Editor.Toolbar.close();

              case 7:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function tryToShow() {
        return _tryToShow.apply(this, arguments);
      }

      return tryToShow;
    }()
    /**
     * Hides Inline Toolbar
     */

  }, {
    key: "close",
    value: function close() {
      var e, t;

      if (this.opened) {
        var _iterator2 = _createForOfIteratorHelper(this.tools),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _ref28 = _step2.value;

            var _ref27 = _slicedToArray(_ref28, 2);

            var o = _ref27[0];
            var i = _ref27[1];
            var s = this.getToolShortcut(o.name);
            s !== void 0 && ge.remove(this.Editor.UI.nodes.redactor, s), A(i.clear) && i.clear();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.tools = /* @__PURE__ */new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t = this.popover) == null || t.destroy(), this.popover = null;
      }
    }
    /**
     * Check if node is contained by Inline Toolbar
     *
     * @param {Node} node — node to check
     */

  }, {
    key: "containsNode",
    value: function containsNode(e) {
      return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
     * Removes UI and its components
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var e;
      this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
     * Making DOM
     */

  }, {
    key: "make",
    value: function make() {
      this.nodes.wrapper = u.make("div", [this.CSS.inlineToolbar].concat(_toConsumableArray(this.isRtl ? [this.Editor.UI.CSS.editorRtlFix] : []))), u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
     * Shows Inline Toolbar
     */

  }, {
    key: "open",
    value: function () {
      var _open2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var t, e;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!this.opened) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt("return");

              case 2:
                this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
                _context19.next = 5;
                return this.getPopoverItems();

              case 5:
                e = _context19.sent;
                this.popover = new hs({
                  items: e,
                  scopeElement: this.Editor.API.methods.ui.nodes.redactor,
                  messages: {
                    nothingFound: z.ui(K.ui.popover, "Nothing found"),
                    search: z.ui(K.ui.popover, "Filter")
                  }
                }), this.move(this.popover.size.width), (t = this.nodes.wrapper) == null || t.append(this.popover.getElement()), this.popover.show();

              case 7:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function open() {
        return _open2.apply(this, arguments);
      }

      return open;
    }()
    /**
     * Move Toolbar to the selected text
     *
     * @param popoverWidth - width of the toolbar popover
     */

  }, {
    key: "move",
    value: function move(e) {
      var t = b.rect,
          o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(),
          i = {
        x: t.x - o.x,
        y: t.y + t.height - // + window.scrollY
        o.top + this.toolbarVerticalMargin
      };
      i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
     * Clear orientation classes and reset position
     */

  }, {
    key: "reset",
    value: function reset() {
      this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
     * Need to show Inline Toolbar or not
     */

  }, {
    key: "allowedToShow",
    value: function allowedToShow() {
      var e = ["IMG", "INPUT"],
          t = b.get(),
          o = b.text;
      if (!t || !t.anchorNode || t.isCollapsed || o.length < 1) return !1;
      var i = u.isElement(t.anchorNode) ? t.anchorNode : t.anchorNode.parentElement;
      if (i === null || t !== null && e.includes(i.tagName)) return !1;
      var s = this.Editor.BlockManager.getBlock(t.anchorNode);
      return !s || this.getTools().some(function (c) {
        return s.tool.inlineTools.has(c.name);
      }) === !1 ? !1 : i.closest("[contenteditable]") !== null;
    }
    /**
     *  Working with Tools
     *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     */

    /**
     * Returns tools that are available for current block
     *
     * Used to check if Inline Toolbar could be shown
     * and to render tools in the Inline Toolbar
     */

  }, {
    key: "getTools",
    value: function getTools() {
      var _this61 = this;

      var e = this.Editor.BlockManager.currentBlock;
      return e ? Array.from(e.tool.inlineTools.values()).filter(function (o) {
        return !(_this61.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0);
      }) : [];
    }
    /**
     * Constructs tools instances and saves them to this.tools
     */

  }, {
    key: "createToolsInstances",
    value: function createToolsInstances() {
      var _this62 = this;

      this.tools = /* @__PURE__ */new Map(), this.getTools().forEach(function (t) {
        var o = t.create();

        _this62.tools.set(t, o);
      });
    }
    /**
     * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
     */

  }, {
    key: "getPopoverItems",
    value: function () {
      var _getPopoverItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this63 = this;

        var e, t, _iterator3, _step3, _loop, _ref30;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                e = [];
                t = 0;
                _iterator3 = _createForOfIteratorHelper(this.tools);
                _context21.prev = 3;
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                  var _ref29, o, i, s, r, a, l;

                  return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          _ref29 = _step3.value;
                          _ref30 = _slicedToArray(_ref29, 2);
                          o = _ref30[0];
                          i = _ref30[1];
                          _context20.next = 6;
                          return i.render();

                        case 6:
                          s = _context20.sent;
                          r = _this63.getToolShortcut(o.name);
                          if (r !== void 0) try {
                            _this63.enableShortcuts(o.name, r);
                          } catch (_unused6) {}
                          a = r !== void 0 ? vt(r) : void 0, l = z.t(K.toolNames, o.title || je(o.name));
                          [s].flat().forEach(function (c) {
                            var h, p;
                            var d = {
                              name: o.name,
                              onActivate: function onActivate() {
                                _this63.toolClicked(i);
                              },
                              hint: {
                                title: l,
                                description: a
                              }
                            };

                            if (u.isElement(c)) {
                              var g = _objectSpread(_objectSpread({}, d), {}, {
                                element: c,
                                type: _.Html
                              });

                              if (A(i.renderActions)) {
                                var f = i.renderActions();
                                g.children = {
                                  isOpen: (h = i.checkState) == null ? void 0 : h.call(i, b.get()),

                                  /** Disable keyboard navigation in actions, as it might conflict with enter press handling */
                                  isFlippable: !1,
                                  items: [{
                                    type: _.Html,
                                    element: f
                                  }]
                                };
                              } else (p = i.checkState) == null || p.call(i, b.get());

                              e.push(g);
                            } else if (c.type === _.Html) e.push(_objectSpread(_objectSpread(_objectSpread({}, d), c), {}, {
                              type: _.Html
                            }));else if (c.type === _.Separator) e.push({
                              type: _.Separator
                            });else {
                              var _g2 = _objectSpread(_objectSpread(_objectSpread({}, d), c), {}, {
                                type: _.Default
                              });

                              "children" in _g2 && t !== 0 && e.push({
                                type: _.Separator
                              }), e.push(_g2), "children" in _g2 && t < _this63.tools.size - 1 && e.push({
                                type: _.Separator
                              });
                            }
                          }), t++;

                        case 11:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee20);
                });

                _iterator3.s();

              case 6:
                if ((_step3 = _iterator3.n()).done) {
                  _context21.next = 10;
                  break;
                }

                return _context21.delegateYield(_loop(), "t0", 8);

              case 8:
                _context21.next = 6;
                break;

              case 10:
                _context21.next = 15;
                break;

              case 12:
                _context21.prev = 12;
                _context21.t1 = _context21["catch"](3);

                _iterator3.e(_context21.t1);

              case 15:
                _context21.prev = 15;

                _iterator3.f();

                return _context21.finish(15);

              case 18:
                return _context21.abrupt("return", e);

              case 19:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[3, 12, 15, 18]]);
      }));

      function getPopoverItems() {
        return _getPopoverItems.apply(this, arguments);
      }

      return getPopoverItems;
    }()
    /**
     * Get shortcut name for tool
     *
     * @param toolName — Tool name
     */

  }, {
    key: "getToolShortcut",
    value: function getToolShortcut(e) {
      var t = this.Editor.Tools,
          o = t.inlineTools.get(e),
          i = t.internal.inlineTools;
      return Array.from(i.keys()).includes(e) ? this.inlineTools[e][cn.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
     * Enable Tool shortcut with Editor Shortcuts Module
     *
     * @param toolName - tool name
     * @param shortcut - shortcut according to the ShortcutData Module format
     */

  }, {
    key: "enableShortcuts",
    value: function enableShortcuts(e, t) {
      var _this64 = this;

      ge.add({
        name: t,
        handler: function handler(o) {
          var s;
          var i = _this64.Editor.BlockManager.currentBlock;
          i && i.tool.enabledInlineTools && (o.preventDefault(), (s = _this64.popover) == null || s.activateItemByName(e));
        },

        /**
         * We need to bind shortcut to the document to make it work in read-only mode
         */
        on: document
      });
    }
    /**
     * Inline Tool button clicks
     *
     * @param tool - Tool's instance
     */

  }, {
    key: "toolClicked",
    value: function toolClicked(e) {
      var o;
      var t = b.range;
      (o = e.surround) == null || o.call(e, t), this.checkToolsState();
    }
    /**
     * Check Tools` state by selection
     */

  }, {
    key: "checkToolsState",
    value: function checkToolsState() {
      var e;
      (e = this.tools) == null || e.forEach(function (t) {
        var o;
        (o = t.checkState) == null || o.call(t, b.get());
      });
    }
    /**
     * Get inline tools tools
     * Tools that has isInline is true
     */

  }, {
    key: "inlineTools",
    get: function get() {
      var e = {};
      return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(function (_ref31) {
        var _ref32 = _slicedToArray(_ref31, 2),
            t = _ref32[0],
            o = _ref32[1];

        e[t] = o.create();
      }), e;
    }
  }]);

  return Cs;
}(E);

function dn() {
  var n = window.getSelection();
  if (n === null) return [null, 0];
  var e = n.focusNode,
      t = n.focusOffset;
  return e === null ? [null, 0] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t] ? (e = e.childNodes[t], t = 0) : (e = e.childNodes[t - 1], t = e.textContent.length)), [e, t]);
}

function un(n, e, t, o) {
  var i = document.createRange();
  o === "left" ? (i.setStart(n, 0), i.setEnd(e, t)) : (i.setStart(e, t), i.setEnd(n, n.childNodes.length));
  var s = i.cloneContents(),
      r = document.createElement("div");
  r.appendChild(s);
  var a = r.textContent || "";
  return ai(a);
}

function Ne(n) {
  var e = u.getDeepestNode(n);
  if (e === null || u.isEmpty(n)) return !0;
  if (u.isNativeInput(e)) return e.selectionEnd === 0;
  if (u.isEmpty(n)) return !0;

  var _dn = dn(),
      _dn2 = _slicedToArray(_dn, 2),
      t = _dn2[0],
      o = _dn2[1];

  return t === null ? !1 : un(n, t, o, "left");
}

function Re(n) {
  var e = u.getDeepestNode(n, !0);
  if (e === null) return !0;
  if (u.isNativeInput(e)) return e.selectionEnd === e.value.length;

  var _dn3 = dn(),
      _dn4 = _slicedToArray(_dn3, 2),
      t = _dn4[0],
      o = _dn4[1];

  return t === null ? !1 : un(n, t, o, "right");
}

var hn = {},
    St = {},
    Xe = {},
    de = {},
    It = {},
    Ot = {};
Object.defineProperty(Ot, "__esModule", {
  value: !0
});
Ot.allInputsSelector = Ts;

function Ts() {
  var n = ["text", "password", "email", "number", "search", "tel", "url"];
  return "[contenteditable=true], textarea, input:not([type]), " + n.map(function (e) {
    return 'input[type="'.concat(e, '"]');
  }).join(", ");
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.allInputsSelector = void 0;
  var e = Ot;
  Object.defineProperty(n, "allInputsSelector", {
    enumerable: !0,
    get: function get() {
      return e.allInputsSelector;
    }
  });
})(It);

var ue = {},
    _t = {};
Object.defineProperty(_t, "__esModule", {
  value: !0
});
_t.isNativeInput = Ss;

function Ss(n) {
  var e = ["INPUT", "TEXTAREA"];
  return n && n.tagName ? e.includes(n.tagName) : !1;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isNativeInput = void 0;
  var e = _t;
  Object.defineProperty(n, "isNativeInput", {
    enumerable: !0,
    get: function get() {
      return e.isNativeInput;
    }
  });
})(ue);

var pn = {},
    Mt = {};
Object.defineProperty(Mt, "__esModule", {
  value: !0
});
Mt.append = Is;

function Is(n, e) {
  Array.isArray(e) ? e.forEach(function (t) {
    n.appendChild(t);
  }) : n.appendChild(e);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.append = void 0;
  var e = Mt;
  Object.defineProperty(n, "append", {
    enumerable: !0,
    get: function get() {
      return e.append;
    }
  });
})(pn);

var At = {},
    Lt = {};
Object.defineProperty(Lt, "__esModule", {
  value: !0
});
Lt.blockElements = Os;

function Os() {
  return ["address", "article", "aside", "blockquote", "canvas", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "li", "main", "nav", "noscript", "ol", "output", "p", "pre", "ruby", "section", "table", "tbody", "thead", "tr", "tfoot", "ul", "video"];
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.blockElements = void 0;
  var e = Lt;
  Object.defineProperty(n, "blockElements", {
    enumerable: !0,
    get: function get() {
      return e.blockElements;
    }
  });
})(At);

var fn = {},
    Pt = {};
Object.defineProperty(Pt, "__esModule", {
  value: !0
});
Pt.calculateBaseline = _s;

function _s(n) {
  var e = window.getComputedStyle(n),
      t = parseFloat(e.fontSize),
      o = parseFloat(e.lineHeight) || t * 1.2,
      i = parseFloat(e.paddingTop),
      s = parseFloat(e.borderTopWidth),
      r = parseFloat(e.marginTop),
      a = t * 0.8,
      l = (o - t) / 2,
      c = r + s + i + l + a;
  return c;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.calculateBaseline = void 0;
  var e = Pt;
  Object.defineProperty(n, "calculateBaseline", {
    enumerable: !0,
    get: function get() {
      return e.calculateBaseline;
    }
  });
})(fn);

var gn = {},
    Nt = {},
    Rt = {},
    Dt = {};
Object.defineProperty(Dt, "__esModule", {
  value: !0
});
Dt.isContentEditable = Ms;

function Ms(n) {
  return n.contentEditable === "true";
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isContentEditable = void 0;
  var e = Dt;
  Object.defineProperty(n, "isContentEditable", {
    enumerable: !0,
    get: function get() {
      return e.isContentEditable;
    }
  });
})(Rt);

Object.defineProperty(Nt, "__esModule", {
  value: !0
});
Nt.canSetCaret = Ps;
var As = ue,
    Ls = Rt;

function Ps(n) {
  var e = !0;
  if ((0, As.isNativeInput)(n)) switch (n.type) {
    case "file":
    case "checkbox":
    case "radio":
    case "hidden":
    case "submit":
    case "button":
    case "image":
    case "reset":
      e = !1;
      break;
  } else e = (0, Ls.isContentEditable)(n);
  return e;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.canSetCaret = void 0;
  var e = Nt;
  Object.defineProperty(n, "canSetCaret", {
    enumerable: !0,
    get: function get() {
      return e.canSetCaret;
    }
  });
})(gn);

var Ve = {},
    Ft = {};

function Ns(n, e, t) {
  var o = t.value !== void 0 ? "value" : "get",
      i = t[o],
      s = "#".concat(e, "Cache");

  if (t[o] = function () {
    for (var _len4 = arguments.length, r = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      r[_key4] = arguments[_key4];
    }

    return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
  }, o === "get" && t.set) {
    var r = t.set;

    t.set = function (a) {
      delete n[s], r.apply(this, a);
    };
  }

  return t;
}

function mn() {
  var n = {
    win: !1,
    mac: !1,
    x11: !1,
    linux: !1
  },
      e = Object.keys(n).find(function (t) {
    return window.navigator.appVersion.toLowerCase().indexOf(t) !== -1;
  });
  return e !== void 0 && (n[e] = !0), n;
}

function jt(n) {
  return n != null && n !== "" && (_typeof(n) != "object" || Object.keys(n).length > 0);
}

function Rs(n) {
  return !jt(n);
}

var Ds = function Ds() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.navigator !== null && jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
};

function Fs(n) {
  var e = mn();
  return n = n.replace(/shift/gi, "⇧").replace(/backspace/gi, "⌫").replace(/enter/gi, "⏎").replace(/up/gi, "↑").replace(/left/gi, "→").replace(/down/gi, "↓").replace(/right/gi, "←").replace(/escape/gi, "⎋").replace(/insert/gi, "Ins").replace(/delete/gi, "␡").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "⌘").replace(/alt/gi, "⌥") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}

function js(n) {
  return n[0].toUpperCase() + n.slice(1);
}

function Hs(n) {
  var e = document.createElement("div");
  e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
  var t = window.getSelection(),
      o = document.createRange();
  if (o.selectNode(e), t === null) throw new Error("Cannot copy text to clipboard");
  t.removeAllRanges(), t.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}

function $s(n, e, t) {
  var _this65 = this;

  var o;
  return function () {
    for (var _len5 = arguments.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      i[_key5] = arguments[_key5];
    }

    var s = _this65,
        r = function r() {
      o = void 0, t !== !0 && n.apply(s, i);
    },
        a = t === !0 && o !== void 0;

    window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
  };
}

function oe(n) {
  return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}

function zs(n) {
  return oe(n) === "boolean";
}

function bn(n) {
  return oe(n) === "function" || oe(n) === "asyncfunction";
}

function Us(n) {
  return bn(n) && /^\s*class\s+/.test(n.toString());
}

function Ws(n) {
  return oe(n) === "number";
}

function De(n) {
  return oe(n) === "object";
}

function Ys(n) {
  return Promise.resolve(n) === n;
}

function Ks(n) {
  return oe(n) === "string";
}

function Xs(n) {
  return oe(n) === "undefined";
}

function bt(n) {
  for (var _len6 = arguments.length, e = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    e[_key6 - 1] = arguments[_key6];
  }

  if (!e.length) return n;
  var t = e.shift();
  if (De(n) && De(t)) for (var o in t) {
    De(t[o]) ? (n[o] === void 0 && Object.assign(n, _defineProperty({}, o, {})), bt(n[o], t[o])) : Object.assign(n, _defineProperty({}, o, t[o]));
  }
  return bt.apply(void 0, [n].concat(e));
}

function Vs(n, e, t) {
  var o = "\xAB".concat(e, "\xBB is deprecated and will be removed in the next major release. Please use the \xAB").concat(t, "\xBB instead.");
  n && console.warn(o);
}

function qs(n) {
  try {
    return new URL(n).href;
  } catch (_unused7) {}

  return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}

function Zs(n) {
  return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}

var Gs = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  DELETE: 46,
  META: 91,
  SLASH: 191
},
    Qs = {
  LEFT: 0,
  WHEEL: 1,
  RIGHT: 2,
  BACKWARD: 3,
  FORWARD: 4
};

var Js = /*#__PURE__*/function () {
  function Js() {
    _classCallCheck(this, Js);

    this.completed = Promise.resolve();
  }
  /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */


  _createClass(Js, [{
    key: "add",
    value: function add(e) {
      var _this66 = this;

      return new Promise(function (t, o) {
        _this66.completed = _this66.completed.then(e).then(t).catch(o);
      });
    }
  }]);

  return Js;
}();

function er(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
  var o,
      i,
      s,
      r = null,
      a = 0;
  t || (t = {});

  var l = function l() {
    a = t.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
  };

  return function () {
    var c = Date.now();
    !a && t.leading === !1 && (a = c);
    var d = e - (c - a);
    return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t.trailing !== !1 && (r = setTimeout(l, d)), s;
  };
}

var tr = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  PromiseQueue: Js,
  beautifyShortcut: Fs,
  cacheable: Ns,
  capitalize: js,
  copyTextToClipboard: Hs,
  debounce: $s,
  deepMerge: bt,
  deprecationAssert: Vs,
  getUserOS: mn,
  getValidUrl: qs,
  isBoolean: zs,
  isClass: Us,
  isEmpty: Rs,
  isFunction: bn,
  isIosDevice: Ds,
  isNumber: Ws,
  isObject: De,
  isPrintableKey: Zs,
  isPromise: Ys,
  isString: Ks,
  isUndefined: Xs,
  keyCodes: Gs,
  mouseButtons: Qs,
  notEmpty: jt,
  throttle: er,
  typeOf: oe
}, Symbol.toStringTag, {
  value: "Module"
})),
    Ht = /* @__PURE__ */Xn(tr);
Object.defineProperty(Ft, "__esModule", {
  value: !0
});
Ft.containsOnlyInlineElements = ir;
var or = Ht,
    nr = At;

function ir(n) {
  var e;
  (0, or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;

  var t = function t(o) {
    return !(0, nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t);
  };

  return Array.from(e.children).every(t);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.containsOnlyInlineElements = void 0;
  var e = Ft;
  Object.defineProperty(n, "containsOnlyInlineElements", {
    enumerable: !0,
    get: function get() {
      return e.containsOnlyInlineElements;
    }
  });
})(Ve);

var vn = {},
    $t = {},
    qe = {},
    zt = {};
Object.defineProperty(zt, "__esModule", {
  value: !0
});
zt.make = sr;

function sr(n, e, t) {
  var o;
  e === void 0 && (e = null), t === void 0 && (t = {});
  var i = document.createElement(n);

  if (Array.isArray(e)) {
    var s = e.filter(function (a) {
      return a !== void 0;
    });
    (o = i.classList).add.apply(o, s);
  } else e !== null && i.classList.add(e);

  for (var r in t) {
    Object.prototype.hasOwnProperty.call(t, r) && (i[r] = t[r]);
  }

  return i;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.make = void 0;
  var e = zt;
  Object.defineProperty(n, "make", {
    enumerable: !0,
    get: function get() {
      return e.make;
    }
  });
})(qe);

Object.defineProperty($t, "__esModule", {
  value: !0
});
$t.fragmentToString = ar;
var rr = qe;

function ar(n) {
  var e = (0, rr.make)("div");
  return e.appendChild(n), e.innerHTML;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.fragmentToString = void 0;
  var e = $t;
  Object.defineProperty(n, "fragmentToString", {
    enumerable: !0,
    get: function get() {
      return e.fragmentToString;
    }
  });
})(vn);

var kn = {},
    Ut = {};
Object.defineProperty(Ut, "__esModule", {
  value: !0
});
Ut.getContentLength = cr;
var lr = ue;

function cr(n) {
  var e, t;
  return (0, lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t !== void 0 ? t : 0;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.getContentLength = void 0;
  var e = Ut;
  Object.defineProperty(n, "getContentLength", {
    enumerable: !0,
    get: function get() {
      return e.getContentLength;
    }
  });
})(kn);

var Wt = {},
    Yt = {},
    Io = Ce && Ce.__spreadArray || function (n, e, t) {
  if (t || arguments.length === 2) for (var o = 0, i = e.length, s; o < i; o++) {
    (s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
  }
  return n.concat(s || Array.prototype.slice.call(e));
};

Object.defineProperty(Yt, "__esModule", {
  value: !0
});
Yt.getDeepestBlockElements = yn;
var dr = Ve;

function yn(n) {
  return (0, dr.containsOnlyInlineElements)(n) ? [n] : Array.from(n.children).reduce(function (e, t) {
    return Io(Io([], e, !0), yn(t), !0);
  }, []);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.getDeepestBlockElements = void 0;
  var e = Yt;
  Object.defineProperty(n, "getDeepestBlockElements", {
    enumerable: !0,
    get: function get() {
      return e.getDeepestBlockElements;
    }
  });
})(Wt);

var wn = {},
    Kt = {},
    Ze = {},
    Xt = {};
Object.defineProperty(Xt, "__esModule", {
  value: !0
});
Xt.isLineBreakTag = ur;

function ur(n) {
  return ["BR", "WBR"].includes(n.tagName);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isLineBreakTag = void 0;
  var e = Xt;
  Object.defineProperty(n, "isLineBreakTag", {
    enumerable: !0,
    get: function get() {
      return e.isLineBreakTag;
    }
  });
})(Ze);

var Ge = {},
    Vt = {};
Object.defineProperty(Vt, "__esModule", {
  value: !0
});
Vt.isSingleTag = hr;

function hr(n) {
  return ["AREA", "BASE", "BR", "COL", "COMMAND", "EMBED", "HR", "IMG", "INPUT", "KEYGEN", "LINK", "META", "PARAM", "SOURCE", "TRACK", "WBR"].includes(n.tagName);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isSingleTag = void 0;
  var e = Vt;
  Object.defineProperty(n, "isSingleTag", {
    enumerable: !0,
    get: function get() {
      return e.isSingleTag;
    }
  });
})(Ge);

Object.defineProperty(Kt, "__esModule", {
  value: !0
});
Kt.getDeepestNode = En;
var pr = ue,
    fr = Ze,
    gr = Ge;

function En(n, e) {
  e === void 0 && (e = !1);
  var t = e ? "lastChild" : "firstChild",
      o = e ? "previousSibling" : "nextSibling";

  if (n.nodeType === Node.ELEMENT_NODE && n[t]) {
    var i = n[t];
    if ((0, gr.isSingleTag)(i) && !(0, pr.isNativeInput)(i) && !(0, fr.isLineBreakTag)(i)) if (i[o]) i = i[o];else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];else return i.parentNode;
    return En(i, e);
  }

  return n;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.getDeepestNode = void 0;
  var e = Kt;
  Object.defineProperty(n, "getDeepestNode", {
    enumerable: !0,
    get: function get() {
      return e.getDeepestNode;
    }
  });
})(wn);

var xn = {},
    qt = {},
    Me = Ce && Ce.__spreadArray || function (n, e, t) {
  if (t || arguments.length === 2) for (var o = 0, i = e.length, s; o < i; o++) {
    (s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
  }
  return n.concat(s || Array.prototype.slice.call(e));
};

Object.defineProperty(qt, "__esModule", {
  value: !0
});
qt.findAllInputs = yr;
var mr = Ve,
    br = Wt,
    vr = It,
    kr = ue;

function yr(n) {
  return Array.from(n.querySelectorAll((0, vr.allInputsSelector)())).reduce(function (e, t) {
    return (0, kr.isNativeInput)(t) || (0, mr.containsOnlyInlineElements)(t) ? Me(Me([], e, !0), [t], !1) : Me(Me([], e, !0), (0, br.getDeepestBlockElements)(t), !0);
  }, []);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.findAllInputs = void 0;
  var e = qt;
  Object.defineProperty(n, "findAllInputs", {
    enumerable: !0,
    get: function get() {
      return e.findAllInputs;
    }
  });
})(xn);

var Bn = {},
    Zt = {};
Object.defineProperty(Zt, "__esModule", {
  value: !0
});
Zt.isCollapsedWhitespaces = wr;

function wr(n) {
  return !/[^\t\n\r ]/.test(n);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isCollapsedWhitespaces = void 0;
  var e = Zt;
  Object.defineProperty(n, "isCollapsedWhitespaces", {
    enumerable: !0,
    get: function get() {
      return e.isCollapsedWhitespaces;
    }
  });
})(Bn);

var Gt = {},
    Qt = {};
Object.defineProperty(Qt, "__esModule", {
  value: !0
});
Qt.isElement = xr;
var Er = Ht;

function xr(n) {
  return (0, Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isElement = void 0;
  var e = Qt;
  Object.defineProperty(n, "isElement", {
    enumerable: !0,
    get: function get() {
      return e.isElement;
    }
  });
})(Gt);

var Cn = {},
    Jt = {},
    eo = {},
    to = {};
Object.defineProperty(to, "__esModule", {
  value: !0
});
to.isLeaf = Br;

function Br(n) {
  return n === null ? !1 : n.childNodes.length === 0;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isLeaf = void 0;
  var e = to;
  Object.defineProperty(n, "isLeaf", {
    enumerable: !0,
    get: function get() {
      return e.isLeaf;
    }
  });
})(eo);

var oo = {},
    no = {};
Object.defineProperty(no, "__esModule", {
  value: !0
});
no.isNodeEmpty = Or;
var Cr = Ze,
    Tr = Gt,
    Sr = ue,
    Ir = Ge;

function Or(n, e) {
  var t = "";
  return (0, Ir.isSingleTag)(n) && !(0, Cr.isLineBreakTag)(n) ? !1 : ((0, Tr.isElement)(n) && (0, Sr.isNativeInput)(n) ? t = n.value : n.textContent !== null && (t = n.textContent.replace("​", "")), e !== void 0 && (t = t.replace(new RegExp(e, "g"), "")), t.trim().length === 0);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isNodeEmpty = void 0;
  var e = no;
  Object.defineProperty(n, "isNodeEmpty", {
    enumerable: !0,
    get: function get() {
      return e.isNodeEmpty;
    }
  });
})(oo);

Object.defineProperty(Jt, "__esModule", {
  value: !0
});
Jt.isEmpty = Ar;
var _r = eo,
    Mr = oo;

function Ar(n, e) {
  n.normalize();

  for (var t = [n]; t.length > 0;) {
    var o = t.shift();

    if (o) {
      if (n = o, (0, _r.isLeaf)(n) && !(0, Mr.isNodeEmpty)(n, e)) return !1;
      t.push.apply(t, Array.from(n.childNodes));
    }
  }

  return !0;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isEmpty = void 0;
  var e = Jt;
  Object.defineProperty(n, "isEmpty", {
    enumerable: !0,
    get: function get() {
      return e.isEmpty;
    }
  });
})(Cn);

var Tn = {},
    io = {};
Object.defineProperty(io, "__esModule", {
  value: !0
});
io.isFragment = Pr;
var Lr = Ht;

function Pr(n) {
  return (0, Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isFragment = void 0;
  var e = io;
  Object.defineProperty(n, "isFragment", {
    enumerable: !0,
    get: function get() {
      return e.isFragment;
    }
  });
})(Tn);

var Sn = {},
    so = {};
Object.defineProperty(so, "__esModule", {
  value: !0
});
so.isHTMLString = Rr;
var Nr = qe;

function Rr(n) {
  var e = (0, Nr.make)("div");
  return e.innerHTML = n, e.childElementCount > 0;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isHTMLString = void 0;
  var e = so;
  Object.defineProperty(n, "isHTMLString", {
    enumerable: !0,
    get: function get() {
      return e.isHTMLString;
    }
  });
})(Sn);

var In = {},
    ro = {};
Object.defineProperty(ro, "__esModule", {
  value: !0
});
ro.offset = Dr;

function Dr(n) {
  var e = n.getBoundingClientRect(),
      t = window.pageXOffset || document.documentElement.scrollLeft,
      o = window.pageYOffset || document.documentElement.scrollTop,
      i = e.top + o,
      s = e.left + t;
  return {
    top: i,
    left: s,
    bottom: i + e.height,
    right: s + e.width
  };
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.offset = void 0;
  var e = ro;
  Object.defineProperty(n, "offset", {
    enumerable: !0,
    get: function get() {
      return e.offset;
    }
  });
})(In);

var On = {},
    ao = {};
Object.defineProperty(ao, "__esModule", {
  value: !0
});
ao.prepend = Fr;

function Fr(n, e) {
  Array.isArray(e) ? (e = e.reverse(), e.forEach(function (t) {
    return n.prepend(t);
  })) : n.prepend(e);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.prepend = void 0;
  var e = ao;
  Object.defineProperty(n, "prepend", {
    enumerable: !0,
    get: function get() {
      return e.prepend;
    }
  });
})(On);

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
  var e = It;
  Object.defineProperty(n, "allInputsSelector", {
    enumerable: !0,
    get: function get() {
      return e.allInputsSelector;
    }
  });
  var t = ue;
  Object.defineProperty(n, "isNativeInput", {
    enumerable: !0,
    get: function get() {
      return t.isNativeInput;
    }
  });
  var o = pn;
  Object.defineProperty(n, "append", {
    enumerable: !0,
    get: function get() {
      return o.append;
    }
  });
  var i = At;
  Object.defineProperty(n, "blockElements", {
    enumerable: !0,
    get: function get() {
      return i.blockElements;
    }
  });
  var s = fn;
  Object.defineProperty(n, "calculateBaseline", {
    enumerable: !0,
    get: function get() {
      return s.calculateBaseline;
    }
  });
  var r = gn;
  Object.defineProperty(n, "canSetCaret", {
    enumerable: !0,
    get: function get() {
      return r.canSetCaret;
    }
  });
  var a = Ve;
  Object.defineProperty(n, "containsOnlyInlineElements", {
    enumerable: !0,
    get: function get() {
      return a.containsOnlyInlineElements;
    }
  });
  var l = vn;
  Object.defineProperty(n, "fragmentToString", {
    enumerable: !0,
    get: function get() {
      return l.fragmentToString;
    }
  });
  var c = kn;
  Object.defineProperty(n, "getContentLength", {
    enumerable: !0,
    get: function get() {
      return c.getContentLength;
    }
  });
  var d = Wt;
  Object.defineProperty(n, "getDeepestBlockElements", {
    enumerable: !0,
    get: function get() {
      return d.getDeepestBlockElements;
    }
  });
  var h = wn;
  Object.defineProperty(n, "getDeepestNode", {
    enumerable: !0,
    get: function get() {
      return h.getDeepestNode;
    }
  });
  var p = xn;
  Object.defineProperty(n, "findAllInputs", {
    enumerable: !0,
    get: function get() {
      return p.findAllInputs;
    }
  });
  var g = Bn;
  Object.defineProperty(n, "isCollapsedWhitespaces", {
    enumerable: !0,
    get: function get() {
      return g.isCollapsedWhitespaces;
    }
  });
  var f = Rt;
  Object.defineProperty(n, "isContentEditable", {
    enumerable: !0,
    get: function get() {
      return f.isContentEditable;
    }
  });
  var v = Gt;
  Object.defineProperty(n, "isElement", {
    enumerable: !0,
    get: function get() {
      return v.isElement;
    }
  });
  var O = Cn;
  Object.defineProperty(n, "isEmpty", {
    enumerable: !0,
    get: function get() {
      return O.isEmpty;
    }
  });
  var T = Tn;
  Object.defineProperty(n, "isFragment", {
    enumerable: !0,
    get: function get() {
      return T.isFragment;
    }
  });
  var M = Sn;
  Object.defineProperty(n, "isHTMLString", {
    enumerable: !0,
    get: function get() {
      return M.isHTMLString;
    }
  });
  var q = eo;
  Object.defineProperty(n, "isLeaf", {
    enumerable: !0,
    get: function get() {
      return q.isLeaf;
    }
  });
  var F = oo;
  Object.defineProperty(n, "isNodeEmpty", {
    enumerable: !0,
    get: function get() {
      return F.isNodeEmpty;
    }
  });
  var H = Ze;
  Object.defineProperty(n, "isLineBreakTag", {
    enumerable: !0,
    get: function get() {
      return H.isLineBreakTag;
    }
  });
  var Q = Ge;
  Object.defineProperty(n, "isSingleTag", {
    enumerable: !0,
    get: function get() {
      return Q.isSingleTag;
    }
  });
  var ie = qe;
  Object.defineProperty(n, "make", {
    enumerable: !0,
    get: function get() {
      return ie.make;
    }
  });
  var k = In;
  Object.defineProperty(n, "offset", {
    enumerable: !0,
    get: function get() {
      return k.offset;
    }
  });
  var m = On;
  Object.defineProperty(n, "prepend", {
    enumerable: !0,
    get: function get() {
      return m.prepend;
    }
  });
})(de);

var Qe = {};
Object.defineProperty(Qe, "__esModule", {
  value: !0
});
Qe.getContenteditableSlice = Hr;
var jr = de;

function Hr(n, e, t, o, i) {
  var s;
  i === void 0 && (i = !1);
  var r = document.createRange();

  if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t)) : (r.setStart(e, t), r.setEnd(n, n.childNodes.length)), i === !0) {
    var a = r.extractContents();
    return (0, jr.fragmentToString)(a);
  }

  var l = r.cloneContents(),
      c = document.createElement("div");
  c.appendChild(l);
  var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
  return d;
}

Object.defineProperty(Xe, "__esModule", {
  value: !0
});
Xe.checkContenteditableSliceForEmptiness = Ur;
var $r = de,
    zr = Qe;

function Ur(n, e, t, o) {
  var i = (0, zr.getContenteditableSlice)(n, e, t, o);
  return (0, $r.isCollapsedWhitespaces)(i);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.checkContenteditableSliceForEmptiness = void 0;
  var e = Xe;
  Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
    enumerable: !0,
    get: function get() {
      return e.checkContenteditableSliceForEmptiness;
    }
  });
})(St);

var _n = {};

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.getContenteditableSlice = void 0;
  var e = Qe;
  Object.defineProperty(n, "getContenteditableSlice", {
    enumerable: !0,
    get: function get() {
      return e.getContenteditableSlice;
    }
  });
})(_n);

var Mn = {},
    lo = {};
Object.defineProperty(lo, "__esModule", {
  value: !0
});
lo.focus = Yr;
var Wr = de;

function Yr(n, e) {
  var t, o;

  if (e === void 0 && (e = !0), (0, Wr.isNativeInput)(n)) {
    n.focus();
    var i = e ? 0 : n.value.length;
    n.setSelectionRange(i, i);
  } else {
    var s = document.createRange(),
        r = window.getSelection();
    if (!r) return;

    var a = function a(p) {
      var g = document.createTextNode("");
      p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
    },
        l = function l(p) {
      return p != null;
    },
        c = n.childNodes,
        d = e ? c[0] : c[c.length - 1];

    if (l(d)) {
      for (; l(d) && d.nodeType !== Node.TEXT_NODE;) {
        d = e ? d.firstChild : d.lastChild;
      }

      if (l(d) && d.nodeType === Node.TEXT_NODE) {
        var h = (o = (t = d.textContent) === null || t === void 0 ? void 0 : t.length) !== null && o !== void 0 ? o : 0,
            i = e ? 0 : h;
        s.setStart(d, i), s.setEnd(d, i);
      } else a(n);
    } else a(n);

    r.removeAllRanges(), r.addRange(s);
  }
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.focus = void 0;
  var e = lo;
  Object.defineProperty(n, "focus", {
    enumerable: !0,
    get: function get() {
      return e.focus;
    }
  });
})(Mn);

var co = {},
    Je = {};
Object.defineProperty(Je, "__esModule", {
  value: !0
});
Je.getCaretNodeAndOffset = Kr;

function Kr() {
  var n = window.getSelection();
  if (n === null) return [null, 0];
  var e = n.focusNode,
      t = n.focusOffset;
  return e === null ? [null, 0] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t] !== void 0 ? (e = e.childNodes[t], t = 0) : (e = e.childNodes[t - 1], e.textContent !== null && (t = e.textContent.length))), [e, t]);
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.getCaretNodeAndOffset = void 0;
  var e = Je;
  Object.defineProperty(n, "getCaretNodeAndOffset", {
    enumerable: !0,
    get: function get() {
      return e.getCaretNodeAndOffset;
    }
  });
})(co);

var An = {},
    et = {};
Object.defineProperty(et, "__esModule", {
  value: !0
});
et.getRange = Xr;

function Xr() {
  var n = window.getSelection();
  return n && n.rangeCount ? n.getRangeAt(0) : null;
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.getRange = void 0;
  var e = et;
  Object.defineProperty(n, "getRange", {
    enumerable: !0,
    get: function get() {
      return e.getRange;
    }
  });
})(An);

var Ln = {},
    uo = {};
Object.defineProperty(uo, "__esModule", {
  value: !0
});
uo.isCaretAtEndOfInput = Zr;
var Oo = de,
    Vr = co,
    qr = St;

function Zr(n) {
  var e = (0, Oo.getDeepestNode)(n, !0);
  if (e === null) return !0;
  if ((0, Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
  var t = (0, Vr.getCaretNodeAndOffset)(),
      o = t[0],
      i = t[1];
  return o === null ? !1 : (0, qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isCaretAtEndOfInput = void 0;
  var e = uo;
  Object.defineProperty(n, "isCaretAtEndOfInput", {
    enumerable: !0,
    get: function get() {
      return e.isCaretAtEndOfInput;
    }
  });
})(Ln);

var Pn = {},
    ho = {};
Object.defineProperty(ho, "__esModule", {
  value: !0
});
ho.isCaretAtStartOfInput = Jr;
var Ae = de,
    Gr = Je,
    Qr = Xe;

function Jr(n) {
  var e = (0, Ae.getDeepestNode)(n);
  if (e === null || (0, Ae.isEmpty)(n)) return !0;
  if ((0, Ae.isNativeInput)(e)) return e.selectionEnd === 0;
  if ((0, Ae.isEmpty)(n)) return !0;
  var t = (0, Gr.getCaretNodeAndOffset)(),
      o = t[0],
      i = t[1];
  return o === null ? !1 : (0, Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.isCaretAtStartOfInput = void 0;
  var e = ho;
  Object.defineProperty(n, "isCaretAtStartOfInput", {
    enumerable: !0,
    get: function get() {
      return e.isCaretAtStartOfInput;
    }
  });
})(Pn);

var Nn = {},
    po = {};
Object.defineProperty(po, "__esModule", {
  value: !0
});
po.save = oa;
var ea = de,
    ta = et;

function oa() {
  var n = (0, ta.getRange)(),
      e = (0, ea.make)("span");
  if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function () {
    var o = window.getSelection();
    o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function () {
      e.remove();
    }, 150));
  };
}

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.save = void 0;
  var e = po;
  Object.defineProperty(n, "save", {
    enumerable: !0,
    get: function get() {
      return e.save;
    }
  });
})(Nn);

(function (n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
  var e = St;
  Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
    enumerable: !0,
    get: function get() {
      return e.checkContenteditableSliceForEmptiness;
    }
  });
  var t = _n;
  Object.defineProperty(n, "getContenteditableSlice", {
    enumerable: !0,
    get: function get() {
      return t.getContenteditableSlice;
    }
  });
  var o = Mn;
  Object.defineProperty(n, "focus", {
    enumerable: !0,
    get: function get() {
      return o.focus;
    }
  });
  var i = co;
  Object.defineProperty(n, "getCaretNodeAndOffset", {
    enumerable: !0,
    get: function get() {
      return i.getCaretNodeAndOffset;
    }
  });
  var s = An;
  Object.defineProperty(n, "getRange", {
    enumerable: !0,
    get: function get() {
      return s.getRange;
    }
  });
  var r = Ln;
  Object.defineProperty(n, "isCaretAtEndOfInput", {
    enumerable: !0,
    get: function get() {
      return r.isCaretAtEndOfInput;
    }
  });
  var a = Pn;
  Object.defineProperty(n, "isCaretAtStartOfInput", {
    enumerable: !0,
    get: function get() {
      return a.isCaretAtStartOfInput;
    }
  });
  var l = Nn;
  Object.defineProperty(n, "save", {
    enumerable: !0,
    get: function get() {
      return l.save;
    }
  });
})(hn);

var na = /*#__PURE__*/function (_E21) {
  _inherits(na, _E21);

  var _super32 = _createSuper(na);

  function na() {
    _classCallCheck(this, na);

    return _super32.apply(this, arguments);
  }

  _createClass(na, [{
    key: "keydown",
    value:
    /**
     * All keydowns on Block
     *
     * @param {KeyboardEvent} event - keydown
     */
    function keydown(e) {
      switch (this.beforeKeydownProcessing(e), e.keyCode) {
        case y.BACKSPACE:
          this.backspace(e);
          break;

        case y.DELETE:
          this.delete(e);
          break;

        case y.ENTER:
          this.enter(e);
          break;

        case y.DOWN:
        case y.RIGHT:
          this.arrowRightAndDown(e);
          break;

        case y.UP:
        case y.LEFT:
          this.arrowLeftAndUp(e);
          break;

        case y.TAB:
          this.tabPressed(e);
          break;
      }

      e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
     * Fires on keydown before event processing
     *
     * @param {KeyboardEvent} event - keydown
     */

  }, {
    key: "beforeKeydownProcessing",
    value: function beforeKeydownProcessing(e) {
      this.needToolbarClosing(e) && Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
     * Key up on Block:
     * - shows Inline Toolbar if something selected
     * - shows conversion toolbar with 85% of block selection
     *
     * @param {KeyboardEvent} event - keyup event
     */

  }, {
    key: "keyup",
    value: function keyup(e) {
      e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
     * Add drop target styles
     *
     * @param {DragEvent} event - drag over event
     */

  }, {
    key: "dragOver",
    value: function dragOver(e) {
      var t = this.Editor.BlockManager.getBlockByChildNode(e.target);
      t.dropTarget = !0;
    }
    /**
     * Remove drop target style
     *
     * @param {DragEvent} event - drag leave event
     */

  }, {
    key: "dragLeave",
    value: function dragLeave(e) {
      var t = this.Editor.BlockManager.getBlockByChildNode(e.target);
      t.dropTarget = !1;
    }
    /**
     * Copying selected blocks
     * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
     *
     * @param {ClipboardEvent} event - clipboard event
     */

  }, {
    key: "handleCommandC",
    value: function handleCommandC(e) {
      var t = this.Editor.BlockSelection;
      t.anyBlockSelected && t.copySelectedBlocks(e);
    }
    /**
     * Copy and Delete selected Blocks
     *
     * @param {ClipboardEvent} event - clipboard event
     */

  }, {
    key: "handleCommandX",
    value: function handleCommandX(e) {
      var _this$Editor = this.Editor,
          t = _this$Editor.BlockSelection,
          o = _this$Editor.BlockManager,
          i = _this$Editor.Caret;
      t.anyBlockSelected && t.copySelectedBlocks(e).then(function () {
        var s = o.removeSelectedBlocks(),
            r = o.insertDefaultBlockAtIndex(s, !0);
        i.setToBlock(r, i.positions.START), t.clearSelection(e);
      });
    }
    /**
     * Tab pressed inside a Block.
     *
     * @param {KeyboardEvent} event - keydown
     */

  }, {
    key: "tabPressed",
    value: function tabPressed(e) {
      var _this$Editor2 = this.Editor,
          t = _this$Editor2.InlineToolbar,
          o = _this$Editor2.Caret;
      if (t.opened) return;
      (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
     * '/' + 'command' keydown inside a Block
     */

  }, {
    key: "commandSlashPressed",
    value: function commandSlashPressed() {
      this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
     * '/' keydown inside a Block
     *
     * @param event - keydown
     */

  }, {
    key: "slashPressed",
    value: function slashPressed(e) {
      !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
     * ENTER pressed on block
     *
     * @param {KeyboardEvent} event - keydown
     */

  }, {
    key: "enter",
    value: function enter(e) {
      var _this$Editor3 = this.Editor,
          t = _this$Editor3.BlockManager,
          o = _this$Editor3.UI,
          i = t.currentBlock;
      if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !pt) return;
      var s = i;
      i.currentInput !== void 0 && Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
     * Handle backspace keydown on Block
     *
     * @param {KeyboardEvent} event - keydown
     */

  }, {
    key: "backspace",
    value: function backspace(e) {
      var _this$Editor4 = this.Editor,
          t = _this$Editor4.BlockManager,
          o = _this$Editor4.Caret,
          i = t.currentBlock,
          s = t.previousBlock;
      if (i === void 0 || !b.isCollapsed || !i.currentInput || !Ne(i.currentInput)) return;

      if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
        o.navigatePrevious();
        return;
      }

      if (s === null) return;

      if (s.isEmpty) {
        t.removeBlock(s);
        return;
      }

      if (i.isEmpty) {
        t.removeBlock(i);
        var l = t.currentBlock;
        o.setToBlock(l, o.positions.END);
        return;
      }

      xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
     * Handles delete keydown on Block
     * Removes char after the caret.
     * If caret is at the end of the block, merge next block with current
     *
     * @param {KeyboardEvent} event - keydown
     */

  }, {
    key: "delete",
    value: function _delete(e) {
      var _this$Editor5 = this.Editor,
          t = _this$Editor5.BlockManager,
          o = _this$Editor5.Caret,
          i = t.currentBlock,
          s = t.nextBlock;
      if (!b.isCollapsed || !Re(i.currentInput)) return;

      if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
        o.navigateNext();
        return;
      }

      if (s === null) return;

      if (s.isEmpty) {
        t.removeBlock(s);
        return;
      }

      if (i.isEmpty) {
        t.removeBlock(i), o.setToBlock(s, o.positions.START);
        return;
      }

      xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
     * Merge passed Blocks
     *
     * @param targetBlock - to which Block we want to merge
     * @param blockToMerge - what Block we want to merge
     */

  }, {
    key: "mergeBlocks",
    value: function mergeBlocks(e, t) {
      var _this$Editor6 = this.Editor,
          o = _this$Editor6.BlockManager,
          i = _this$Editor6.Toolbar;
      e.lastInput !== void 0 && (hn.focus(e.lastInput, !1), o.mergeBlocks(e, t).then(function () {
        i.close();
      }));
    }
    /**
     * Handle right and down keyboard keys
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "arrowRightAndDown",
    value: function arrowRightAndDown(e) {
      var _this67 = this;

      var t = ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === y.TAB);
      if (this.Editor.UI.someToolbarOpened && t) return;
      this.Editor.Toolbar.close();
      var o = this.Editor.BlockManager.currentBlock,
          s = ((o == null ? void 0 : o.currentInput) !== void 0 ? Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;

      if (e.shiftKey && e.keyCode === y.DOWN && s) {
        this.Editor.CrossBlockSelection.toggleBlockSelectedState();
        return;
      }

      if (e.keyCode === y.DOWN || e.keyCode === y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
        e.preventDefault();
        return;
      }

      Fe(function () {
        _this67.Editor.BlockManager.currentBlock && _this67.Editor.BlockManager.currentBlock.updateCurrentInput();
      }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
     * Handle left and up keyboard keys
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "arrowLeftAndUp",
    value: function arrowLeftAndUp(e) {
      var _this68 = this;

      if (this.Editor.UI.someToolbarOpened) {
        if (ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === y.TAB)) return;
        this.Editor.UI.closeAllToolbars();
      }

      this.Editor.Toolbar.close();
      var t = this.Editor.BlockManager.currentBlock,
          i = ((t == null ? void 0 : t.currentInput) !== void 0 ? Ne(t.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;

      if (e.shiftKey && e.keyCode === y.UP && i) {
        this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
        return;
      }

      if (e.keyCode === y.UP || e.keyCode === y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
        e.preventDefault();
        return;
      }

      Fe(function () {
        _this68.Editor.BlockManager.currentBlock && _this68.Editor.BlockManager.currentBlock.updateCurrentInput();
      }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
     * Cases when we need to close Toolbar
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "needToolbarClosing",
    value: function needToolbarClosing(e) {
      var t = e.keyCode === y.ENTER && this.Editor.Toolbar.toolbox.opened,
          o = e.keyCode === y.ENTER && this.Editor.BlockSettings.opened,
          i = e.keyCode === y.ENTER && this.Editor.InlineToolbar.opened,
          s = e.keyCode === y.TAB;
      return !(e.shiftKey || s || t || o || i);
    }
    /**
     * If Toolbox is not open, then just open it and show plus button
     */

  }, {
    key: "activateToolbox",
    value: function activateToolbox() {
      this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
     * Open Toolbar and show BlockSettings before flipping Tools
     */

  }, {
    key: "activateBlockSettings",
    value: function activateBlockSettings() {
      this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
  }]);

  return na;
}(E);

var ct = /*#__PURE__*/function () {
  /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */
  function ct(e) {
    _classCallCheck(this, ct);

    this.blocks = [], this.workingArea = e;
  }
  /**
   * Get length of Block instances array
   *
   * @returns {number}
   */


  _createClass(ct, [{
    key: "length",
    get: function get() {
      return this.blocks.length;
    }
    /**
     * Get Block instances array
     *
     * @returns {Block[]}
     */

  }, {
    key: "array",
    get: function get() {
      return this.blocks;
    }
    /**
     * Get blocks html elements array
     *
     * @returns {HTMLElement[]}
     */

  }, {
    key: "nodes",
    get: function get() {
      return No(this.workingArea.children);
    }
    /**
     * Proxy trap to implement array-like setter
     *
     * @example
     * blocks[0] = new Block(...)
     * @param {Blocks} instance — Blocks instance
     * @param {PropertyKey} property — block index or any Blocks class property key to set
     * @param {Block} value — value to set
     * @returns {boolean}
     */

  }, {
    key: "push",
    value:
    /**
     * Push new Block to the blocks array and append it to working area
     *
     * @param {Block} block - Block to add
     */
    function push(e) {
      this.blocks.push(e), this.insertToDOM(e);
    }
    /**
     * Swaps blocks with indexes first and second
     *
     * @param {number} first - first block index
     * @param {number} second - second block index
     * @deprecated — use 'move' instead
     */

  }, {
    key: "swap",
    value: function swap(e, t) {
      var o = this.blocks[t];
      u.swap(this.blocks[e].holder, o.holder), this.blocks[t] = this.blocks[e], this.blocks[e] = o;
    }
    /**
     * Move a block from one to another index
     *
     * @param {number} toIndex - new index of the block
     * @param {number} fromIndex - block to move
     */

  }, {
    key: "move",
    value: function move(e, t) {
      var o = this.blocks.splice(t, 1)[0],
          i = e - 1,
          s = Math.max(0, i),
          r = this.blocks[s];
      e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
      var a = this.composeBlockEvent("move", {
        fromIndex: t,
        toIndex: e
      });
      o.call(ee.MOVED, a);
    }
    /**
     * Insert new Block at passed index
     *
     * @param {number} index — index to insert Block
     * @param {Block} block — Block to insert
     * @param {boolean} replace — it true, replace block on given index
     */

  }, {
    key: "insert",
    value: function insert(e, t) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

      if (!this.length) {
        this.push(t);
        return;
      }

      e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call(ee.REMOVED));
      var i = o ? 1 : 0;

      if (this.blocks.splice(e, i, t), e > 0) {
        var s = this.blocks[e - 1];
        this.insertToDOM(t, "afterend", s);
      } else {
        var _s3 = this.blocks[e + 1];
        _s3 ? this.insertToDOM(t, "beforebegin", _s3) : this.insertToDOM(t);
      }
    }
    /**
     * Replaces block under passed index with passed block
     *
     * @param index - index of existed block
     * @param block - new block
     */

  }, {
    key: "replace",
    value: function replace(e, t) {
      if (this.blocks[e] === void 0) throw Error("Incorrect index");
      this.blocks[e].holder.replaceWith(t.holder), this.blocks[e] = t;
    }
    /**
     * Inserts several blocks at once
     *
     * @param blocks - blocks to insert
     * @param index - index to insert blocks at
     */

  }, {
    key: "insertMany",
    value: function insertMany(e, t) {
      var _this$blocks2;

      var o = new DocumentFragment();

      var _iterator4 = _createForOfIteratorHelper(e),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _i2 = _step4.value;
          o.appendChild(_i2.holder);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (this.length > 0) {
        var _this$blocks;

        if (t > 0) {
          var i = Math.min(t - 1, this.length - 1);
          this.blocks[i].holder.after(o);
        } else t === 0 && this.workingArea.prepend(o);

        (_this$blocks = this.blocks).splice.apply(_this$blocks, [t, 0].concat(_toConsumableArray(e)));
      } else (_this$blocks2 = this.blocks).push.apply(_this$blocks2, _toConsumableArray(e)), this.workingArea.appendChild(o);

      e.forEach(function (i) {
        return i.call(ee.RENDERED);
      });
    }
    /**
     * Remove block
     *
     * @param {number} index - index of Block to remove
     */

  }, {
    key: "remove",
    value: function remove(e) {
      isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call(ee.REMOVED), this.blocks.splice(e, 1);
    }
    /**
     * Remove all blocks
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      this.workingArea.innerHTML = "", this.blocks.forEach(function (e) {
        return e.call(ee.REMOVED);
      }), this.blocks.length = 0;
    }
    /**
     * Insert Block after passed target
     *
     * @todo decide if this method is necessary
     * @param {Block} targetBlock — target after which Block should be inserted
     * @param {Block} newBlock — Block to insert
     */

  }, {
    key: "insertAfter",
    value: function insertAfter(e, t) {
      var o = this.blocks.indexOf(e);
      this.insert(o + 1, t);
    }
    /**
     * Get Block by index
     *
     * @param {number} index — Block index
     * @returns {Block}
     */

  }, {
    key: "get",
    value: function get(e) {
      return this.blocks[e];
    }
    /**
     * Return index of passed Block
     *
     * @param {Block} block - Block to find
     * @returns {number}
     */

  }, {
    key: "indexOf",
    value: function indexOf(e) {
      return this.blocks.indexOf(e);
    }
    /**
     * Insert new Block into DOM
     *
     * @param {Block} block - Block to insert
     * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
     * @param {Block} target — Block related to position
     */

  }, {
    key: "insertToDOM",
    value: function insertToDOM(e, t, o) {
      t ? o.holder.insertAdjacentElement(t, e.holder) : this.workingArea.appendChild(e.holder), e.call(ee.RENDERED);
    }
    /**
     * Composes Block event with passed type and details
     *
     * @param {string} type - event type
     * @param {object} detail - event detail
     */

  }, {
    key: "composeBlockEvent",
    value: function composeBlockEvent(e, t) {
      return new CustomEvent(e, {
        detail: t
      });
    }
  }], [{
    key: "set",
    value: function set(e, t, o) {
      return isNaN(Number(t)) ? (Reflect.set(e, t, o), !0) : (e.insert(+t, o), !0);
    }
    /**
     * Proxy trap to implement array-like getter
     *
     * @param {Blocks} instance — Blocks instance
     * @param {PropertyKey} property — Blocks class property key
     * @returns {Block|*}
     */

  }, {
    key: "get",
    value: function get(e, t) {
      return isNaN(Number(t)) ? Reflect.get(e, t) : e.get(+t);
    }
  }]);

  return ct;
}();

var _o = "block-removed",
    Mo = "block-added",
    ia = "block-moved",
    Ao = "block-changed";

var sa = /*#__PURE__*/function () {
  function sa() {
    _classCallCheck(this, sa);

    this.completed = Promise.resolve();
  }
  /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */


  _createClass(sa, [{
    key: "add",
    value: function add(e) {
      var _this69 = this;

      return new Promise(function (t, o) {
        _this69.completed = _this69.completed.then(e).then(t).catch(o);
      });
    }
  }]);

  return sa;
}();

var ra = /*#__PURE__*/function (_E22) {
  _inherits(ra, _E22);

  var _super33 = _createSuper(ra);

  function ra() {
    var _this70;

    _classCallCheck(this, ra);

    _this70 = _super33.apply(this, arguments), _this70._currentBlockIndex = -1, _this70._blocks = null;
    return _this70;
  }
  /**
   * Returns current Block index
   *
   * @returns {number}
   */


  _createClass(ra, [{
    key: "currentBlockIndex",
    get: function get() {
      return this._currentBlockIndex;
    }
    /**
     * Set current Block index and fire Block lifecycle callbacks
     *
     * @param {number} newIndex - index of Block to set as current
     */
    ,
    set: function set(e) {
      this._currentBlockIndex = e;
    }
    /**
     * returns first Block
     *
     * @returns {Block}
     */

  }, {
    key: "firstBlock",
    get: function get() {
      return this._blocks[0];
    }
    /**
     * returns last Block
     *
     * @returns {Block}
     */

  }, {
    key: "lastBlock",
    get: function get() {
      return this._blocks[this._blocks.length - 1];
    }
    /**
     * Get current Block instance
     *
     * @returns {Block}
     */

  }, {
    key: "currentBlock",
    get: function get() {
      return this._blocks[this.currentBlockIndex];
    }
    /**
     * Set passed Block as a current
     *
     * @param block - block to set as a current
     */
    ,
    set: function set(e) {
      this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
     * Returns next Block instance
     *
     * @returns {Block|null}
     */

  }, {
    key: "nextBlock",
    get: function get() {
      return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
     * Return first Block with inputs after current Block
     *
     * @returns {Block | undefined}
     */

  }, {
    key: "nextContentfulBlock",
    get: function get() {
      return this.blocks.slice(this.currentBlockIndex + 1).find(function (t) {
        return !!t.inputs.length;
      });
    }
    /**
     * Return first Block with inputs before current Block
     *
     * @returns {Block | undefined}
     */

  }, {
    key: "previousContentfulBlock",
    get: function get() {
      return this.blocks.slice(0, this.currentBlockIndex).reverse().find(function (t) {
        return !!t.inputs.length;
      });
    }
    /**
     * Returns previous Block instance
     *
     * @returns {Block|null}
     */

  }, {
    key: "previousBlock",
    get: function get() {
      return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
     * Get array of Block instances
     *
     * @returns {Block[]} {@link Blocks#array}
     */

  }, {
    key: "blocks",
    get: function get() {
      return this._blocks.array;
    }
    /**
     * Check if each Block is empty
     *
     * @returns {boolean}
     */

  }, {
    key: "isEditorEmpty",
    get: function get() {
      return this.blocks.every(function (e) {
        return e.isEmpty;
      });
    }
    /**
     * Should be called after Editor.UI preparation
     * Define this._blocks property
     */

  }, {
    key: "prepare",
    value: function prepare() {
      var _this71 = this;

      var e = new ct(this.Editor.UI.nodes.redactor);
      this._blocks = new Proxy(e, {
        set: ct.set,
        get: ct.get
      }), this.listeners.on(document, "copy", function (t) {
        return _this71.Editor.BlockEvents.handleCommandC(t);
      });
    }
    /**
     * Toggle read-only state
     *
     * If readOnly is true:
     *  - Unbind event handlers from created Blocks
     *
     * if readOnly is false:
     *  - Bind event handlers to all existing Blocks
     *
     * @param {boolean} readOnlyEnabled - "read only" state
     */

  }, {
    key: "toggleReadOnly",
    value: function toggleReadOnly(e) {
      e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
     * Creates Block instance by tool name
     *
     * @param {object} options - block creation options
     * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
     * @param {string} [options.id] - unique id for this block
     * @param {BlockToolData} [options.data] - constructor params
     * @returns {Block}
     */

  }, {
    key: "composeBlock",
    value: function composeBlock(_ref33) {
      var _this72 = this;

      var e = _ref33.tool,
          _ref33$data = _ref33.data,
          t = _ref33$data === void 0 ? {} : _ref33$data,
          _ref33$id = _ref33.id,
          o = _ref33$id === void 0 ? void 0 : _ref33$id,
          _ref33$tunes = _ref33.tunes,
          i = _ref33$tunes === void 0 ? {} : _ref33$tunes;
      var s = this.Editor.ReadOnly.isEnabled,
          r = this.Editor.Tools.blockTools.get(e),
          a = new R({
        id: o,
        data: t,
        tool: r,
        api: this.Editor.API,
        readOnly: s,
        tunesData: i
      }, this.eventsDispatcher);
      return s || window.requestIdleCallback(function () {
        _this72.bindBlockEvents(a);
      }, {
        timeout: 2e3
      }), a;
    }
    /**
     * Insert new block into _blocks
     *
     * @param {object} options - insert options
     * @param {string} [options.id] - block's unique id
     * @param {string} [options.tool] - plugin name, by default method inserts the default block type
     * @param {object} [options.data] - plugin data
     * @param {number} [options.index] - index where to insert new Block
     * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
     * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
     * @returns {Block}
     */

  }, {
    key: "insert",
    value: function insert() {
      var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref34$id = _ref34.id,
          e = _ref34$id === void 0 ? void 0 : _ref34$id,
          _ref34$tool = _ref34.tool,
          t = _ref34$tool === void 0 ? this.config.defaultBlock : _ref34$tool,
          _ref34$data = _ref34.data,
          o = _ref34$data === void 0 ? {} : _ref34$data,
          i = _ref34.index,
          _ref34$needToFocus = _ref34.needToFocus,
          s = _ref34$needToFocus === void 0 ? !0 : _ref34$needToFocus,
          _ref34$replace = _ref34.replace,
          r = _ref34$replace === void 0 ? !1 : _ref34$replace,
          _ref34$tunes = _ref34.tunes,
          a = _ref34$tunes === void 0 ? {} : _ref34$tunes;

      var l = i;
      l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
      var c = this.composeBlock({
        id: e,
        tool: t,
        data: o,
        tunes: a
      });
      return r && this.blockDidMutated(_o, this.getBlockByIndex(l), {
        index: l
      }), this._blocks.insert(l, c, r), this.blockDidMutated(Mo, c, {
        index: l
      }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
     * Inserts several blocks at once
     *
     * @param blocks - blocks to insert
     * @param index - index where to insert
     */

  }, {
    key: "insertMany",
    value: function insertMany(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this._blocks.insertMany(e, t);
    }
    /**
     * Update Block data.
     *
     * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
     * Should not trigger 'block-removed' or 'block-added' events.
     *
     * If neither data nor tunes is provided, return the provided block instead.
     *
     * @param block - block to update
     * @param data - (optional) new data
     * @param tunes - (optional) tune data
     */

  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(e, t, o) {
        var i, s, r;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!(!t && !o)) {
                  _context22.next = 2;
                  break;
                }

                return _context22.abrupt("return", e);

              case 2:
                _context22.next = 4;
                return e.data;

              case 4:
                i = _context22.sent;
                s = this.composeBlock({
                  id: e.id,
                  tool: e.name,
                  data: Object.assign({}, i, t !== null && t !== void 0 ? t : {}),
                  tunes: o !== null && o !== void 0 ? o : e.tunes
                });
                r = this.getBlockIndex(e);
                return _context22.abrupt("return", (this._blocks.replace(r, s), this.blockDidMutated(Ao, s, {
                  index: r
                }), s));

              case 8:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function update(_x23, _x24, _x25) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
    /**
     * Replace passed Block with the new one with specified Tool and data
     *
     * @param block - block to replace
     * @param newTool - new Tool name
     * @param data - new Tool data
     */

  }, {
    key: "replace",
    value: function replace(e, t, o) {
      var i = this.getBlockIndex(e);
      return this.insert({
        tool: t,
        data: o,
        index: i,
        replace: !0
      });
    }
    /**
     * Insert pasted content. Call onPaste callback after insert.
     *
     * @param {string} toolName - name of Tool to insert
     * @param {PasteEvent} pasteEvent - pasted data
     * @param {boolean} replace - should replace current block
     */

  }, {
    key: "paste",
    value: function paste(e, t) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var i = this.insert({
        tool: e,
        replace: o
      });

      try {
        window.requestIdleCallback(function () {
          i.call(ee.ON_PASTE, t);
        });
      } catch (s) {
        S("".concat(e, ": onPaste callback call is failed"), "error", s);
      }

      return i;
    }
    /**
     * Insert new default block at passed index
     *
     * @param {number} index - index where Block should be inserted
     * @param {boolean} needToFocus - if true, updates current Block index
     *
     * TODO: Remove method and use insert() with index instead (?)
     * @returns {Block} inserted Block
     */

  }, {
    key: "insertDefaultBlockAtIndex",
    value: function insertDefaultBlockAtIndex(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var o = this.composeBlock({
        tool: this.config.defaultBlock
      });
      return this._blocks[e] = o, this.blockDidMutated(Mo, o, {
        index: e
      }), t ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
     * Always inserts at the end
     *
     * @returns {Block}
     */

  }, {
    key: "insertAtEnd",
    value: function insertAtEnd() {
      return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
     * Merge two blocks
     *
     * @param {Block} targetBlock - previous block will be append to this block
     * @param {Block} blockToMerge - block that will be merged with target block
     * @returns {Promise} - the sequence that can be continued
     */

  }, {
    key: "mergeBlocks",
    value: function () {
      var _mergeBlocks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(e, t) {
        var o, i, _yt, _yt2, s, _i3, _s4;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!(e.name === t.name && e.mergeable)) {
                  _context23.next = 11;
                  break;
                }

                _context23.next = 3;
                return t.data;

              case 3:
                i = _context23.sent;

                if (!V(i)) {
                  _context23.next = 7;
                  break;
                }

                console.error("Could not merge Block. Failed to extract original Block data.");
                return _context23.abrupt("return");

              case 7:
                _yt = yt([i], e.tool.sanitizeConfig), _yt2 = _slicedToArray(_yt, 1), s = _yt2[0];
                o = s;
                _context23.next = 17;
                break;

              case 11:
                if (!(e.mergeable && He(t, "export") && He(e, "import"))) {
                  _context23.next = 17;
                  break;
                }

                _context23.next = 14;
                return t.exportDataAsString();

              case 14:
                _i3 = _context23.sent;
                _s4 = Z(_i3, e.tool.sanitizeConfig);
                o = Bo(_s4, e.tool.conversionConfig);

              case 17:
                _context23.t0 = o !== void 0;

                if (!_context23.t0) {
                  _context23.next = 23;
                  break;
                }

                _context23.next = 21;
                return e.mergeWith(o);

              case 21:
                this.removeBlock(t);
                this.currentBlockIndex = this._blocks.indexOf(e);

              case 23:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function mergeBlocks(_x26, _x27) {
        return _mergeBlocks.apply(this, arguments);
      }

      return mergeBlocks;
    }()
    /**
     * Remove passed Block
     *
     * @param block - Block to remove
     * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
     */

  }, {
    key: "removeBlock",
    value: function removeBlock(e) {
      var _this73 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return new Promise(function (o) {
        var i = _this73._blocks.indexOf(e);

        if (!_this73.validateIndex(i)) throw new Error("Can't find a Block to remove");
        _this73._blocks.remove(i), e.destroy(), _this73.blockDidMutated(_o, e, {
          index: i
        }), _this73.currentBlockIndex >= i && _this73.currentBlockIndex--, _this73.blocks.length ? i === 0 && (_this73.currentBlockIndex = 0) : (_this73.unsetCurrentBlock(), t && _this73.insert()), o();
      });
    }
    /**
     * Remove only selected Blocks
     * and returns first Block index where started removing...
     *
     * @returns {number|undefined}
     */

  }, {
    key: "removeSelectedBlocks",
    value: function removeSelectedBlocks() {
      var e;

      for (var t = this.blocks.length - 1; t >= 0; t--) {
        this.blocks[t].selected && (this.removeBlock(this.blocks[t]), e = t);
      }

      return e;
    }
    /**
     * Attention!
     * After removing insert the new default typed Block and focus on it
     * Removes all blocks
     */

  }, {
    key: "removeAllBlocks",
    value: function removeAllBlocks() {
      for (var e = this.blocks.length - 1; e >= 0; e--) {
        this._blocks.remove(e);
      }

      this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
     * Split current Block
     * 1. Extract content from Caret position to the Block`s end
     * 2. Insert a new Block below current one with extracted content
     *
     * @returns {Block}
     */

  }, {
    key: "split",
    value: function split() {
      var e = this.Editor.Caret.extractFragmentFromCaretPosition(),
          t = u.make("div");
      t.appendChild(e);
      var o = {
        text: u.isEmpty(t) ? "" : t.innerHTML
      };
      return this.insert({
        data: o
      });
    }
    /**
     * Returns Block by passed index
     *
     * @param {number} index - index to get. -1 to get last
     * @returns {Block}
     */

  }, {
    key: "getBlockByIndex",
    value: function getBlockByIndex(e) {
      return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
     * Returns an index for passed Block
     *
     * @param block - block to find index
     */

  }, {
    key: "getBlockIndex",
    value: function getBlockIndex(e) {
      return this._blocks.indexOf(e);
    }
    /**
     * Returns the Block by passed id
     *
     * @param id - id of block to get
     * @returns {Block}
     */

  }, {
    key: "getBlockById",
    value: function getBlockById(e) {
      return this._blocks.array.find(function (t) {
        return t.id === e;
      });
    }
    /**
     * Get Block instance by html element
     *
     * @param {Node} element - html element to get Block by
     */

  }, {
    key: "getBlock",
    value: function getBlock(e) {
      u.isElement(e) || (e = e.parentNode);
      var t = this._blocks.nodes,
          o = e.closest(".".concat(R.CSS.wrapper)),
          i = t.indexOf(o);
      if (i >= 0) return this._blocks[i];
    }
    /**
     * 1) Find first-level Block from passed child Node
     * 2) Mark it as current
     *
     * @param {Node} childNode - look ahead from this node.
     * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
     */

  }, {
    key: "setCurrentBlockByChildNode",
    value: function setCurrentBlockByChildNode(e) {
      u.isElement(e) || (e = e.parentNode);
      var t = e.closest(".".concat(R.CSS.wrapper));
      if (!t) return;
      var o = t.closest(".".concat(this.Editor.UI.CSS.editorWrapper));
      if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
     * Return block which contents passed node
     *
     * @param {Node} childNode - node to get Block by
     * @returns {Block}
     */

  }, {
    key: "getBlockByChildNode",
    value: function getBlockByChildNode(e) {
      if (!e || !(e instanceof Node)) return;
      u.isElement(e) || (e = e.parentNode);
      var t = e.closest(".".concat(R.CSS.wrapper));
      return this.blocks.find(function (o) {
        return o.holder === t;
      });
    }
    /**
     * Swap Blocks Position
     *
     * @param {number} fromIndex - index of first block
     * @param {number} toIndex - index of second block
     * @deprecated — use 'move' instead
     */

  }, {
    key: "swap",
    value: function swap(e, t) {
      this._blocks.swap(e, t), this.currentBlockIndex = t;
    }
    /**
     * Move a block to a new index
     *
     * @param {number} toIndex - index where to move Block
     * @param {number} fromIndex - index of Block to move
     */

  }, {
    key: "move",
    value: function move(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentBlockIndex;

      if (isNaN(e) || isNaN(t)) {
        S("Warning during 'move' call: incorrect indices provided.", "warn");
        return;
      }

      if (!this.validateIndex(e) || !this.validateIndex(t)) {
        S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
        return;
      }

      this._blocks.move(e, t), this.currentBlockIndex = e, this.blockDidMutated(ia, this.currentBlock, {
        fromIndex: t,
        toIndex: e
      });
    }
    /**
     * Converts passed Block to the new Tool
     * Uses Conversion Config
     *
     * @param blockToConvert - Block that should be converted
     * @param targetToolName - name of the Tool to convert to
     * @param blockDataOverrides - optional new Block data overrides
     */

  }, {
    key: "convert",
    value: function () {
      var _convert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(e, t, o) {
        var s, r, a, l;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return e.save();

              case 2:
                if (_context24.sent) {
                  _context24.next = 4;
                  break;
                }

                throw new Error("Could not convert Block. Failed to extract original Block data.");

              case 4:
                s = this.Editor.Tools.blockTools.get(t);

                if (s) {
                  _context24.next = 7;
                  break;
                }

                throw new Error("Could not convert Block. Tool \xAB".concat(t, "\xBB not found."));

              case 7:
                _context24.next = 9;
                return e.exportDataAsString();

              case 9:
                r = _context24.sent;
                a = Z(r, s.sanitizeConfig);
                l = Bo(a, s.conversionConfig, s.settings);
                return _context24.abrupt("return", (o && (l = Object.assign(l, o)), this.replace(e, s.name, l)));

              case 13:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function convert(_x28, _x29, _x30) {
        return _convert.apply(this, arguments);
      }

      return convert;
    }()
    /**
     * Sets current Block Index -1 which means unknown
     * and clear highlights
     */

  }, {
    key: "unsetCurrentBlock",
    value: function unsetCurrentBlock() {
      this.currentBlockIndex = -1;
    }
    /**
     * Clears Editor
     *
     * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
     *                                             we don't need to add an empty default block
     *                                        2) in api.blocks.clear we should add empty block
     */

  }, {
    key: "clear",
    value: function () {
      var _clear2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var _this74 = this;

        var e,
            t,
            _args26 = arguments;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                e = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : !1;
                t = new sa();

                _toConsumableArray(this.blocks).forEach(function (i) {
                  t.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
                    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            _context25.next = 2;
                            return _this74.removeBlock(i, !1);

                          case 2:
                          case "end":
                            return _context25.stop();
                        }
                      }
                    }, _callee25);
                  })));
                });

                _context26.next = 5;
                return t.completed;

              case 5:
                this.unsetCurrentBlock();
                e && this.insert();
                this.Editor.UI.checkEmptiness();

              case 8:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function clear() {
        return _clear2.apply(this, arguments);
      }

      return clear;
    }()
    /**
     * Cleans up all the block tools' resources
     * This is called when editor is destroyed
     */

  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return Promise.all(this.blocks.map(function (e) {
                  return e.destroy();
                }));

              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function destroy() {
        return _destroy.apply(this, arguments);
      }

      return destroy;
    }()
    /**
     * Bind Block events
     *
     * @param {Block} block - Block to which event should be bound
     */

  }, {
    key: "bindBlockEvents",
    value: function bindBlockEvents(e) {
      var _this75 = this;

      var t = this.Editor.BlockEvents;
      this.readOnlyMutableListeners.on(e.holder, "keydown", function (o) {
        t.keydown(o);
      }), this.readOnlyMutableListeners.on(e.holder, "keyup", function (o) {
        t.keyup(o);
      }), this.readOnlyMutableListeners.on(e.holder, "dragover", function (o) {
        t.dragOver(o);
      }), this.readOnlyMutableListeners.on(e.holder, "dragleave", function (o) {
        t.dragLeave(o);
      }), e.on("didMutated", function (o) {
        return _this75.blockDidMutated(Ao, o, {
          index: _this75.getBlockIndex(o)
        });
      });
    }
    /**
     * Disable mutable handlers and bindings
     */

  }, {
    key: "disableModuleBindings",
    value: function disableModuleBindings() {
      this.readOnlyMutableListeners.clearAll();
    }
    /**
     * Enables all module handlers and bindings for all Blocks
     */

  }, {
    key: "enableModuleBindings",
    value: function enableModuleBindings() {
      var _this76 = this;

      this.readOnlyMutableListeners.on(document, "cut", function (e) {
        return _this76.Editor.BlockEvents.handleCommandX(e);
      }), this.blocks.forEach(function (e) {
        _this76.bindBlockEvents(e);
      });
    }
    /**
     * Validates that the given index is not lower than 0 or higher than the amount of blocks
     *
     * @param {number} index - index of blocks array to validate
     * @returns {boolean}
     */

  }, {
    key: "validateIndex",
    value: function validateIndex(e) {
      return !(e < 0 || e >= this._blocks.length);
    }
    /**
     * Block mutation callback
     *
     * @param mutationType - what happened with block
     * @param block - mutated block
     * @param detailData - additional data to pass with change event
     */

  }, {
    key: "blockDidMutated",
    value: function blockDidMutated(e, t, o) {
      var i = new CustomEvent(e, {
        detail: _objectSpread({
          target: new J(t)
        }, o)
      });
      return this.eventsDispatcher.emit($o, {
        event: i
      }), t;
    }
  }]);

  return ra;
}(E);

var aa = /*#__PURE__*/function (_E23) {
  _inherits(aa, _E23);

  var _super34 = _createSuper(aa);

  function aa() {
    var _this77;

    _classCallCheck(this, aa);

    _this77 = _super34.apply(this, arguments), _this77.anyBlockSelectedCache = null, _this77.needToSelectAll = !1, _this77.nativeInputSelected = !1, _this77.readyToBlockSelection = !1;
    return _this77;
  }
  /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */


  _createClass(aa, [{
    key: "sanitizerConfig",
    get: function get() {
      return {
        p: {},
        h1: {},
        h2: {},
        h3: {},
        h4: {},
        h5: {},
        h6: {},
        ol: {},
        ul: {},
        li: {},
        br: !0,
        img: {
          src: !0,
          width: !0,
          height: !0
        },
        a: {
          href: !0
        },
        b: {},
        i: {},
        u: {}
      };
    }
    /**
     * Flag that identifies all Blocks selection
     *
     * @returns {boolean}
     */

  }, {
    key: "allBlocksSelected",
    get: function get() {
      var e = this.Editor.BlockManager;
      return e.blocks.every(function (t) {
        return t.selected === !0;
      });
    }
    /**
     * Set selected all blocks
     *
     * @param {boolean} state - state to set
     */
    ,
    set: function set(e) {
      var t = this.Editor.BlockManager;
      t.blocks.forEach(function (o) {
        o.selected = e;
      }), this.clearCache();
    }
    /**
     * Flag that identifies any Block selection
     *
     * @returns {boolean}
     */

  }, {
    key: "anyBlockSelected",
    get: function get() {
      var e = this.Editor.BlockManager;
      return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some(function (t) {
        return t.selected === !0;
      })), this.anyBlockSelectedCache;
    }
    /**
     * Return selected Blocks array
     *
     * @returns {Block[]}
     */

  }, {
    key: "selectedBlocks",
    get: function get() {
      return this.Editor.BlockManager.blocks.filter(function (e) {
        return e.selected;
      });
    }
    /**
     * Module Preparation
     * Registers Shortcuts CMD+A and CMD+C
     * to select all and copy them
     */

  }, {
    key: "prepare",
    value: function prepare() {
      var _this78 = this;

      this.selection = new b(), ge.add({
        name: "CMD+A",
        handler: function handler(e) {
          var _this78$Editor = _this78.Editor,
              t = _this78$Editor.BlockManager,
              o = _this78$Editor.ReadOnly;

          if (o.isEnabled) {
            e.preventDefault(), _this78.selectAllBlocks();
            return;
          }

          t.currentBlock && _this78.handleCommandA(e);
        },
        on: this.Editor.UI.nodes.redactor
      });
    }
    /**
     * Toggle read-only state
     *
     *  - Remove all ranges
     *  - Unselect all Blocks
     */

  }, {
    key: "toggleReadOnly",
    value: function toggleReadOnly() {
      b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
     * Remove selection of Block
     *
     * @param {number?} index - Block index according to the BlockManager's indexes
     */

  }, {
    key: "unSelectBlockByIndex",
    value: function unSelectBlockByIndex(e) {
      var t = this.Editor.BlockManager;
      var o;
      isNaN(e) ? o = t.currentBlock : o = t.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
     * Clear selection from Blocks
     *
     * @param {Event} reason - event caused clear of selection
     * @param {boolean} restoreSelection - if true, restore saved selection
     */

  }, {
    key: "clearSelection",
    value: function clearSelection(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var _this$Editor7 = this.Editor,
          o = _this$Editor7.BlockManager,
          i = _this$Editor7.Caret,
          s = _this$Editor7.RectangleSelection;
      this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
      var r = e && e instanceof KeyboardEvent,
          a = r && Po(e.keyCode);

      if (this.anyBlockSelected && r && a && !b.isSelectionExists) {
        var l = o.removeSelectedBlocks();
        o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), Fe(function () {
          var c = e.key;
          i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
        }, 20)();
      }

      if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
        this.Editor.RectangleSelection.clearSelection();
        return;
      }

      t && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
     * Reduce each Block and copy its content
     *
     * @param {ClipboardEvent} e - copy/cut event
     * @returns {Promise<void>}
     */

  }, {
    key: "copySelectedBlocks",
    value: function copySelectedBlocks(e) {
      var _this79 = this;

      e.preventDefault();
      var t = u.make("div");
      this.selectedBlocks.forEach(function (s) {
        var r = Z(s.holder.innerHTML, _this79.sanitizerConfig),
            a = u.make("p");
        a.innerHTML = r, t.appendChild(a);
      });
      var o = Array.from(t.childNodes).map(function (s) {
        return s.textContent;
      }).join("\n\n"),
          i = t.innerHTML;
      return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map(function (s) {
        return s.save();
      })).then(function (s) {
        try {
          e.clipboardData.setData(_this79.Editor.Paste.MIME_TYPE, JSON.stringify(s));
        } catch (_unused8) {}
      });
    }
    /**
     * Select Block by its index
     *
     * @param {number?} index - Block index according to the BlockManager's indexes
     */

  }, {
    key: "selectBlockByIndex",
    value: function selectBlockByIndex(e) {
      var t = this.Editor.BlockManager,
          o = t.getBlockByIndex(e);
      o !== void 0 && this.selectBlock(o);
    }
    /**
     * Select passed Block
     *
     * @param {Block} block - Block to select
     */

  }, {
    key: "selectBlock",
    value: function selectBlock(e) {
      this.selection.save(), b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
     * Remove selection from passed Block
     *
     * @param {Block} block - Block to unselect
     */

  }, {
    key: "unselectBlock",
    value: function unselectBlock(e) {
      e.selected = !1, this.clearCache();
    }
    /**
     * Clear anyBlockSelected cache
     */

  }, {
    key: "clearCache",
    value: function clearCache() {
      this.anyBlockSelectedCache = null;
    }
    /**
     * Module destruction
     * De-registers Shortcut CMD+A
     */

  }, {
    key: "destroy",
    value: function destroy() {
      ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
     * First CMD+A selects all input content by native behaviour,
     * next CMD+A keypress selects all blocks
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "handleCommandA",
    value: function handleCommandA(e) {
      if (this.Editor.RectangleSelection.clearSelection(), u.isNativeInput(e.target) && !this.readyToBlockSelection) {
        this.readyToBlockSelection = !0;
        return;
      }

      var t = this.Editor.BlockManager.getBlock(e.target),
          o = t.inputs;

      if (o.length > 1 && !this.readyToBlockSelection) {
        this.readyToBlockSelection = !0;
        return;
      }

      if (o.length === 1 && !this.needToSelectAll) {
        this.needToSelectAll = !0;
        return;
      }

      this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t), this.needToSelectAll = !0);
    }
    /**
     * Select All Blocks
     * Each Block has selected setter that makes Block copyable
     */

  }, {
    key: "selectAllBlocks",
    value: function selectAllBlocks() {
      this.selection.save(), b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
  }]);

  return aa;
}(E);

var Ye = /*#__PURE__*/function (_E24) {
  _inherits(Ye, _E24);

  var _super35 = _createSuper(Ye);

  function Ye() {
    _classCallCheck(this, Ye);

    return _super35.apply(this, arguments);
  }

  _createClass(Ye, [{
    key: "positions",
    get:
    /**
     * Allowed caret positions in input
     *
     * @static
     * @returns {{START: string, END: string, DEFAULT: string}}
     */
    function get() {
      return {
        START: "start",
        END: "end",
        DEFAULT: "default"
      };
    }
    /**
     * Elements styles that can be useful for Caret Module
     */

  }, {
    key: "setToBlock",
    value:
    /**
     * Method gets Block instance and puts caret to the text node with offset
     * There two ways that method applies caret position:
     *   - first found text node: sets at the beginning, but you can pass an offset
     *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
     *
     * @param {Block} block - Block class
     * @param {string} position - position where to set caret.
     *                            If default - leave default behaviour and apply offset if it's passed
     * @param {number} offset - caret offset regarding to the block content
     */
    function setToBlock(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.positions.DEFAULT;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var c;
      var _this$Editor8 = this.Editor,
          i = _this$Editor8.BlockManager,
          s = _this$Editor8.BlockSelection;

      if (s.clearSelection(), !e.focusable) {
        (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
        return;
      }

      var r;

      switch (t) {
        case this.positions.START:
          r = e.firstInput;
          break;

        case this.positions.END:
          r = e.lastInput;
          break;

        default:
          r = e.currentInput;
      }

      if (!r) return;
      var a,
          l = o;
      if (t === this.positions.START) a = u.getDeepestNode(r, !1), l = 0;else if (t === this.positions.END) a = u.getDeepestNode(r, !0), l = u.getContentLength(a);else {
        var _u$getNodeByOffset = u.getNodeByOffset(r, o),
            d = _u$getNodeByOffset.node,
            h = _u$getNodeByOffset.offset;

        d ? (a = d, l = h) : (a = u.getDeepestNode(r, !1), l = 0);
      }
      this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
     * Set caret to the current input of current Block.
     *
     * @param {HTMLElement} input - input where caret should be set
     * @param {string} position - position of the caret.
     *                            If default - leave default behaviour and apply offset if it's passed
     * @param {number} offset - caret offset regarding to the text node
     */

  }, {
    key: "setToInput",
    value: function setToInput(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.positions.DEFAULT;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = this.Editor.BlockManager.currentBlock,
          s = u.getDeepestNode(e);

      switch (t) {
        case this.positions.START:
          this.set(s, 0);
          break;

        case this.positions.END:
          this.set(s, u.getContentLength(s));
          break;

        default:
          o && this.set(s, o);
      }

      i.currentInput = e;
    }
    /**
     * Creates Document Range and sets caret to the element with offset
     *
     * @param {HTMLElement} element - target node.
     * @param {number} offset - offset
     */

  }, {
    key: "set",
    value: function set(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _b$setCursor = b.setCursor(e, t),
          i = _b$setCursor.top,
          s = _b$setCursor.bottom,
          _window = window,
          r = _window.innerHeight;

      i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
     * Set Caret to the last Block
     * If last block is not empty, append another empty block
     */

  }, {
    key: "setToTheLastBlock",
    value: function setToTheLastBlock() {
      var e = this.Editor.BlockManager.lastBlock;
      if (e) if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);else {
        var t = this.Editor.BlockManager.insertAtEnd();
        this.setToBlock(t);
      }
    }
    /**
     * Extract content fragment of current Block from Caret position to the end of the Block
     */

  }, {
    key: "extractFragmentFromCaretPosition",
    value: function extractFragmentFromCaretPosition() {
      var e = b.get();

      if (e.rangeCount) {
        var t = e.getRangeAt(0),
            o = this.Editor.BlockManager.currentBlock.currentInput;
        if (t.deleteContents(), o) if (u.isNativeInput(o)) {
          var i = o,
              s = document.createDocumentFragment(),
              r = i.value.substring(0, i.selectionStart),
              a = i.value.substring(i.selectionStart);
          return s.textContent = a, i.value = r, s;
        } else {
          var _i4 = t.cloneRange();

          return _i4.selectNodeContents(o), _i4.setStart(t.endContainer, t.endOffset), _i4.extractContents();
        }
      }
    }
    /**
     * Set's caret to the next Block or Tool`s input
     * Before moving caret, we should check if caret position is at the end of Plugins node
     * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
     *
     * @param {boolean} force - pass true to skip check for caret position
     */

  }, {
    key: "navigateNext",
    value: function navigateNext() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.Editor.BlockManager,
          o = t.currentBlock,
          i = t.nextBlock;
      if (o === void 0) return !1;
      var s = o.nextInput,
          r = o.currentInput,
          a = r !== void 0 ? Re(r) : void 0;
      var l = i;
      var c = e || a || !o.focusable;
      if (s && c) return this.setToInput(s, this.positions.START), !0;

      if (l === null) {
        if (o.tool.isDefault || !c) return !1;
        l = t.insertAtEnd();
      }

      return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
    }
    /**
     * Set's caret to the previous Tool`s input or Block
     * Before moving caret, we should check if caret position is start of the Plugins node
     * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
     *
     * @param {boolean} force - pass true to skip check for caret position
     */

  }, {
    key: "navigatePrevious",
    value: function navigatePrevious() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var _this$Editor$BlockMan = this.Editor.BlockManager,
          t = _this$Editor$BlockMan.currentBlock,
          o = _this$Editor$BlockMan.previousBlock;
      if (!t) return !1;
      var i = t.previousInput,
          s = t.currentInput,
          r = s !== void 0 ? Ne(s) : void 0,
          a = e || r || !t.focusable;
      return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
     * Inserts shadow element after passed element where caret can be placed
     *
     * @param {Element} element - element after which shadow caret should be inserted
     */

  }, {
    key: "createShadow",
    value: function createShadow(e) {
      var t = document.createElement("span");
      t.classList.add(Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t);
    }
    /**
     * Restores caret position
     *
     * @param {HTMLElement} element - element where caret should be restored
     */

  }, {
    key: "restoreCaret",
    value: function restoreCaret(e) {
      var t = e.querySelector(".".concat(Ye.CSS.shadowCaret));
      if (!t) return;
      new b().expandToTag(t);
      var i = document.createRange();
      i.selectNode(t), i.extractContents();
    }
    /**
     * Inserts passed content at caret position
     *
     * @param {string} content - content to insert
     */

  }, {
    key: "insertContentAtCaretPosition",
    value: function insertContentAtCaretPosition(e) {
      var t = document.createDocumentFragment(),
          o = document.createElement("div"),
          i = b.get(),
          s = b.range;
      o.innerHTML = e, Array.from(o.childNodes).forEach(function (c) {
        return t.appendChild(c);
      }), t.childNodes.length === 0 && t.appendChild(new Text());
      var r = t.lastChild;
      s.deleteContents(), s.insertNode(t);
      var a = document.createRange(),
          l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
      l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
    }
  }], [{
    key: "CSS",
    get: function get() {
      return {
        shadowCaret: "cdx-shadow-caret"
      };
    }
  }]);

  return Ye;
}(E);

var la = /*#__PURE__*/function (_E25) {
  _inherits(la, _E25);

  var _super36 = _createSuper(la);

  function la() {
    var _this80;

    _classCallCheck(this, la);

    _this80 = _super36.apply(this, arguments), _this80.onMouseUp = function () {
      _this80.listeners.off(document, "mouseover", _this80.onMouseOver), _this80.listeners.off(document, "mouseup", _this80.onMouseUp);
    }, _this80.onMouseOver = function (e) {
      var _this80$Editor = _this80.Editor,
          t = _this80$Editor.BlockManager,
          o = _this80$Editor.BlockSelection;
      if (e.relatedTarget === null && e.target === null) return;

      var i = t.getBlockByChildNode(e.relatedTarget) || _this80.lastSelectedBlock,
          s = t.getBlockByChildNode(e.target);

      if (!(!i || !s) && s !== i) {
        if (i === _this80.firstSelectedBlock) {
          b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
          return;
        }

        if (s === _this80.firstSelectedBlock) {
          i.selected = !1, s.selected = !1, o.clearCache();
          return;
        }

        _this80.Editor.InlineToolbar.close(), _this80.toggleBlocksSelectedState(i, s), _this80.lastSelectedBlock = s;
      }
    };
    return _this80;
  }
  /**
   * Module preparation
   *
   * @returns {Promise}
   */


  _createClass(la, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var _this81 = this;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                this.listeners.on(document, "mousedown", function (e) {
                  _this81.enableCrossBlockSelection(e);
                });

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function prepare() {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
    /**
     * Sets up listeners
     *
     * @param {MouseEvent} event - mouse down event
     */

  }, {
    key: "watchSelection",
    value: function watchSelection(e) {
      if (e.button !== qn.LEFT) return;
      var t = this.Editor.BlockManager;
      this.firstSelectedBlock = t.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
     * Return boolean is cross block selection started:
     * there should be at least 2 selected blocks
     */

  }, {
    key: "isCrossBlockSelectionStarted",
    get: function get() {
      return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
     * Change selection state of the next Block
     * Used for CBS via Shift + arrow keys
     *
     * @param {boolean} next - if true, toggle next block. Previous otherwise
     */

  }, {
    key: "toggleBlockSelectedState",
    value: function toggleBlockSelectedState() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var _this$Editor9 = this.Editor,
          t = _this$Editor9.BlockManager,
          o = _this$Editor9.BlockSelection;
      this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), b.get().removeAllRanges());
      var i = t.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1),
          s = t.blocks[i];
      s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
        block: "nearest"
      }));
    }
    /**
     * Clear saved state
     *
     * @param {Event} reason - event caused clear of selection
     */

  }, {
    key: "clear",
    value: function clear(e) {
      var _this$Editor10 = this.Editor,
          t = _this$Editor10.BlockManager,
          o = _this$Editor10.BlockSelection,
          i = _this$Editor10.Caret,
          s = t.blocks.indexOf(this.firstSelectedBlock),
          r = t.blocks.indexOf(this.lastSelectedBlock);
      if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch (e.keyCode) {
        case y.DOWN:
        case y.RIGHT:
          i.setToBlock(t.blocks[Math.max(s, r)], i.positions.END);
          break;

        case y.UP:
        case y.LEFT:
          i.setToBlock(t.blocks[Math.min(s, r)], i.positions.START);
          break;

        default:
          i.setToBlock(t.blocks[Math.max(s, r)], i.positions.END);
      }
      this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
     * Enables Cross Block Selection
     *
     * @param {MouseEvent} event - mouse down event
     */

  }, {
    key: "enableCrossBlockSelection",
    value: function enableCrossBlockSelection(e) {
      var t = this.Editor.UI;
      b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
     * Change blocks selection state between passed two blocks.
     *
     * @param {Block} firstBlock - first block in range
     * @param {Block} lastBlock - last block in range
     */

  }, {
    key: "toggleBlocksSelectedState",
    value: function toggleBlocksSelectedState(e, t) {
      var _this$Editor11 = this.Editor,
          o = _this$Editor11.BlockManager,
          i = _this$Editor11.BlockSelection,
          s = o.blocks.indexOf(e),
          r = o.blocks.indexOf(t),
          a = e.selected !== t.selected;

      for (var l = Math.min(s, r); l <= Math.max(s, r); l++) {
        var c = o.blocks[l];
        c !== this.firstSelectedBlock && c !== (a ? e : t) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
      }
    }
  }]);

  return la;
}(E);

var ca = /*#__PURE__*/function (_E26) {
  _inherits(ca, _E26);

  var _super37 = _createSuper(ca);

  function ca() {
    var _this82;

    _classCallCheck(this, ca);

    _this82 = _super37.apply(this, arguments), _this82.isStartedAtEditor = !1;
    return _this82;
  }
  /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */


  _createClass(ca, [{
    key: "toggleReadOnly",
    value: function toggleReadOnly(e) {
      e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
     * Add drag events listeners to editor zone
     */

  }, {
    key: "enableModuleBindings",
    value: function enableModuleBindings() {
      var _this83 = this;

      var e = this.Editor.UI;
      this.readOnlyMutableListeners.on(e.nodes.holder, "drop", /*#__PURE__*/function () {
        var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t) {
          return _regeneratorRuntime.wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  _context29.next = 2;
                  return _this83.processDrop(t);

                case 2:
                case "end":
                  return _context29.stop();
              }
            }
          }, _callee29);
        }));

        return function (_x31) {
          return _ref36.apply(this, arguments);
        };
      }(), !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", function () {
        _this83.processDragStart();
      }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", function (t) {
        _this83.processDragOver(t);
      }, !0);
    }
    /**
     * Unbind drag-n-drop event handlers
     */

  }, {
    key: "disableModuleBindings",
    value: function disableModuleBindings() {
      this.readOnlyMutableListeners.clearAll();
    }
    /**
     * Handle drop event
     *
     * @param {DragEvent} dropEvent - drop event
     */

  }, {
    key: "processDrop",
    value: function () {
      var _processDrop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(e) {
        var _this$Editor12, t, o, i, s, r;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _this$Editor12 = this.Editor, t = _this$Editor12.BlockManager, o = _this$Editor12.Paste, i = _this$Editor12.Caret;
                e.preventDefault(), t.blocks.forEach(function (r) {
                  r.dropTarget = !1;
                }), b.isAtEditor && !b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
                s = t.setCurrentBlockByChildNode(e.target);
                if (s) this.Editor.Caret.setToBlock(s, i.positions.END);else {
                  r = t.setCurrentBlockByChildNode(t.lastBlock.holder);
                  this.Editor.Caret.setToBlock(r, i.positions.END);
                }
                _context30.next = 6;
                return o.processDataTransfer(e.dataTransfer, !0);

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function processDrop(_x32) {
        return _processDrop.apply(this, arguments);
      }

      return processDrop;
    }()
    /**
     * Handle drag start event
     */

  }, {
    key: "processDragStart",
    value: function processDragStart() {
      b.isAtEditor && !b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
     * @param {DragEvent} dragEvent - drag event
     */

  }, {
    key: "processDragOver",
    value: function processDragOver(e) {
      e.preventDefault();
    }
  }]);

  return ca;
}(E);

var da = 180,
    ua = 400;

var ha = /*#__PURE__*/function (_E27) {
  _inherits(ha, _E27);

  var _super38 = _createSuper(ha);

  /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */
  function ha(_ref37) {
    var _this84;

    var e = _ref37.config,
        t = _ref37.eventsDispatcher;

    _classCallCheck(this, ha);

    _this84 = _super38.call(this, {
      config: e,
      eventsDispatcher: t
    }), _this84.disabled = !1, _this84.batchingTimeout = null, _this84.batchingOnChangeQueue = /* @__PURE__ */new Map(), _this84.batchTime = ua, _this84.mutationObserver = new MutationObserver(function (o) {
      _this84.redactorChanged(o);
    }), _this84.eventsDispatcher.on($o, function (o) {
      _this84.particularBlockChanged(o.event);
    }), _this84.eventsDispatcher.on(zo, function () {
      _this84.disable();
    }), _this84.eventsDispatcher.on(Uo, function () {
      _this84.enable();
    });
    return _this84;
  }
  /**
   * Enables onChange event
   */


  _createClass(ha, [{
    key: "enable",
    value: function enable() {
      this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
        childList: !0,
        subtree: !0,
        characterData: !0,
        attributes: !0
      }), this.disabled = !1;
    }
    /**
     * Disables onChange event
     */

  }, {
    key: "disable",
    value: function disable() {
      this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
     * Call onChange event passed to Editor.js configuration
     *
     * @param event - some of our custom change events
     */

  }, {
    key: "particularBlockChanged",
    value: function particularBlockChanged(e) {
      var _this85 = this;

      this.disabled || !A(this.config.onChange) || (this.batchingOnChangeQueue.set("block:".concat(e.detail.target.id, ":event:").concat(e.type), e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(function () {
        var t;
        _this85.batchingOnChangeQueue.size === 1 ? t = _this85.batchingOnChangeQueue.values().next().value : t = Array.from(_this85.batchingOnChangeQueue.values()), _this85.config.onChange && _this85.config.onChange(_this85.Editor.API.methods, t), _this85.batchingOnChangeQueue.clear();
      }, this.batchTime));
    }
    /**
     * Fired on every blocks wrapper dom change
     *
     * @param mutations - mutations happened
     */

  }, {
    key: "redactorChanged",
    value: function redactorChanged(e) {
      this.eventsDispatcher.emit(ft, {
        mutations: e
      });
    }
  }]);

  return ha;
}(E);

var Rn = /*#__PURE__*/function (_E28) {
  _inherits(Dn, _E28);

  var _super39 = _createSuper(Dn);

  function Dn() {
    var _this86;

    _classCallCheck(this, Dn);

    _this86 = _super39.apply(this, arguments), _this86.MIME_TYPE = "application/x-editor-js", _this86.toolsTags = {}, _this86.tagsByTool = {}, _this86.toolsPatterns = [], _this86.toolsFiles = {}, _this86.exceptionList = [], _this86.processTool = function (e) {
      try {
        var t = e.create({}, {}, !1);

        if (e.pasteConfig === !1) {
          _this86.exceptionList.push(e.name);

          return;
        }

        if (!A(t.onPaste)) return;
        _this86.getTagsConfig(e), _this86.getFilesConfig(e), _this86.getPatternsConfig(e);
      } catch (t) {
        S("Paste handling for \xAB".concat(e.name, "\xBB Tool hasn't been set up because of the error"), "warn", t);
      }
    }, _this86.handlePasteEvent = /*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(e) {
        var _this86$Editor, t, o, i;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _this86$Editor = _this86.Editor, t = _this86$Editor.BlockManager, o = _this86$Editor.Toolbar, i = t.setCurrentBlockByChildNode(e.target);
                !i || _this86.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && _this86.exceptionList.includes(i.name) || (e.preventDefault(), _this86.processDataTransfer(e.clipboardData), o.close());

              case 2:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      return function (_x33) {
        return _ref38.apply(this, arguments);
      };
    }();
    return _this86;
  }
  /**
   * Set onPaste callback and collect tools` paste configurations
   */


  _createClass(Dn, [{
    key: "prepare",
    value: function () {
      var _prepare2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.processTools();

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function prepare() {
        return _prepare2.apply(this, arguments);
      }

      return prepare;
    }()
    /**
     * Set read-only state
     *
     * @param {boolean} readOnlyEnabled - read only flag value
     */

  }, {
    key: "toggleReadOnly",
    value: function toggleReadOnly(e) {
      e ? this.unsetCallback() : this.setCallback();
    }
    /**
     * Handle pasted or dropped data transfer object
     *
     * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
     * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
     */

  }, {
    key: "processDataTransfer",
    value: function () {
      var _processDataTransfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(e) {
        var _this87 = this;

        var t,
            o,
            i,
            r,
            a,
            l,
            c,
            d,
            h,
            _args33 = arguments;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                t = _args33.length > 1 && _args33[1] !== undefined ? _args33[1] : !1;
                o = this.Editor.Tools, i = e.types;

                if (!((i.includes ? i.includes("Files") : i.contains("Files")) && !V(this.toolsFiles))) {
                  _context33.next = 6;
                  break;
                }

                _context33.next = 5;
                return this.processFiles(e.files);

              case 5:
                return _context33.abrupt("return");

              case 6:
                r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
                l = e.getData("text/html");

                if (!r) {
                  _context33.next = 16;
                  break;
                }

                _context33.prev = 9;
                this.insertEditorJSData(JSON.parse(r));
                return _context33.abrupt("return");

              case 14:
                _context33.prev = 14;
                _context33.t0 = _context33["catch"](9);

              case 16:
                t && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
                c = Object.keys(this.toolsTags).reduce(function (p, g) {
                  var _this87$toolsTags$g$s;

                  return p[g.toLowerCase()] = (_this87$toolsTags$g$s = _this87.toolsTags[g].sanitizationConfig) !== null && _this87$toolsTags$g$s !== void 0 ? _this87$toolsTags$g$s : {}, p;
                }, {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
                  br: {}
                }), h = Z(l, d);

                if (!(!h.trim() || h.trim() === a || !u.isHTMLString(h))) {
                  _context33.next = 23;
                  break;
                }

                _context33.next = 21;
                return this.processText(a);

              case 21:
                _context33.next = 25;
                break;

              case 23:
                _context33.next = 25;
                return this.processText(h, !0);

              case 25:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this, [[9, 14]]);
      }));

      function processDataTransfer(_x34) {
        return _processDataTransfer.apply(this, arguments);
      }

      return processDataTransfer;
    }()
    /**
     * Process pasted text and divide them into Blocks
     *
     * @param {string} data - text to process. Can be HTML or plain.
     * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
     */

  }, {
    key: "processText",
    value: function () {
      var _processText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(e) {
        var _this88 = this;

        var t,
            _this$Editor13,
            o,
            i,
            s,
            a,
            _args35 = arguments;

        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                t = _args35.length > 1 && _args35[1] !== undefined ? _args35[1] : !1;
                _this$Editor13 = this.Editor, o = _this$Editor13.Caret, i = _this$Editor13.BlockManager, s = t ? this.processHTML(e) : this.processPlain(e);

                if (s.length) {
                  _context35.next = 4;
                  break;
                }

                return _context35.abrupt("return");

              case 4:
                if (!(s.length === 1)) {
                  _context35.next = 7;
                  break;
                }

                s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
                return _context35.abrupt("return");

              case 7:
                a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
                s.map( /*#__PURE__*/function () {
                  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(l, c) {
                    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                      while (1) {
                        switch (_context34.prev = _context34.next) {
                          case 0:
                            return _context34.abrupt("return", _this88.insertBlock(l, c === 0 && a));

                          case 1:
                          case "end":
                            return _context34.stop();
                        }
                      }
                    }, _callee34);
                  }));

                  return function (_x36, _x37) {
                    return _ref39.apply(this, arguments);
                  };
                }()), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);

              case 9:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function processText(_x35) {
        return _processText.apply(this, arguments);
      }

      return processText;
    }()
    /**
     * Set onPaste callback handler
     */

  }, {
    key: "setCallback",
    value: function setCallback() {
      this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
     * Unset onPaste callback handler
     */

  }, {
    key: "unsetCallback",
    value: function unsetCallback() {
      this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
     * Get and process tool`s paste configs
     */

  }, {
    key: "processTools",
    value: function processTools() {
      var e = this.Editor.Tools.blockTools;
      Array.from(e.values()).forEach(this.processTool);
    }
    /**
     * Get tags name list from either tag name or sanitization config.
     *
     * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
     * @returns {string[]} array of tags.
     */

  }, {
    key: "collectTagNames",
    value: function collectTagNames(e) {
      return te(e) ? [e] : D(e) ? Object.keys(e) : [];
    }
    /**
     * Get tags to substitute by Tool
     *
     * @param tool - BlockTool object
     */

  }, {
    key: "getTagsConfig",
    value: function getTagsConfig(e) {
      var _this89 = this;

      if (e.pasteConfig === !1) return;
      var t = e.pasteConfig.tags || [],
          o = [];
      t.forEach(function (i) {
        var s = _this89.collectTagNames(i);

        o.push.apply(o, _toConsumableArray(s)), s.forEach(function (r) {
          if (Object.prototype.hasOwnProperty.call(_this89.toolsTags, r)) {
            S("Paste handler for \xAB".concat(e.name, "\xBB Tool on \xAB").concat(r, "\xBB tag is skipped because it is already used by \xAB").concat(_this89.toolsTags[r].tool.name, "\xBB Tool."), "warn");
            return;
          }

          var a = D(i) ? i[r] : null;
          _this89.toolsTags[r.toUpperCase()] = {
            tool: e,
            sanitizationConfig: a
          };
        });
      }), this.tagsByTool[e.name] = o.map(function (i) {
        return i.toUpperCase();
      });
    }
    /**
     * Get files` types and extensions to substitute by Tool
     *
     * @param tool - BlockTool object
     */

  }, {
    key: "getFilesConfig",
    value: function getFilesConfig(e) {
      if (e.pasteConfig === !1) return;
      var _e$pasteConfig$files = e.pasteConfig.files,
          t = _e$pasteConfig$files === void 0 ? {} : _e$pasteConfig$files;
      var o = t.extensions,
          i = t.mimeTypes;
      !o && !i || (o && !Array.isArray(o) && (S("\xABextensions\xBB property of the onDrop config for \xAB".concat(e.name, "\xBB Tool should be an array")), o = []), i && !Array.isArray(i) && (S("\xABmimeTypes\xBB property of the onDrop config for \xAB".concat(e.name, "\xBB Tool should be an array")), i = []), i && (i = i.filter(function (s) {
        return ei(s) ? !0 : (S("MIME type value \xAB".concat(s, "\xBB for the \xAB").concat(e.name, "\xBB Tool is not a valid MIME type"), "warn"), !1);
      })), this.toolsFiles[e.name] = {
        extensions: o || [],
        mimeTypes: i || []
      });
    }
    /**
     * Get RegExp patterns to substitute by Tool
     *
     * @param tool - BlockTool object
     */

  }, {
    key: "getPatternsConfig",
    value: function getPatternsConfig(e) {
      var _this90 = this;

      e.pasteConfig === !1 || !e.pasteConfig.patterns || V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(function (_ref40) {
        var _ref41 = _slicedToArray(_ref40, 2),
            t = _ref41[0],
            o = _ref41[1];

        o instanceof RegExp || S("Pattern ".concat(o, " for \xAB").concat(e.name, "\xBB Tool is skipped because it should be a Regexp instance."), "warn"), _this90.toolsPatterns.push({
          key: t,
          pattern: o,
          tool: e
        });
      });
    }
    /**
     * Check if browser behavior suits better
     *
     * @param {EventTarget} element - element where content has been pasted
     * @returns {boolean}
     */

  }, {
    key: "isNativeBehaviour",
    value: function isNativeBehaviour(e) {
      return u.isNativeInput(e);
    }
    /**
     * Get files from data transfer object and insert related Tools
     *
     * @param {FileList} items - pasted or dropped items
     */

  }, {
    key: "processFiles",
    value: function () {
      var _processFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e) {
        var _this91 = this;

        var t, o, s;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                t = this.Editor.BlockManager;
                _context36.next = 3;
                return Promise.all(Array.from(e).map(function (r) {
                  return _this91.processFile(r);
                }));

              case 3:
                o = _context36.sent;
                o = o.filter(function (r) {
                  return !!r;
                });
                s = t.currentBlock.tool.isDefault && t.currentBlock.isEmpty;
                o.forEach(function (r, a) {
                  t.paste(r.type, r.event, a === 0 && s);
                });

              case 7:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function processFiles(_x38) {
        return _processFiles.apply(this, arguments);
      }

      return processFiles;
    }()
    /**
     * Get information about file and find Tool to handle it
     *
     * @param {File} file - file to process
     */

  }, {
    key: "processFile",
    value: function () {
      var _processFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(e) {
        var t, o, _o2, i;

        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                t = Jn(e), o = Object.entries(this.toolsFiles).find(function (_ref42) {
                  var _ref43 = _slicedToArray(_ref42, 2),
                      r = _ref43[0],
                      _ref43$ = _ref43[1],
                      a = _ref43$.mimeTypes,
                      l = _ref43$.extensions;

                  var _e$type$split = e.type.split("/"),
                      _e$type$split2 = _slicedToArray(_e$type$split, 2),
                      c = _e$type$split2[0],
                      d = _e$type$split2[1],
                      h = l.find(function (g) {
                    return g.toLowerCase() === t.toLowerCase();
                  }),
                      p = a.find(function (g) {
                    var _g$split = g.split("/"),
                        _g$split2 = _slicedToArray(_g$split, 2),
                        f = _g$split2[0],
                        v = _g$split2[1];

                    return f === c && (v === d || v === "*");
                  });

                  return !!h || !!p;
                });

                if (o) {
                  _context37.next = 3;
                  break;
                }

                return _context37.abrupt("return");

              case 3:
                _o2 = _slicedToArray(o, 1), i = _o2[0];
                return _context37.abrupt("return", {
                  event: this.composePasteEvent("file", {
                    file: e
                  }),
                  type: i
                });

              case 5:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function processFile(_x39) {
        return _processFile.apply(this, arguments);
      }

      return processFile;
    }()
    /**
     * Split HTML string to blocks and return it as array of Block data
     *
     * @param {string} innerHTML - html string to process
     * @returns {PasteData[]}
     */

  }, {
    key: "processHTML",
    value: function processHTML(e) {
      var _this92 = this;

      var t = this.Editor.Tools,
          o = u.make("DIV");
      return o.innerHTML = e, this.getNodes(o).map(function (s) {
        var r,
            a = t.defaultTool,
            l = !1;

        switch (s.nodeType) {
          case Node.DOCUMENT_FRAGMENT_NODE:
            r = u.make("div"), r.appendChild(s);
            break;

          case Node.ELEMENT_NODE:
            r = s, l = !0, _this92.toolsTags[r.tagName] && (a = _this92.toolsTags[r.tagName].tool);
            break;
        }

        var _ref44 = a.pasteConfig || {
          tags: []
        },
            c = _ref44.tags,
            d = c.reduce(function (g, f) {
          return _this92.collectTagNames(f).forEach(function (O) {
            var T = D(f) ? f[O] : null;
            g[O.toLowerCase()] = T || {};
          }), g;
        }, {}),
            h = Object.assign({}, d, a.baseSanitizeConfig);

        if (r.tagName.toLowerCase() === "table") {
          var g = Z(r.outerHTML, h);
          r = u.make("div", void 0, {
            innerHTML: g
          }).firstChild;
        } else r.innerHTML = Z(r.innerHTML, h);

        var p = _this92.composePasteEvent("tag", {
          data: r
        });

        return {
          content: r,
          isBlock: l,
          tool: a.name,
          event: p
        };
      }).filter(function (s) {
        var r = u.isEmpty(s.content),
            a = u.isSingleTag(s.content);
        return !r || a;
      });
    }
    /**
     * Split plain text by new line symbols and return it as array of Block data
     *
     * @param {string} plain - string to process
     * @returns {PasteData[]}
     */

  }, {
    key: "processPlain",
    value: function processPlain(e) {
      var _this93 = this;

      var t = this.config.defaultBlock;
      if (!e) return [];
      var o = t;
      return e.split(/\r?\n/).filter(function (i) {
        return i.trim();
      }).map(function (i) {
        var s = u.make("div");
        s.textContent = i;

        var r = _this93.composePasteEvent("tag", {
          data: s
        });

        return {
          content: s,
          tool: o,
          isBlock: !1,
          event: r
        };
      });
    }
    /**
     * Process paste of single Block tool content
     *
     * @param {PasteData} dataToInsert - data of Block to insert
     */

  }, {
    key: "processSingleBlock",
    value: function () {
      var _processSingleBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(e) {
        var _this$Editor14, t, o, i;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _this$Editor14 = this.Editor, t = _this$Editor14.Caret, o = _this$Editor14.BlockManager, i = o.currentBlock;

                if (!(!i || e.tool !== i.name || !u.containsOnlyInlineElements(e.content.innerHTML))) {
                  _context38.next = 4;
                  break;
                }

                this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
                return _context38.abrupt("return");

              case 4:
                t.insertContentAtCaretPosition(e.content.innerHTML);

              case 5:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function processSingleBlock(_x40) {
        return _processSingleBlock.apply(this, arguments);
      }

      return processSingleBlock;
    }()
    /**
     * Process paste to single Block:
     * 1. Find patterns` matches
     * 2. Insert new block if it is not the same type as current one
     * 3. Just insert text if there is no substitutions
     *
     * @param {PasteData} dataToInsert - data of Block to insert
     */

  }, {
    key: "processInlinePaste",
    value: function () {
      var _processInlinePaste = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(e) {
        var _this$Editor15, t, o, i, r, a, l, _r2;

        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _this$Editor15 = this.Editor, t = _this$Editor15.BlockManager, o = _this$Editor15.Caret, i = e.content;

                if (!(t.currentBlock && t.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH)) {
                  _context39.next = 9;
                  break;
                }

                _context39.next = 4;
                return this.processPattern(i.textContent);

              case 4:
                r = _context39.sent;

                if (!r) {
                  _context39.next = 9;
                  break;
                }

                a = t.currentBlock && t.currentBlock.tool.isDefault && t.currentBlock.isEmpty, l = t.paste(r.tool, r.event, a);
                o.setToBlock(l, o.positions.END);
                return _context39.abrupt("return");

              case 9:
                if (t.currentBlock && t.currentBlock.currentInput) {
                  _r2 = t.currentBlock.tool.baseSanitizeConfig;
                  document.execCommand("insertHTML", !1, Z(i.innerHTML, _r2));
                } else this.insertBlock(e);

              case 10:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function processInlinePaste(_x41) {
        return _processInlinePaste.apply(this, arguments);
      }

      return processInlinePaste;
    }()
    /**
     * Get patterns` matches
     *
     * @param {string} text - text to process
     * @returns {Promise<{event: PasteEvent, tool: string}>}
     */

  }, {
    key: "processPattern",
    value: function () {
      var _processPattern = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                t = this.toolsPatterns.find(function (i) {
                  var s = i.pattern.exec(e);
                  return s ? e === s.shift() : !1;
                });
                return _context40.abrupt("return", t ? {
                  event: this.composePasteEvent("pattern", {
                    key: t.key,
                    data: e
                  }),
                  tool: t.tool.name
                } : void 0);

              case 2:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function processPattern(_x42) {
        return _processPattern.apply(this, arguments);
      }

      return processPattern;
    }()
    /**
     * Insert pasted Block content to Editor
     *
     * @param {PasteData} data - data to insert
     * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
     * @returns {void}
     */

  }, {
    key: "insertBlock",
    value: function insertBlock(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var _this$Editor16 = this.Editor,
          o = _this$Editor16.BlockManager,
          i = _this$Editor16.Caret,
          s = o.currentBlock;
      var r;

      if (t && s && s.isEmpty) {
        r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
        return;
      }

      r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
     * Insert data passed as application/x-editor-js JSON
     *
     * @param {Array} blocks — Blocks' data to insert
     * @returns {void}
     */

  }, {
    key: "insertEditorJSData",
    value: function insertEditorJSData(e) {
      var _this$Editor17 = this.Editor,
          t = _this$Editor17.BlockManager,
          o = _this$Editor17.Caret,
          i = _this$Editor17.Tools;
      yt(e, function (r) {
        return i.blockTools.get(r).sanitizeConfig;
      }).forEach(function (_ref45, l) {
        var r = _ref45.tool,
            a = _ref45.data;
        var c = !1;
        l === 0 && (c = t.currentBlock && t.currentBlock.tool.isDefault && t.currentBlock.isEmpty);
        var d = t.insert({
          tool: r,
          data: a,
          replace: c
        });
        o.setToBlock(d, o.positions.END);
      });
    }
    /**
     * Fetch nodes from Element node
     *
     * @param {Node} node - current node
     * @param {Node[]} nodes - processed nodes
     * @param {Node} destNode - destination node
     */

  }, {
    key: "processElementNode",
    value: function processElementNode(e, t, o) {
      var i = Object.keys(this.toolsTags),
          s = e,
          _ref46 = this.toolsTags[s.tagName] || {},
          r = _ref46.tool,
          a = this.tagsByTool[r == null ? void 0 : r.name] || [],
          l = i.includes(s.tagName),
          c = u.blockElements.includes(s.tagName.toLowerCase()),
          d = Array.from(s.children).some(function (_ref47) {
        var p = _ref47.tagName;
        return i.includes(p) && !a.includes(p);
      }),
          h = Array.from(s.children).some(function (_ref48) {
        var p = _ref48.tagName;
        return u.blockElements.includes(p.toLowerCase());
      });

      if (!c && !l && !d) return o.appendChild(s), [].concat(_toConsumableArray(t), [o]);
      if (l && !d || c && !h && !d) return [].concat(_toConsumableArray(t), [o, s]);
    }
    /**
     * Recursively divide HTML string to two types of nodes:
     * 1. Block element
     * 2. Document Fragments contained text and markup tags like a, b, i etc.
     *
     * @param {Node} wrapper - wrapper of paster HTML content
     * @returns {Node[]}
     */

  }, {
    key: "getNodes",
    value: function getNodes(e) {
      var _this94 = this;

      var t = Array.from(e.childNodes);
      var o;

      var i = function i(s, r) {
        if (u.isEmpty(r) && !u.isSingleTag(r)) return s;
        var a = s[s.length - 1];
        var l = new DocumentFragment();

        switch (a && u.isFragment(a) && (l = s.pop()), r.nodeType) {
          case Node.ELEMENT_NODE:
            if (o = _this94.processElementNode(r, s, l), o) return o;
            break;

          case Node.TEXT_NODE:
            return l.appendChild(r), [].concat(_toConsumableArray(s), [l]);

          default:
            return [].concat(_toConsumableArray(s), [l]);
        }

        return [].concat(_toConsumableArray(s), _toConsumableArray(Array.from(r.childNodes).reduce(i, [])));
      };

      return t.reduce(i, []);
    }
    /**
     * Compose paste event with passed type and detail
     *
     * @param {string} type - event type
     * @param {PasteEventDetail} detail - event detail
     */

  }, {
    key: "composePasteEvent",
    value: function composePasteEvent(e, t) {
      return new CustomEvent(e, {
        detail: t
      });
    }
  }]);

  return Dn;
}(E);

Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
var pa = Rn;

var fa = /*#__PURE__*/function (_E29) {
  _inherits(fa, _E29);

  var _super40 = _createSuper(fa);

  function fa() {
    var _this95;

    _classCallCheck(this, fa);

    _this95 = _super40.apply(this, arguments), _this95.toolsDontSupportReadOnly = [], _this95.readOnlyEnabled = !1;
    return _this95;
  }
  /**
   * Returns state of read only mode
   */


  _createClass(fa, [{
    key: "isEnabled",
    get: function get() {
      return this.readOnlyEnabled;
    }
    /**
     * Set initial state
     */

  }, {
    key: "prepare",
    value: function () {
      var _prepare3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var e, t, o;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                e = this.Editor.Tools, t = e.blockTools, o = [];
                Array.from(t.entries()).forEach(function (_ref49) {
                  var _ref50 = _slicedToArray(_ref49, 2),
                      i = _ref50[0],
                      s = _ref50[1];

                  s.isReadOnlySupported || o.push(i);
                }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);

              case 2:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function prepare() {
        return _prepare3.apply(this, arguments);
      }

      return prepare;
    }()
    /**
     * Set read-only mode or toggle current state
     * Call all Modules `toggleReadOnly` method and re-render Editor
     *
     * @param state - (optional) read-only state or toggle
     * @param isInitial - (optional) true when editor is initializing
     */

  }, {
    key: "toggle",
    value: function () {
      var _toggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        var e,
            t,
            o,
            s,
            i,
            _args42 = arguments;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                e = _args42.length > 0 && _args42[0] !== undefined ? _args42[0] : !this.readOnlyEnabled;
                t = _args42.length > 1 && _args42[1] !== undefined ? _args42[1] : !1;
                e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
                o = this.readOnlyEnabled;
                this.readOnlyEnabled = e;

                for (s in this.Editor) {
                  this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
                }

                if (!(o === e)) {
                  _context42.next = 8;
                  break;
                }

                return _context42.abrupt("return", this.readOnlyEnabled);

              case 8:
                if (!t) {
                  _context42.next = 10;
                  break;
                }

                return _context42.abrupt("return", this.readOnlyEnabled);

              case 10:
                this.Editor.ModificationsObserver.disable();
                _context42.next = 13;
                return this.Editor.Saver.save();

              case 13:
                i = _context42.sent;
                _context42.next = 16;
                return this.Editor.BlockManager.clear();

              case 16:
                _context42.next = 18;
                return this.Editor.Renderer.render(i.blocks);

              case 18:
                this.Editor.ModificationsObserver.enable();
                return _context42.abrupt("return", this.readOnlyEnabled);

              case 20:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function toggle() {
        return _toggle.apply(this, arguments);
      }

      return toggle;
    }()
    /**
     * Throws an error about tools which don't support read-only mode
     */

  }, {
    key: "throwCriticalError",
    value: function throwCriticalError() {
      throw new Ho("To enable read-only mode all connected tools should support it. Tools ".concat(this.toolsDontSupportReadOnly.join(", "), " don't support read-only mode."));
    }
  }]);

  return fa;
}(E);

var Be = /*#__PURE__*/function (_E30) {
  _inherits(Be, _E30);

  var _super41 = _createSuper(Be);

  function Be() {
    var _this96;

    _classCallCheck(this, Be);

    _this96 = _super41.apply(this, arguments), _this96.isRectSelectionActivated = !1, _this96.SCROLL_SPEED = 3, _this96.HEIGHT_OF_SCROLL_ZONE = 40, _this96.BOTTOM_SCROLL_ZONE = 1, _this96.TOP_SCROLL_ZONE = 2, _this96.MAIN_MOUSE_BUTTON = 0, _this96.mousedown = !1, _this96.isScrolling = !1, _this96.inScrollZone = null, _this96.startX = 0, _this96.startY = 0, _this96.mouseX = 0, _this96.mouseY = 0, _this96.stackOfSelected = [], _this96.listenerIds = [];
    return _this96;
  }
  /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */


  _createClass(Be, [{
    key: "prepare",
    value:
    /**
     * Module Preparation
     * Creating rect and hang handlers
     */
    function prepare() {
      this.enableModuleBindings();
    }
    /**
     * Init rect params
     *
     * @param {number} pageX - X coord of mouse
     * @param {number} pageY - Y coord of mouse
     */

  }, {
    key: "startSelection",
    value: function startSelection(e, t) {
      var o = document.elementFromPoint(e - window.pageXOffset, t - window.pageYOffset);
      o.closest(".".concat(this.Editor.Toolbar.CSS.toolbar)) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
      var s = [".".concat(R.CSS.content), ".".concat(this.Editor.Toolbar.CSS.toolbar), ".".concat(this.Editor.InlineToolbar.CSS.inlineToolbar)],
          r = o.closest("." + this.Editor.UI.CSS.editorWrapper),
          a = s.some(function (l) {
        return !!o.closest(l);
      });
      !r || a || (this.mousedown = !0, this.startX = e, this.startY = t);
    }
    /**
     * Clear all params to end selection
     */

  }, {
    key: "endSelection",
    value: function endSelection() {
      this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
     * is RectSelection Activated
     */

  }, {
    key: "isRectActivated",
    value: function isRectActivated() {
      return this.isRectSelectionActivated;
    }
    /**
     * Mark that selection is end
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.isRectSelectionActivated = !1;
    }
    /**
     * Sets Module necessary event handlers
     */

  }, {
    key: "enableModuleBindings",
    value: function enableModuleBindings() {
      var _this97 = this;

      var _this$genHTML = this.genHTML(),
          e = _this$genHTML.container;

      this.listeners.on(e, "mousedown", function (t) {
        _this97.processMouseDown(t);
      }, !1), this.listeners.on(document.body, "mousemove", dt(function (t) {
        _this97.processMouseMove(t);
      }, 10), {
        passive: !0
      }), this.listeners.on(document.body, "mouseleave", function () {
        _this97.processMouseLeave();
      }), this.listeners.on(window, "scroll", dt(function (t) {
        _this97.processScroll(t);
      }, 10), {
        passive: !0
      }), this.listeners.on(document.body, "mouseup", function () {
        _this97.processMouseUp();
      }, !1);
    }
    /**
     * Handle mouse down events
     *
     * @param {MouseEvent} mouseEvent - mouse event payload
     */

  }, {
    key: "processMouseDown",
    value: function processMouseDown(e) {
      if (e.button !== this.MAIN_MOUSE_BUTTON) return;
      e.target.closest(u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
     * Handle mouse move events
     *
     * @param {MouseEvent} mouseEvent - mouse event payload
     */

  }, {
    key: "processMouseMove",
    value: function processMouseMove(e) {
      this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
     * Handle mouse leave
     */

  }, {
    key: "processMouseLeave",
    value: function processMouseLeave() {
      this.clearSelection(), this.endSelection();
    }
    /**
     * @param {MouseEvent} mouseEvent - mouse event payload
     */

  }, {
    key: "processScroll",
    value: function processScroll(e) {
      this.changingRectangle(e);
    }
    /**
     * Handle mouse up
     */

  }, {
    key: "processMouseUp",
    value: function processMouseUp() {
      this.clearSelection(), this.endSelection();
    }
    /**
     * Scroll If mouse in scroll zone
     *
     * @param {number} clientY - Y coord of mouse
     */

  }, {
    key: "scrollByZones",
    value: function scrollByZones(e) {
      if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
        this.isScrolling = !1;
        return;
      }

      this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
     * Generates required HTML elements
     *
     * @returns {Object<string, Element>}
     */

  }, {
    key: "genHTML",
    value: function genHTML() {
      var e = this.Editor.UI,
          t = e.nodes.holder.querySelector("." + e.CSS.editorWrapper),
          o = u.make("div", Be.CSS.overlay, {}),
          i = u.make("div", Be.CSS.overlayContainer, {}),
          s = u.make("div", Be.CSS.rect, {});
      return i.appendChild(s), o.appendChild(i), t.appendChild(o), this.overlayRectangle = s, {
        container: t,
        overlay: o
      };
    }
    /**
     * Activates scrolling if blockSelection is active and mouse is in scroll zone
     *
     * @param {number} speed - speed of scrolling
     */

  }, {
    key: "scrollVertical",
    value: function scrollVertical(e) {
      var _this98 = this;

      if (!(this.inScrollZone && this.mousedown)) return;
      var t = window.pageYOffset;
      window.scrollBy(0, e), this.mouseY += window.pageYOffset - t, setTimeout(function () {
        _this98.scrollVertical(e);
      }, 0);
    }
    /**
     * Handles the change in the rectangle and its effect
     *
     * @param {MouseEvent} event - mouse event
     */

  }, {
    key: "changingRectangle",
    value: function changingRectangle(e) {
      if (!this.mousedown) return;
      e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);

      var _this$genInfoForMouse = this.genInfoForMouseSelection(),
          t = _this$genInfoForMouse.rightPos,
          o = _this$genInfoForMouse.leftPos,
          i = _this$genInfoForMouse.index,
          s = this.startX > t && this.mouseX > t,
          r = this.startX < o && this.mouseX < o;

      this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), b.get().removeAllRanges());
    }
    /**
     * Shrink rect to singular point
     */

  }, {
    key: "shrinkRectangleToPoint",
    value: function shrinkRectangleToPoint() {
      this.overlayRectangle.style.left = "".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.top = "".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.right = "calc(100% - ".concat(this.startX - window.pageXOffset, "px");
    }
    /**
     * Select or unselect all of blocks in array if rect is out or in selectable area
     */

  }, {
    key: "inverseSelection",
    value: function inverseSelection() {
      var t = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;

      if (this.rectCrossesBlocks && !t) {
        var _iterator5 = _createForOfIteratorHelper(this.stackOfSelected),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var o = _step5.value;
            this.Editor.BlockSelection.selectBlockByIndex(o);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      if (!this.rectCrossesBlocks && t) {
        var _iterator6 = _createForOfIteratorHelper(this.stackOfSelected),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _o3 = _step6.value;
            this.Editor.BlockSelection.unSelectBlockByIndex(_o3);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
    /**
     * Updates size of rectangle
     */

  }, {
    key: "updateRectangleSize",
    value: function updateRectangleSize() {
      this.mouseY >= this.startY ? (this.overlayRectangle.style.top = "".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.mouseY - window.pageYOffset, "px")) : (this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.top = "".concat(this.mouseY - window.pageYOffset, "px")), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = "".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.right = "calc(100% - ".concat(this.mouseX - window.pageXOffset, "px")) : (this.overlayRectangle.style.right = "calc(100% - ".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.left = "".concat(this.mouseX - window.pageXOffset, "px"));
    }
    /**
     * Collects information needed to determine the behavior of the rectangle
     *
     * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
     */

  }, {
    key: "genInfoForMouseSelection",
    value: function genInfoForMouseSelection() {
      var t = document.body.offsetWidth / 2,
          o = this.mouseY - window.pageYOffset,
          i = document.elementFromPoint(t, o),
          s = this.Editor.BlockManager.getBlockByChildNode(i);
      var r;
      s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex(function (h) {
        return h.holder === s.holder;
      }));
      var a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + R.CSS.content),
          l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2,
          c = t - l,
          d = t + l;
      return {
        index: r,
        leftPos: c,
        rightPos: d
      };
    }
    /**
     * Select block with index index
     *
     * @param index - index of block in redactor
     */

  }, {
    key: "addBlockInSelection",
    value: function addBlockInSelection(e) {
      this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
     * Adds a block to the selection and determines which blocks should be selected
     *
     * @param {object} index - index of new block in the reactor
     */

  }, {
    key: "trySelectNextBlock",
    value: function trySelectNextBlock(e) {
      var _this99 = this;

      var t = this.stackOfSelected[this.stackOfSelected.length - 1] === e,
          o = this.stackOfSelected.length,
          i = 1,
          s = -1,
          r = 0;
      if (t) return;
      var a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
      var l = r;
      o > 1 && (l = a ? i : s);
      var c = e > this.stackOfSelected[o - 1] && l === i,
          d = e < this.stackOfSelected[o - 1] && l === s,
          p = !(c || d || l === r);

      if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
        var v = this.stackOfSelected[o - 1] + 1 || e;

        for (v; v <= e; v++) {
          this.addBlockInSelection(v);
        }

        return;
      }

      if (!p && e < this.stackOfSelected[o - 1]) {
        for (var _v = this.stackOfSelected[o - 1] - 1; _v >= e; _v--) {
          this.addBlockInSelection(_v);
        }

        return;
      }

      if (!p) return;
      var g = o - 1,
          f;

      for (e > this.stackOfSelected[o - 1] ? f = function f() {
        return e > _this99.stackOfSelected[g];
      } : f = function f() {
        return e < _this99.stackOfSelected[g];
      }; f();) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
      }
    }
  }], [{
    key: "CSS",
    get: function get() {
      return {
        overlay: "codex-editor-overlay",
        overlayContainer: "codex-editor-overlay__container",
        rect: "codex-editor-overlay__rectangle",
        topScrollZone: "codex-editor-overlay__scroll-zone--top",
        bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
      };
    }
  }]);

  return Be;
}(E);

var ga = /*#__PURE__*/function (_E31) {
  _inherits(ga, _E31);

  var _super42 = _createSuper(ga);

  function ga() {
    _classCallCheck(this, ga);

    return _super42.apply(this, arguments);
  }

  _createClass(ga, [{
    key: "render",
    value:
    /**
     * Renders passed blocks as one batch
     *
     * @param blocksData - blocks to render
     */
    function () {
      var _render2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(e) {
        var _this100 = this;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", new Promise(function (t) {
                  var _this100$Editor = _this100.Editor,
                      o = _this100$Editor.Tools,
                      i = _this100$Editor.BlockManager;
                  if (e.length === 0) i.insert();else {
                    var s = e.map(function (_ref51) {
                      var r = _ref51.type,
                          a = _ref51.data,
                          l = _ref51.tunes,
                          c = _ref51.id;
                      o.available.has(r) === !1 && (X("Tool \xAB".concat(r, "\xBB is not found. Check 'tools' property at the Editor.js config."), "warn"), a = _this100.composeStubDataForTool(r, a, c), r = o.stubTool);
                      var d;

                      try {
                        d = i.composeBlock({
                          id: c,
                          tool: r,
                          data: a,
                          tunes: l
                        });
                      } catch (h) {
                        S("Block \xAB".concat(r, "\xBB skipped because of plugins error"), "error", {
                          data: a,
                          error: h
                        }), a = _this100.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                          id: c,
                          tool: r,
                          data: a,
                          tunes: l
                        });
                      }

                      return d;
                    });
                    i.insertMany(s);
                  }
                  window.requestIdleCallback(function () {
                    t();
                  }, {
                    timeout: 2e3
                  });
                }));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      function render(_x43) {
        return _render2.apply(this, arguments);
      }

      return render;
    }()
    /**
     * Create data for the Stub Tool that will be used instead of unavailable tool
     *
     * @param tool - unavailable tool name to stub
     * @param data - data of unavailable block
     * @param [id] - id of unavailable block
     */

  }, {
    key: "composeStubDataForTool",
    value: function composeStubDataForTool(e, t, o) {
      var i = this.Editor.Tools;
      var s = e;

      if (i.unavailable.has(e)) {
        var r = i.unavailable.get(e).toolbox;
        r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
      }

      return {
        savedData: {
          id: o,
          type: e,
          data: t
        },
        title: s
      };
    }
  }]);

  return ga;
}(E);

var ma = /*#__PURE__*/function (_E32) {
  _inherits(ma, _E32);

  var _super43 = _createSuper(ma);

  function ma() {
    _classCallCheck(this, ma);

    return _super43.apply(this, arguments);
  }

  _createClass(ma, [{
    key: "save",
    value:
    /**
     * Composes new chain of Promises to fire them alternatelly
     *
     * @returns {OutputData}
     */
    function () {
      var _save2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var _this101 = this;

        var _this$Editor18, e, t, o, i, s, r;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _this$Editor18 = this.Editor, e = _this$Editor18.BlockManager, t = _this$Editor18.Tools, o = e.blocks, i = [];
                _context44.prev = 1;
                o.forEach(function (a) {
                  i.push(_this101.getSavedData(a));
                });
                _context44.next = 5;
                return Promise.all(i);

              case 5:
                s = _context44.sent;
                _context44.next = 8;
                return yt(s, function (a) {
                  return t.blockTools.get(a).sanitizeConfig;
                });

              case 8:
                r = _context44.sent;
                return _context44.abrupt("return", this.makeOutput(r));

              case 12:
                _context44.prev = 12;
                _context44.t0 = _context44["catch"](1);
                X("Saving failed due to the Error %o", "error", _context44.t0);

              case 15:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this, [[1, 12]]);
      }));

      function save() {
        return _save2.apply(this, arguments);
      }

      return save;
    }()
    /**
     * Saves and validates
     *
     * @param {Block} block - Editor's Tool
     * @returns {ValidatedData} - Tool's validated data
     */

  }, {
    key: "getSavedData",
    value: function () {
      var _getSavedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(e) {
        var t, o;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return e.save();

              case 2:
                t = _context45.sent;
                _context45.t0 = t;

                if (!_context45.t0) {
                  _context45.next = 8;
                  break;
                }

                _context45.next = 7;
                return e.validate(t.data);

              case 7:
                _context45.t0 = _context45.sent;

              case 8:
                o = _context45.t0;
                return _context45.abrupt("return", _objectSpread(_objectSpread({}, t), {}, {
                  isValid: o
                }));

              case 10:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));

      function getSavedData(_x44) {
        return _getSavedData.apply(this, arguments);
      }

      return getSavedData;
    }()
    /**
     * Creates output object with saved data, time and version of editor
     *
     * @param {ValidatedData} allExtractedData - data extracted from Blocks
     * @returns {OutputData}
     */

  }, {
    key: "makeOutput",
    value: function makeOutput(e) {
      var _this102 = this;

      var t = [];
      return e.forEach(function (_ref52) {
        var o = _ref52.id,
            i = _ref52.tool,
            s = _ref52.data,
            r = _ref52.tunes,
            a = _ref52.isValid;

        if (!a) {
          S("Block \xAB".concat(i, "\xBB skipped because saved data is invalid"));
          return;
        }

        if (i === _this102.Editor.Tools.stubTool) {
          t.push(s);
          return;
        }

        var l = _objectSpread({
          id: o,
          type: i,
          data: s
        }, !V(r) && {
          tunes: r
        });

        t.push(l);
      }), {
        time: + /* @__PURE__ */new Date(),
        blocks: t,
        version: "2.31.0"
      };
    }
  }]);

  return ma;
}(E);

(function () {
  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") {
      var n = document.createElement("style");
      n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();

var ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';

function va(n) {
  var e = document.createElement("div");
  e.innerHTML = n.trim();
  var t = document.createDocumentFragment();
  return t.append.apply(t, _toConsumableArray(Array.from(e.childNodes))), t;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */


var fo = /*#__PURE__*/function () {
  /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */
  function fo(_ref53) {
    var _t$preserveBlank;

    var e = _ref53.data,
        t = _ref53.config,
        o = _ref53.api,
        i = _ref53.readOnly;

    _classCallCheck(this, fo);

    this.api = o, this.readOnly = i, this._CSS = {
      block: this.api.styles.block,
      wrapper: "ce-paragraph"
    }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t.placeholder ? t.placeholder : fo.DEFAULT_PLACEHOLDER, this._data = e !== null && e !== void 0 ? e : {}, this._element = null, this._preserveBlank = (_t$preserveBlank = t.preserveBlank) !== null && _t$preserveBlank !== void 0 ? _t$preserveBlank : !1;
  }
  /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */


  _createClass(fo, [{
    key: "onKeyUp",
    value: function onKeyUp(e) {
      if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
      var t = this._element.textContent;
      t === "" && (this._element.innerHTML = "");
    }
    /**
     * Create Tool's view
     *
     * @returns {HTMLDivElement}
     * @private
     */

  }, {
    key: "drawView",
    value: function drawView() {
      var e = document.createElement("DIV");
      return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
     * Return Tool's view
     *
     * @returns {HTMLDivElement}
     */

  }, {
    key: "render",
    value: function render() {
      return this._element = this.drawView(), this._element;
    }
    /**
     * Method that specified how to merge two Text blocks.
     * Called by Editor.js by backspace at the beginning of the Block
     *
     * @param {ParagraphData} data
     * @public
     */

  }, {
    key: "merge",
    value: function merge(e) {
      if (!this._element) return;
      this._data.text += e.text;
      var t = va(e.text);
      this._element.appendChild(t), this._element.normalize();
    }
    /**
     * Validate Paragraph block data:
     * - check for emptiness
     *
     * @param {ParagraphData} savedData — data received after saving
     * @returns {boolean} false if saved data is not correct, otherwise true
     * @public
     */

  }, {
    key: "validate",
    value: function validate(e) {
      return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
     * Extract Tool's data from the view
     *
     * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
     * @returns {ParagraphData} - saved data
     * @public
     */

  }, {
    key: "save",
    value: function save(e) {
      return {
        text: e.innerHTML
      };
    }
    /**
     * On paste callback fired from Editor.
     *
     * @param {HTMLPasteEvent} event - event with pasted data
     */

  }, {
    key: "onPaste",
    value: function onPaste(e) {
      var _this103 = this;

      var t = {
        text: e.detail.data.innerHTML
      };
      this._data = t, window.requestAnimationFrame(function () {
        _this103._element && (_this103._element.innerHTML = _this103._data.text || "");
      });
    }
    /**
     * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
     * @returns {ConversionConfig}
     */

  }], [{
    key: "DEFAULT_PLACEHOLDER",
    get:
    /**
     * Default placeholder for Paragraph Tool
     *
     * @returns {string}
     * @class
     */
    function get() {
      return "";
    }
  }, {
    key: "conversionConfig",
    get: function get() {
      return {
        export: "text",
        // to convert Paragraph to other block, use 'text' property of saved data
        import: "text" // to covert other block's exported string to Paragraph, fill 'text' property of tool data

      };
    }
    /**
     * Sanitizer rules
     * @returns {SanitizerConfig} - Edtior.js sanitizer config
     */

  }, {
    key: "sanitize",
    get: function get() {
      return {
        text: {
          br: !0
        }
      };
    }
    /**
     * Returns true to notify the core that read-only mode is supported
     *
     * @returns {boolean}
     */

  }, {
    key: "isReadOnlySupported",
    get: function get() {
      return !0;
    }
    /**
     * Used by Editor paste handling API.
     * Provides configuration to handle P tags.
     *
     * @returns {PasteConfig} - Paragraph Paste Setting
     */

  }, {
    key: "pasteConfig",
    get: function get() {
      return {
        tags: ["P"]
      };
    }
    /**
     * Icon and title for displaying at the Toolbox
     *
     * @returns {ToolboxConfig} - Paragraph Toolbox Setting
     */

  }, {
    key: "toolbox",
    get: function get() {
      return {
        icon: ba,
        title: "Text"
      };
    }
  }]);

  return fo;
}();

var go = /*#__PURE__*/function () {
  function go() {
    _classCallCheck(this, go);

    this.commandName = "bold";
  }
  /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */


  _createClass(go, [{
    key: "render",
    value:
    /**
     * Create button for Inline Toolbar
     */
    function render() {
      var _this104 = this;

      return {
        icon: Ki,
        name: "bold",
        onActivate: function onActivate() {
          document.execCommand(_this104.commandName);
        },
        isActive: function isActive() {
          return document.queryCommandState(_this104.commandName);
        }
      };
    }
    /**
     * Set a shortcut
     *
     * @returns {boolean}
     */

  }, {
    key: "shortcut",
    get: function get() {
      return "CMD+B";
    }
  }], [{
    key: "sanitize",
    get: function get() {
      return {
        b: {}
      };
    }
  }]);

  return go;
}();

go.isInline = !0;
go.title = "Bold";

var mo = /*#__PURE__*/function () {
  function mo() {
    _classCallCheck(this, mo);

    this.commandName = "italic", this.CSS = {
      button: "ce-inline-tool",
      buttonActive: "ce-inline-tool--active",
      buttonModifier: "ce-inline-tool--italic"
    }, this.nodes = {
      button: null
    };
  }
  /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */


  _createClass(mo, [{
    key: "render",
    value:
    /**
     * Create button for Inline Toolbar
     */
    function render() {
      return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = Ji, this.nodes.button;
    }
    /**
     * Wrap range with <i> tag
     */

  }, {
    key: "surround",
    value: function surround() {
      document.execCommand(this.commandName);
    }
    /**
     * Check selection and set activated state to button if there are <i> tag
     */

  }, {
    key: "checkState",
    value: function checkState() {
      var e = document.queryCommandState(this.commandName);
      return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
     * Set a shortcut
     */

  }, {
    key: "shortcut",
    get: function get() {
      return "CMD+I";
    }
  }], [{
    key: "sanitize",
    get: function get() {
      return {
        i: {}
      };
    }
  }]);

  return mo;
}();

mo.isInline = !0;
mo.title = "Italic";

var bo = /*#__PURE__*/function () {
  /**
   * @param api - Editor.js API
   */
  function bo(_ref54) {
    var e = _ref54.api;

    _classCallCheck(this, bo);

    this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
      button: "ce-inline-tool",
      buttonActive: "ce-inline-tool--active",
      buttonModifier: "ce-inline-tool--link",
      buttonUnlink: "ce-inline-tool--unlink",
      input: "ce-inline-tool-input",
      inputShowed: "ce-inline-tool-input--showed"
    }, this.nodes = {
      button: null,
      input: null
    }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new b();
  }
  /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */


  _createClass(bo, [{
    key: "render",
    value:
    /**
     * Create button for Inline Toolbar
     */
    function render() {
      return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = Co, this.nodes.button;
    }
    /**
     * Input for the link
     */

  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this105 = this;

      return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", function (e) {
        e.keyCode === _this105.ENTER_KEY && _this105.enterPressed(e);
      }), this.nodes.input;
    }
    /**
     * Handle clicks on the Inline Toolbar icon
     *
     * @param {Range} range - range to wrap with link
     */

  }, {
    key: "surround",
    value: function surround(e) {
      if (e) {
        this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
        var t = this.selection.findParentTag("A");

        if (t) {
          this.selection.expandToTag(t), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close();
          return;
        }
      }

      this.toggleActions();
    }
    /**
     * Check selection and set activated state to button if there are <a> tag
     */

  }, {
    key: "checkState",
    value: function checkState() {
      var e = this.selection.findParentTag("A");

      if (e) {
        this.nodes.button.innerHTML = ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
        var t = e.getAttribute("href");
        this.nodes.input.value = t !== "null" ? t : "", this.selection.save();
      } else this.nodes.button.innerHTML = Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);

      return !!e;
    }
    /**
     * Function called with Inline Toolbar closing
     */

  }, {
    key: "clear",
    value: function clear() {
      this.closeActions();
    }
    /**
     * Set a shortcut
     */

  }, {
    key: "shortcut",
    get: function get() {
      return "CMD+K";
    }
    /**
     * Show/close link input
     */

  }, {
    key: "toggleActions",
    value: function toggleActions() {
      this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
     * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
     */

  }, {
    key: "openActions",
    value: function openActions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
     * Close input
     *
     * @param {boolean} clearSavedSelection — we don't need to clear saved selection
     *                                        on toggle-clicks on the icon of opened Toolbar
     */

  }, {
    key: "closeActions",
    value: function closeActions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;

      if (this.selection.isFakeBackgroundEnabled) {
        var t = new b();
        t.save(), this.selection.restore(), this.selection.removeFakeBackground(), t.restore();
      }

      this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
     * Enter pressed on input
     *
     * @param {KeyboardEvent} event - enter keydown event
     */

  }, {
    key: "enterPressed",
    value: function enterPressed(e) {
      var t = this.nodes.input.value || "";

      if (!t.trim()) {
        this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
        return;
      }

      if (!this.validateURL(t)) {
        this.notifier.show({
          message: "Pasted link is not valid.",
          style: "error"
        }), S("Incorrect Link pasted", "warn", t);
        return;
      }

      t = this.prepareLink(t), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
     * Detects if passed string is URL
     *
     * @param {string} str - string to validate
     * @returns {boolean}
     */

  }, {
    key: "validateURL",
    value: function validateURL(e) {
      return !/\s/.test(e);
    }
    /**
     * Process link before injection
     * - sanitize
     * - add protocol for links like 'google.com'
     *
     * @param {string} link - raw user input
     */

  }, {
    key: "prepareLink",
    value: function prepareLink(e) {
      return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
     * Add 'http' protocol to the links like 'vc.ru', 'google.com'
     *
     * @param {string} link - string to process
     */

  }, {
    key: "addProtocol",
    value: function addProtocol(e) {
      if (/^(\w+):(\/\/)?/.test(e)) return e;
      var t = /^\/[^/\s]/.test(e),
          o = e.substring(0, 1) === "#",
          i = /^\/\/[^/\s]/.test(e);
      return !t && !o && !i && (e = "http://" + e), e;
    }
    /**
     * Inserts <a> tag with "href"
     *
     * @param {string} link - "href" value
     */

  }, {
    key: "insertLink",
    value: function insertLink(e) {
      var t = this.selection.findParentTag("A");
      t && this.selection.expandToTag(t), document.execCommand(this.commandLink, !1, e);
    }
    /**
     * Removes <a> tag
     */

  }, {
    key: "unlink",
    value: function unlink() {
      document.execCommand(this.commandUnlink);
    }
  }], [{
    key: "sanitize",
    get: function get() {
      return {
        a: {
          href: !0,
          target: "_blank",
          rel: "nofollow"
        }
      };
    }
  }]);

  return bo;
}();

bo.isInline = !0;
bo.title = "Link";

var Fn = /*#__PURE__*/function () {
  /**
   * @param api - Editor.js API
   */
  function Fn(_ref55) {
    var e = _ref55.api;

    _classCallCheck(this, Fn);

    this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
  }
  /**
   * Returns tool's UI config
   */


  _createClass(Fn, [{
    key: "render",
    value: function () {
      var _render3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        var _this106 = this;

        var e, t, o, i, s, r, a, l;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                e = b.get(), t = this.blocksAPI.getBlockByElement(e.anchorNode);

                if (!(t === void 0)) {
                  _context47.next = 3;
                  break;
                }

                return _context47.abrupt("return", []);

              case 3:
                o = this.toolsAPI.getBlockTools();
                _context47.next = 6;
                return Yo(t, o);

              case 6:
                i = _context47.sent;

                if (!(i.length === 0)) {
                  _context47.next = 9;
                  break;
                }

                return _context47.abrupt("return", []);

              case 9:
                s = i.reduce(function (c, d) {
                  var h;
                  return (h = d.toolbox) == null || h.forEach(function (p) {
                    c.push({
                      icon: p.icon,
                      title: z.t(K.toolNames, p.title),
                      name: d.name,
                      closeOnActivate: !0,
                      onActivate: function () {
                        var _onActivate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
                          var g;
                          return _regeneratorRuntime.wrap(function _callee46$(_context46) {
                            while (1) {
                              switch (_context46.prev = _context46.next) {
                                case 0:
                                  _context46.next = 2;
                                  return _this106.blocksAPI.convert(t.id, d.name, p.data);

                                case 2:
                                  g = _context46.sent;

                                  _this106.caretAPI.setToBlock(g, "end");

                                case 4:
                                case "end":
                                  return _context46.stop();
                              }
                            }
                          }, _callee46);
                        }));

                        function onActivate() {
                          return _onActivate2.apply(this, arguments);
                        }

                        return onActivate;
                      }()
                    });
                  }), c;
                }, []);
                _context47.next = 12;
                return t.getActiveToolboxEntry();

              case 12:
                r = _context47.sent;
                a = r !== void 0 ? r.icon : Go;
                l = !be();
                return _context47.abrupt("return", {
                  icon: a,
                  name: "convert-to",
                  hint: {
                    title: this.i18nAPI.t("Convert to")
                  },
                  children: {
                    searchable: l,
                    items: s,
                    onOpen: function onOpen() {
                      l && (_this106.selectionAPI.setFakeBackground(), _this106.selectionAPI.save());
                    },
                    onClose: function onClose() {
                      l && (_this106.selectionAPI.restore(), _this106.selectionAPI.removeFakeBackground());
                    }
                  }
                });

              case 16:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function render() {
        return _render3.apply(this, arguments);
      }

      return render;
    }()
  }]);

  return Fn;
}();

Fn.isInline = !0;

var jn = /*#__PURE__*/function () {
  /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */
  function jn(_ref56) {
    var e = _ref56.data,
        t = _ref56.api;

    _classCallCheck(this, jn);

    this.CSS = {
      wrapper: "ce-stub",
      info: "ce-stub__info",
      title: "ce-stub__title",
      subtitle: "ce-stub__subtitle"
    }, this.api = t, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
  }
  /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */


  _createClass(jn, [{
    key: "render",
    value: function render() {
      return this.wrapper;
    }
    /**
     * Return original Tool data
     *
     * @returns {BlockToolData}
     */

  }, {
    key: "save",
    value: function save() {
      return this.savedData;
    }
    /**
     * Create Tool html markup
     *
     * @returns {HTMLElement}
     */

  }, {
    key: "make",
    value: function make() {
      var e = u.make("div", this.CSS.wrapper),
          t = is,
          o = u.make("div", this.CSS.info),
          i = u.make("div", this.CSS.title, {
        textContent: this.title
      }),
          s = u.make("div", this.CSS.subtitle, {
        textContent: this.subtitle
      });
      return e.innerHTML = t, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
  }]);

  return jn;
}();

jn.isReadOnlySupported = !0;

var ka = /*#__PURE__*/function (_Tt) {
  _inherits(ka, _Tt);

  var _super44 = _createSuper(ka);

  function ka() {
    var _this107;

    _classCallCheck(this, ka);

    _this107 = _super44.apply(this, arguments), _this107.type = ae.Inline;
    return _this107;
  }
  /**
   * Returns title for Inline Tool if specified by user
   */


  _createClass(ka, [{
    key: "title",
    get: function get() {
      return this.constructable[We.Title];
    }
    /**
     * Constructs new InlineTool instance from constructable
     */

  }, {
    key: "create",
    value: function create() {
      return new this.constructable({
        api: this.api,
        config: this.settings
      });
    }
    /**
     * Allows inline tool to be available in read-only mode
     * Can be used, for example, by comments tool
     */

  }, {
    key: "isReadOnlySupported",
    get: function get() {
      var _this$constructable$W;

      return (_this$constructable$W = this.constructable[We.IsReadOnlySupported]) !== null && _this$constructable$W !== void 0 ? _this$constructable$W : !1;
    }
  }]);

  return ka;
}(Tt);

var ya = /*#__PURE__*/function (_Tt2) {
  _inherits(ya, _Tt2);

  var _super45 = _createSuper(ya);

  function ya() {
    var _this108;

    _classCallCheck(this, ya);

    _this108 = _super45.apply(this, arguments), _this108.type = ae.Tune;
    return _this108;
  }
  /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */


  _createClass(ya, [{
    key: "create",
    value: function create(e, t) {
      return new this.constructable({
        api: this.api,
        config: this.settings,
        block: t,
        data: e
      });
    }
  }]);

  return ya;
}(Tt);

var j = /*#__PURE__*/function (_Map) {
  _inherits(j, _Map);

  var _super46 = _createSuper(j);

  function j() {
    _classCallCheck(this, j);

    return _super46.apply(this, arguments);
  }

  _createClass(j, [{
    key: "blockTools",
    get:
    /**
     * Returns Block Tools collection
     */
    function get() {
      var e = Array.from(this.entries()).filter(function (_ref57) {
        var _ref58 = _slicedToArray(_ref57, 2),
            t = _ref58[1];

        return t.isBlock();
      });
      return new j(e);
    }
    /**
     * Returns Inline Tools collection
     */

  }, {
    key: "inlineTools",
    get: function get() {
      var e = Array.from(this.entries()).filter(function (_ref59) {
        var _ref60 = _slicedToArray(_ref59, 2),
            t = _ref60[1];

        return t.isInline();
      });
      return new j(e);
    }
    /**
     * Returns Block Tunes collection
     */

  }, {
    key: "blockTunes",
    get: function get() {
      var e = Array.from(this.entries()).filter(function (_ref61) {
        var _ref62 = _slicedToArray(_ref61, 2),
            t = _ref62[1];

        return t.isTune();
      });
      return new j(e);
    }
    /**
     * Returns internal Tools collection
     */

  }, {
    key: "internalTools",
    get: function get() {
      var e = Array.from(this.entries()).filter(function (_ref63) {
        var _ref64 = _slicedToArray(_ref63, 2),
            t = _ref64[1];

        return t.isInternal;
      });
      return new j(e);
    }
    /**
     * Returns Tools collection provided by user
     */

  }, {
    key: "externalTools",
    get: function get() {
      var e = Array.from(this.entries()).filter(function (_ref65) {
        var _ref66 = _slicedToArray(_ref65, 2),
            t = _ref66[1];

        return !t.isInternal;
      });
      return new j(e);
    }
  }]);

  return j;
}( /*#__PURE__*/_wrapNativeSuper(Map));

var wa = Object.defineProperty,
    Ea = Object.getOwnPropertyDescriptor,
    Hn = function Hn(n, e, t, o) {
  for (var i = o > 1 ? void 0 : o ? Ea(e, t) : e, s = n.length - 1, r; s >= 0; s--) {
    (r = n[s]) && (i = (o ? r(e, t, i) : r(i)) || i);
  }

  return o && i && wa(e, t, i), i;
};

var vo = /*#__PURE__*/function (_Tt3) {
  _inherits(vo, _Tt3);

  var _super47 = _createSuper(vo);

  function vo() {
    var _this109;

    _classCallCheck(this, vo);

    _this109 = _super47.apply(this, arguments), _this109.type = ae.Block, _this109.inlineTools = new j(), _this109.tunes = new j();
    return _this109;
  }
  /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */


  _createClass(vo, [{
    key: "create",
    value: function create(e, t, o) {
      return new this.constructable({
        data: e,
        block: t,
        readOnly: o,
        api: this.api,
        config: this.settings
      });
    }
    /**
     * Returns true if read-only mode is supported by Tool
     */

  }, {
    key: "isReadOnlySupported",
    get: function get() {
      return this.constructable[pe.IsReadOnlySupported] === !0;
    }
    /**
     * Returns true if Tool supports linebreaks
     */

  }, {
    key: "isLineBreaksEnabled",
    get: function get() {
      return this.constructable[pe.IsEnabledLineBreaks];
    }
    /**
     * Returns Tool toolbox configuration (internal or user-specified).
     *
     * Merges internal and user-defined toolbox configs based on the following rules:
     *
     * - If both internal and user-defined toolbox configs are arrays their items are merged.
     * Length of the second one is kept.
     *
     * - If both are objects their properties are merged.
     *
     * - If one is an object and another is an array than internal config is replaced with user-defined
     * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
     */

  }, {
    key: "toolbox",
    get: function get() {
      var e = this.constructable[pe.Toolbox],
          t = this.config[Pe.Toolbox];
      if (!V(e) && t !== !1) return t ? Array.isArray(e) ? Array.isArray(t) ? t.map(function (o, i) {
        var s = e[i];
        return s ? _objectSpread(_objectSpread({}, s), o) : o;
      }) : [t] : Array.isArray(t) ? t : [_objectSpread(_objectSpread({}, e), t)] : Array.isArray(e) ? e : [e];
    }
    /**
     * Returns Tool conversion configuration
     */

  }, {
    key: "conversionConfig",
    get: function get() {
      return this.constructable[pe.ConversionConfig];
    }
    /**
     * Returns enabled inline tools for Tool
     */

  }, {
    key: "enabledInlineTools",
    get: function get() {
      return this.config[Pe.EnabledInlineTools] || !1;
    }
    /**
     * Returns enabled tunes for Tool
     */

  }, {
    key: "enabledBlockTunes",
    get: function get() {
      return this.config[Pe.EnabledBlockTunes];
    }
    /**
     * Returns Tool paste configuration
     */

  }, {
    key: "pasteConfig",
    get: function get() {
      var _this$constructable$p;

      return (_this$constructable$p = this.constructable[pe.PasteConfig]) !== null && _this$constructable$p !== void 0 ? _this$constructable$p : {};
    }
  }, {
    key: "sanitizeConfig",
    get: function get() {
      var e = _get(_getPrototypeOf(vo.prototype), "sanitizeConfig", this),
          t = this.baseSanitizeConfig;

      if (V(e)) return t;
      var o = {};

      for (var i in e) {
        if (Object.prototype.hasOwnProperty.call(e, i)) {
          var s = e[i];
          D(s) ? o[i] = Object.assign({}, t, s) : o[i] = s;
        }
      }

      return o;
    }
  }, {
    key: "baseSanitizeConfig",
    get: function get() {
      var e = {};
      return Array.from(this.inlineTools.values()).forEach(function (t) {
        return Object.assign(e, t.sanitizeConfig);
      }), Array.from(this.tunes.values()).forEach(function (t) {
        return Object.assign(e, t.sanitizeConfig);
      }), e;
    }
  }]);

  return vo;
}(Tt);

Hn([me], vo.prototype, "sanitizeConfig", 1);
Hn([me], vo.prototype, "baseSanitizeConfig", 1);

var xa = /*#__PURE__*/function () {
  /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */
  function xa(e, t, o) {
    _classCallCheck(this, xa);

    this.api = o, this.config = e, this.editorConfig = t;
  }
  /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */


  _createClass(xa, [{
    key: "get",
    value: function get(e) {
      var _this$config$e = this.config[e],
          t = _this$config$e.class,
          _this$config$e$isInte = _this$config$e.isInternal,
          o = _this$config$e$isInte === void 0 ? !1 : _this$config$e$isInte,
          i = _objectWithoutProperties(_this$config$e, _excluded),
          s = this.getConstructor(t),
          r = t[mt.IsTune];

      return new s({
        name: e,
        constructable: t,
        config: i,
        api: this.api.getMethodsForTool(e, r),
        isDefault: e === this.editorConfig.defaultBlock,
        defaultPlaceholder: this.editorConfig.placeholder,
        isInternal: o
      });
    }
    /**
     * Find appropriate Tool object constructor for Tool constructable
     *
     * @param constructable - Tools constructable
     */

  }, {
    key: "getConstructor",
    value: function getConstructor(e) {
      switch (!0) {
        case e[We.IsInline]:
          return ka;

        case e[mt.IsTune]:
          return ya;

        default:
          return vo;
      }
    }
  }]);

  return xa;
}();

var $n = /*#__PURE__*/function () {
  /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */
  function $n(_ref67) {
    var e = _ref67.api;

    _classCallCheck(this, $n);

    this.CSS = {
      animation: "wobble"
    }, this.api = e;
  }
  /**
   * Tune's appearance in block settings menu
   */


  _createClass($n, [{
    key: "render",
    value: function render() {
      var _this110 = this;

      return {
        icon: Xi,
        title: this.api.i18n.t("Move down"),
        onActivate: function onActivate() {
          return _this110.handleClick();
        },
        name: "move-down"
      };
    }
    /**
     * Handle clicks on 'move down' button
     */

  }, {
    key: "handleClick",
    value: function handleClick() {
      var e = this.api.blocks.getCurrentBlockIndex(),
          t = this.api.blocks.getBlockByIndex(e + 1);
      if (!t) throw new Error("Unable to move Block down since it is already the last");
      var o = t.holder,
          i = o.getBoundingClientRect();
      var s = Math.abs(window.innerHeight - o.offsetHeight);
      i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
  }]);

  return $n;
}();

$n.isTune = !0;

var zn = /*#__PURE__*/function () {
  /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */
  function zn(_ref68) {
    var e = _ref68.api;

    _classCallCheck(this, zn);

    this.api = e;
  }
  /**
   * Tune's appearance in block settings menu
   */


  _createClass(zn, [{
    key: "render",
    value: function render() {
      var _this111 = this;

      return {
        icon: Gi,
        title: this.api.i18n.t("Delete"),
        name: "delete",
        confirmation: {
          title: this.api.i18n.t("Click to delete"),
          onActivate: function onActivate() {
            return _this111.handleClick();
          }
        }
      };
    }
    /**
     * Delete block conditions passed
     */

  }, {
    key: "handleClick",
    value: function handleClick() {
      this.api.blocks.delete();
    }
  }]);

  return zn;
}();

zn.isTune = !0;

var Un = /*#__PURE__*/function () {
  /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */
  function Un(_ref69) {
    var e = _ref69.api;

    _classCallCheck(this, Un);

    this.CSS = {
      animation: "wobble"
    }, this.api = e;
  }
  /**
   * Tune's appearance in block settings menu
   */


  _createClass(Un, [{
    key: "render",
    value: function render() {
      var _this112 = this;

      return {
        icon: Zi,
        title: this.api.i18n.t("Move up"),
        onActivate: function onActivate() {
          return _this112.handleClick();
        },
        name: "move-up"
      };
    }
    /**
     * Move current block up
     */

  }, {
    key: "handleClick",
    value: function handleClick() {
      var e = this.api.blocks.getCurrentBlockIndex(),
          t = this.api.blocks.getBlockByIndex(e),
          o = this.api.blocks.getBlockByIndex(e - 1);
      if (e === 0 || !t || !o) throw new Error("Unable to move Block up since it is already the first");
      var i = t.holder,
          s = o.holder,
          r = i.getBoundingClientRect(),
          a = s.getBoundingClientRect();
      var l;
      a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
  }]);

  return Un;
}();

Un.isTune = !0;

var Ba = Object.defineProperty,
    Ca = Object.getOwnPropertyDescriptor,
    Ta = function Ta(n, e, t, o) {
  for (var i = o > 1 ? void 0 : o ? Ca(e, t) : e, s = n.length - 1, r; s >= 0; s--) {
    (r = n[s]) && (i = (o ? r(e, t, i) : r(i)) || i);
  }

  return o && i && Ba(e, t, i), i;
};

var Wn = /*#__PURE__*/function (_E33) {
  _inherits(Wn, _E33);

  var _super48 = _createSuper(Wn);

  function Wn() {
    var _this113;

    _classCallCheck(this, Wn);

    _this113 = _super48.apply(this, arguments), _this113.stubTool = "stub", _this113.toolsAvailable = new j(), _this113.toolsUnavailable = new j();
    return _this113;
  }
  /**
   * Returns available Tools
   */


  _createClass(Wn, [{
    key: "available",
    get: function get() {
      return this.toolsAvailable;
    }
    /**
     * Returns unavailable Tools
     */

  }, {
    key: "unavailable",
    get: function get() {
      return this.toolsUnavailable;
    }
    /**
     * Return Tools for the Inline Toolbar
     */

  }, {
    key: "inlineTools",
    get: function get() {
      return this.available.inlineTools;
    }
    /**
     * Return editor block tools
     */

  }, {
    key: "blockTools",
    get: function get() {
      return this.available.blockTools;
    }
    /**
     * Return available Block Tunes
     *
     * @returns {object} - object of Inline Tool's classes
     */

  }, {
    key: "blockTunes",
    get: function get() {
      return this.available.blockTunes;
    }
    /**
     * Returns default Tool object
     */

  }, {
    key: "defaultTool",
    get: function get() {
      return this.blockTools.get(this.config.defaultBlock);
    }
    /**
     * Returns internal tools
     */

  }, {
    key: "internal",
    get: function get() {
      return this.available.internalTools;
    }
    /**
     * Creates instances via passed or default configuration
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "prepare",
    value: function () {
      var _prepare4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        var _this114 = this;

        var e, t;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                if (!(this.validateTools(), this.config.tools = ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0)) {
                  _context48.next = 2;
                  break;
                }

                throw Error("Can't start without tools");

              case 2:
                e = this.prepareConfig();
                this.factory = new xa(e, this.config, this.Editor.API);
                t = this.getListOfPrepareFunctions(e);

                if (!(t.length === 0)) {
                  _context48.next = 7;
                  break;
                }

                return _context48.abrupt("return", Promise.resolve());

              case 7:
                _context48.next = 9;
                return Qn(t, function (o) {
                  _this114.toolPrepareMethodSuccess(o);
                }, function (o) {
                  _this114.toolPrepareMethodFallback(o);
                });

              case 9:
                this.prepareBlockTools();

              case 10:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function prepare() {
        return _prepare4.apply(this, arguments);
      }

      return prepare;
    }()
  }, {
    key: "getAllInlineToolsSanitizeConfig",
    value: function getAllInlineToolsSanitizeConfig() {
      var e = {};
      return Array.from(this.inlineTools.values()).forEach(function (t) {
        Object.assign(e, t.sanitizeConfig);
      }), e;
    }
    /**
     * Calls each Tool reset method to clean up anything set by Tool
     */

  }, {
    key: "destroy",
    value: function destroy() {
      Object.values(this.available).forEach( /*#__PURE__*/function () {
        var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(e) {
          return _regeneratorRuntime.wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  _context49.t0 = A(e.reset);

                  if (!_context49.t0) {
                    _context49.next = 4;
                    break;
                  }

                  _context49.next = 4;
                  return e.reset();

                case 4:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49);
        }));

        return function (_x45) {
          return _ref70.apply(this, arguments);
        };
      }());
    }
    /**
     * Returns internal tools
     * Includes Bold, Italic, Link and Paragraph
     */

  }, {
    key: "internalTools",
    get: function get() {
      return {
        convertTo: {
          class: Fn,
          isInternal: !0
        },
        link: {
          class: bo,
          isInternal: !0
        },
        bold: {
          class: go,
          isInternal: !0
        },
        italic: {
          class: mo,
          isInternal: !0
        },
        paragraph: {
          class: fo,
          inlineToolbar: !0,
          isInternal: !0
        },
        stub: {
          class: jn,
          isInternal: !0
        },
        moveUp: {
          class: Un,
          isInternal: !0
        },
        delete: {
          class: zn,
          isInternal: !0
        },
        moveDown: {
          class: $n,
          isInternal: !0
        }
      };
    }
    /**
     * Tool prepare method success callback
     *
     * @param {object} data - append tool to available list
     */

  }, {
    key: "toolPrepareMethodSuccess",
    value: function toolPrepareMethodSuccess(e) {
      var t = this.factory.get(e.toolName);

      if (t.isInline()) {
        var i = ["render"].filter(function (s) {
          return !t.create()[s];
        });

        if (i.length) {
          S("Incorrect Inline Tool: ".concat(t.name, ". Some of required methods is not implemented %o"), "warn", i), this.toolsUnavailable.set(t.name, t);
          return;
        }
      }

      this.toolsAvailable.set(t.name, t);
    }
    /**
     * Tool prepare method fail callback
     *
     * @param {object} data - append tool to unavailable list
     */

  }, {
    key: "toolPrepareMethodFallback",
    value: function toolPrepareMethodFallback(e) {
      this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
     * Binds prepare function of plugins with user or default config
     *
     * @returns {Array} list of functions that needs to be fired sequentially
     * @param config - tools config
     */

  }, {
    key: "getListOfPrepareFunctions",
    value: function getListOfPrepareFunctions(e) {
      var t = [];
      return Object.entries(e).forEach(function (_ref71) {
        var _ref72 = _slicedToArray(_ref71, 2),
            o = _ref72[0],
            i = _ref72[1];

        t.push({
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          function: A(i.class.prepare) ? i.class.prepare : function () {},
          data: {
            toolName: o,
            config: i.config
          }
        });
      }), t;
    }
    /**
     * Assign enabled Inline Tools and Block Tunes for Block Tool
     */

  }, {
    key: "prepareBlockTools",
    value: function prepareBlockTools() {
      var _this115 = this;

      Array.from(this.blockTools.values()).forEach(function (e) {
        _this115.assignInlineToolsToBlockTool(e), _this115.assignBlockTunesToBlockTool(e);
      });
    }
    /**
     * Assign enabled Inline Tools for Block Tool
     *
     * @param tool - Block Tool
     */

  }, {
    key: "assignInlineToolsToBlockTool",
    value: function assignInlineToolsToBlockTool(e) {
      var _this116 = this;

      if (this.config.inlineToolbar !== !1) {
        if (e.enabledInlineTools === !0) {
          e.inlineTools = new j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map(function (t) {
            return [t, _this116.inlineTools.get(t)];
          }) : Array.from(this.inlineTools.entries()));
          return;
        }

        Array.isArray(e.enabledInlineTools) && (e.inlineTools = new j(
        /** Prepend ConvertTo Inline Tool */
        ["convertTo"].concat(_toConsumableArray(e.enabledInlineTools)).map(function (t) {
          return [t, _this116.inlineTools.get(t)];
        })));
      }
    }
    /**
     * Assign enabled Block Tunes for Block Tool
     *
     * @param tool — Block Tool
     */

  }, {
    key: "assignBlockTunesToBlockTool",
    value: function assignBlockTunesToBlockTool(e) {
      var _this117 = this;

      if (e.enabledBlockTunes !== !1) {
        if (Array.isArray(e.enabledBlockTunes)) {
          var t = new j(e.enabledBlockTunes.map(function (o) {
            return [o, _this117.blockTunes.get(o)];
          }));
          e.tunes = new j([].concat(_toConsumableArray(t), _toConsumableArray(this.blockTunes.internalTools)));
          return;
        }

        if (Array.isArray(this.config.tunes)) {
          var _t4 = new j(this.config.tunes.map(function (o) {
            return [o, _this117.blockTunes.get(o)];
          }));

          e.tunes = new j([].concat(_toConsumableArray(_t4), _toConsumableArray(this.blockTunes.internalTools)));
          return;
        }

        e.tunes = this.blockTunes.internalTools;
      }
    }
    /**
     * Validate Tools configuration objects and throw Error for user if it is invalid
     */

  }, {
    key: "validateTools",
    value: function validateTools() {
      for (var e in this.config.tools) {
        if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
          if (e in this.internalTools) return;
          var t = this.config.tools[e];
          if (!A(t) && !A(t.class)) throw Error("Tool \xAB".concat(e, "\xBB must be a constructor function or an object with function in the \xABclass\xBB property"));
        }
      }
    }
    /**
     * Unify tools config
     */

  }, {
    key: "prepareConfig",
    value: function prepareConfig() {
      var e = {};

      for (var t in this.config.tools) {
        D(this.config.tools[t]) ? e[t] = this.config.tools[t] : e[t] = {
          class: this.config.tools[t]
        };
      }

      return e;
    }
  }]);

  return Wn;
}(E);

Ta([me], Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
var Sa = ":root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:\"\\feff\"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:\"\";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:\"\";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:\"\";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}\n";

var Ia = /*#__PURE__*/function (_E34) {
  _inherits(Ia, _E34);

  var _super49 = _createSuper(Ia);

  function Ia() {
    var _this118;

    _classCallCheck(this, Ia);

    _this118 = _super49.apply(this, arguments), _this118.isMobile = !1, _this118.contentRectCache = null, _this118.resizeDebouncer = Eo(function () {
      _this118.windowResize();
    }, 200), _this118.selectionChangeDebounced = Eo(function () {
      _this118.selectionChanged();
    }, da), _this118.documentTouchedListener = function (e) {
      _this118.documentTouched(e);
    };
    return _this118;
  }
  /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */


  _createClass(Ia, [{
    key: "CSS",
    get: function get() {
      return {
        editorWrapper: "codex-editor",
        editorWrapperNarrow: "codex-editor--narrow",
        editorZone: "codex-editor__redactor",
        editorZoneHidden: "codex-editor__redactor--hidden",
        editorEmpty: "codex-editor--empty",
        editorRtlFix: "codex-editor--rtl"
      };
    }
    /**
     * Return Width of center column of Editor
     *
     * @returns {DOMRect}
     */

  }, {
    key: "contentRect",
    get: function get() {
      if (this.contentRectCache !== null) return this.contentRectCache;
      var e = this.nodes.wrapper.querySelector(".".concat(R.CSS.content));
      return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
        width: 650,
        left: 0,
        right: 0
      };
    }
    /**
     * Making main interface
     */

  }, {
    key: "prepare",
    value: function () {
      var _prepare5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                this.setIsMobile(), this.make(), this.loadStyles();

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function prepare() {
        return _prepare5.apply(this, arguments);
      }

      return prepare;
    }()
    /**
     * Toggle read-only state
     *
     * If readOnly is true:
     *  - removes all listeners from main UI module elements
     *
     * if readOnly is false:
     *  - enables all listeners to UI module elements
     *
     * @param {boolean} readOnlyEnabled - "read only" state
     */

  }, {
    key: "toggleReadOnly",
    value: function toggleReadOnly(e) {
      var _this119 = this;

      e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(function () {
        _this119.bindReadOnlySensitiveListeners();
      }, {
        timeout: 2e3
      });
    }
    /**
     * Check if Editor is empty and set CSS class to wrapper
     */

  }, {
    key: "checkEmptiness",
    value: function checkEmptiness() {
      var e = this.Editor.BlockManager;
      this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
     * Check if one of Toolbar is opened
     * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
     *
     * @returns {boolean}
     */

  }, {
    key: "someToolbarOpened",
    get: function get() {
      var _this$Editor19 = this.Editor,
          e = _this$Editor19.Toolbar,
          t = _this$Editor19.BlockSettings,
          o = _this$Editor19.InlineToolbar;
      return !!(t.opened || o.opened || e.toolbox.opened);
    }
    /**
     * Check for some Flipper-buttons is under focus
     */

  }, {
    key: "someFlipperButtonFocused",
    get: function get() {
      return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(function (_ref73) {
        var _ref74 = _slicedToArray(_ref73, 2),
            e = _ref74[0],
            t = _ref74[1];

        return t.flipper instanceof ce;
      }).some(function (_ref75) {
        var _ref76 = _slicedToArray(_ref75, 2),
            e = _ref76[0],
            t = _ref76[1];

        return t.flipper.hasFocus();
      });
    }
    /**
     * Clean editor`s UI
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
    }
    /**
     * Close all Editor's toolbars
     */

  }, {
    key: "closeAllToolbars",
    value: function closeAllToolbars() {
      var _this$Editor20 = this.Editor,
          e = _this$Editor20.Toolbar,
          t = _this$Editor20.BlockSettings,
          o = _this$Editor20.InlineToolbar;
      t.close(), o.close(), e.toolbox.close();
    }
    /**
     * Check for mobile mode and save the result
     */

  }, {
    key: "setIsMobile",
    value: function setIsMobile() {
      var e = window.innerWidth < Ro;
      e !== this.isMobile && this.eventsDispatcher.emit(Te, {
        isEnabled: this.isMobile
      }), this.isMobile = e;
    }
    /**
     * Makes Editor.js interface
     */

  }, {
    key: "make",
    value: function make() {
      this.nodes.holder = u.getHolder(this.config.holder), this.nodes.wrapper = u.make("div", [this.CSS.editorWrapper].concat(_toConsumableArray(this.isRtl ? [this.CSS.editorRtlFix] : []))), this.nodes.redactor = u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
    }
    /**
     * Appends CSS
     */

  }, {
    key: "loadStyles",
    value: function loadStyles() {
      var e = "editor-js-styles";
      if (u.get(e)) return;
      var t = u.make("style", null, {
        id: e,
        textContent: Sa.toString()
      });
      this.config.style && !V(this.config.style) && this.config.style.nonce && t.setAttribute("nonce", this.config.style.nonce), u.prepend(document.head, t);
    }
    /**
     * Adds listeners that should work both in read-only and read-write modes
     */

  }, {
    key: "bindReadOnlyInsensitiveListeners",
    value: function bindReadOnlyInsensitiveListeners() {
      this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
        passive: !0
      }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
        capture: !0,
        passive: !0
      }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
        capture: !0,
        passive: !0
      });
    }
    /**
     * Removes listeners that should work both in read-only and read-write modes
     */

  }, {
    key: "unbindReadOnlyInsensitiveListeners",
    value: function unbindReadOnlyInsensitiveListeners() {
      this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
    }
    /**
     * Adds listeners that should work only in read-only mode
     */

  }, {
    key: "bindReadOnlySensitiveListeners",
    value: function bindReadOnlySensitiveListeners() {
      var _this120 = this;

      this.readOnlyMutableListeners.on(this.nodes.redactor, "click", function (e) {
        _this120.redactorClicked(e);
      }, !1), this.readOnlyMutableListeners.on(document, "keydown", function (e) {
        _this120.documentKeydown(e);
      }, !0), this.readOnlyMutableListeners.on(document, "mousedown", function (e) {
        _this120.documentClicked(e);
      }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
     * Listen redactor mousemove to emit 'block-hovered' event
     */

  }, {
    key: "watchBlockHoveredEvents",
    value: function watchBlockHoveredEvents() {
      var _this121 = this;

      var e;
      this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", dt(function (t) {
        var o = t.target.closest(".ce-block");
        _this121.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, _this121.eventsDispatcher.emit(ln, {
          block: _this121.Editor.BlockManager.getBlockByChildNode(o)
        }));
      }, 20), {
        passive: !0
      });
    }
    /**
     * Unbind events that should work only in read-only mode
     */

  }, {
    key: "unbindReadOnlySensitiveListeners",
    value: function unbindReadOnlySensitiveListeners() {
      this.readOnlyMutableListeners.clearAll();
    }
    /**
     * Resize window handler
     */

  }, {
    key: "windowResize",
    value: function windowResize() {
      this.contentRectCache = null, this.setIsMobile();
    }
    /**
     * All keydowns on document
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "documentKeydown",
    value: function documentKeydown(e) {
      switch (e.keyCode) {
        case y.ENTER:
          this.enterPressed(e);
          break;

        case y.BACKSPACE:
        case y.DELETE:
          this.backspacePressed(e);
          break;

        case y.ESC:
          this.escapePressed(e);
          break;

        default:
          this.defaultBehaviour(e);
          break;
      }
    }
    /**
     * Ignore all other document's keydown events
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "defaultBehaviour",
    value: function defaultBehaviour(e) {
      var t = this.Editor.BlockManager.currentBlock,
          o = e.target.closest(".".concat(this.CSS.editorWrapper)),
          i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;

      if (t !== void 0 && o === null) {
        this.Editor.BlockEvents.keydown(e);
        return;
      }

      o || t && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "backspacePressed",
    value: function backspacePressed(e) {
      var _this$Editor21 = this.Editor,
          t = _this$Editor21.BlockManager,
          o = _this$Editor21.BlockSelection,
          i = _this$Editor21.Caret;

      if (o.anyBlockSelected && !b.isSelectionExists) {
        var s = t.removeSelectedBlocks(),
            r = t.insertDefaultBlockAtIndex(s, !0);
        i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
      }
    }
    /**
     * Escape pressed
     * If some of Toolbar components are opened, then close it otherwise close Toolbar
     *
     * @param {Event} event - escape keydown event
     */

  }, {
    key: "escapePressed",
    value: function escapePressed(e) {
      this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
     * Enter pressed on document
     *
     * @param {KeyboardEvent} event - keyboard event
     */

  }, {
    key: "enterPressed",
    value: function enterPressed(e) {
      var _this$Editor22 = this.Editor,
          t = _this$Editor22.BlockManager,
          o = _this$Editor22.BlockSelection;
      if (this.someToolbarOpened) return;
      var i = t.currentBlockIndex >= 0;

      if (o.anyBlockSelected && !b.isSelectionExists) {
        o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
        return;
      }

      if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
        var s = this.Editor.BlockManager.insert();
        e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
      }

      this.Editor.BlockSelection.clearSelection(e);
    }
    /**
     * All clicks on document
     *
     * @param {MouseEvent} event - Click event
     */

  }, {
    key: "documentClicked",
    value: function documentClicked(e) {
      var a, l;
      if (!e.isTrusted) return;
      var t = e.target;
      this.nodes.holder.contains(t) || b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
      var i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t),
          s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t),
          r = i || s;

      if (this.Editor.BlockSettings.opened && !r) {
        this.Editor.BlockSettings.close();
        var c = this.Editor.BlockManager.getBlockByChildNode(t);
        this.Editor.Toolbar.moveAndOpen(c);
      }

      this.Editor.BlockSelection.clearSelection(e);
    }
    /**
     * First touch on editor
     * Fired before click
     *
     * Used to change current block — we need to do it before 'selectionChange' event.
     * Also:
     * - Move and show the Toolbar
     * - Set a Caret
     *
     * @param event - touch or mouse event
     */

  }, {
    key: "documentTouched",
    value: function documentTouched(e) {
      var t = e.target;

      if (t === this.nodes.redactor) {
        var o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX,
            i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
        t = document.elementFromPoint(o, i);
      }

      try {
        this.Editor.BlockManager.setCurrentBlockByChildNode(t);
      } catch (_unused10) {
        this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
      }

      this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
    }
    /**
     * All clicks on the redactor zone
     *
     * @param {MouseEvent} event - click event
     * @description
     * - By clicks on the Editor's bottom zone:
     *      - if last Block is empty, set a Caret to this
     *      - otherwise, add a new empty Block and set a Caret to that
     */

  }, {
    key: "redactorClicked",
    value: function redactorClicked(e) {
      if (!b.isCollapsed) return;
      var t = e.target,
          o = e.metaKey || e.ctrlKey;

      if (u.isAnchor(t) && o) {
        e.stopImmediatePropagation(), e.stopPropagation();
        var i = t.getAttribute("href"),
            s = oi(i);
        ii(s);
        return;
      }

      this.processBottomZoneClick(e);
    }
    /**
     * Check if user clicks on the Editor's bottom zone:
     *  - set caret to the last block
     *  - or add new empty block
     *
     * @param event - click event
     */

  }, {
    key: "processBottomZoneClick",
    value: function processBottomZoneClick(e) {
      var t = this.Editor.BlockManager.getBlockByIndex(-1),
          o = u.offset(t.holder).bottom,
          i = e.pageY,
          s = this.Editor.BlockSelection;

      if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) &&
      /**
      * If there is cross block selection started, target will be equal to redactor so we need additional check
      */
      !s.anyBlockSelected &&
      /**
      * Prevent caret jumping (to last block) when clicking between blocks
      */
      o < i) {
        e.stopImmediatePropagation(), e.stopPropagation();
        var _this$Editor23 = this.Editor,
            a = _this$Editor23.BlockManager,
            l = _this$Editor23.Caret,
            c = _this$Editor23.Toolbar;
        (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
      }
    }
    /**
     * Handle selection changes on mobile devices
     * Uses for showing the Inline Toolbar
     */

  }, {
    key: "selectionChanged",
    value: function selectionChanged() {
      var _this$Editor24 = this.Editor,
          e = _this$Editor24.CrossBlockSelection,
          t = _this$Editor24.BlockSelection,
          o = b.anchorElement;

      if (e.isCrossBlockSelectionStarted && t.anyBlockSelected && b.get().removeAllRanges(), !o) {
        b.range || this.Editor.InlineToolbar.close();
        return;
      }

      var i = o.closest(".".concat(R.CSS.content));
      (i === null || i.closest(".".concat(b.CSS.editorWrapper)) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
     * Editor.js provides and ability to show placeholders for empty contenteditable elements
     *
     * This method watches for input and focus events and toggles 'data-empty' attribute
     * to workaroud the case, when inputs contains only <br>s and has no visible content
     * Then, CSS could rely on this attribute to show placeholders
     */

  }, {
    key: "enableInputsEmptyMark",
    value: function enableInputsEmptyMark() {
      function e(t) {
        var o = t.target;
        Do(o);
      }

      this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
  }]);

  return Ia;
}(E);

var Oa = {
  // API Modules
  BlocksAPI: gi,
  CaretAPI: bi,
  EventsAPI: vi,
  I18nAPI: kt,
  API: ki,
  InlineToolbarAPI: yi,
  ListenersAPI: wi,
  NotifierAPI: Ci,
  ReadOnlyAPI: Ti,
  SanitizerAPI: Li,
  SaverAPI: Pi,
  SelectionAPI: Ni,
  ToolsAPI: Ri,
  StylesAPI: Di,
  ToolbarAPI: Fi,
  TooltipAPI: Ui,
  UiAPI: Wi,
  // Toolbar Modules
  BlockSettings: ms,
  Toolbar: Bs,
  InlineToolbar: Cs,
  // Modules
  BlockEvents: na,
  BlockManager: ra,
  BlockSelection: aa,
  Caret: Ye,
  CrossBlockSelection: la,
  DragNDrop: ca,
  ModificationsObserver: ha,
  Paste: pa,
  ReadOnly: fa,
  RectangleSelection: Be,
  Renderer: ga,
  Saver: ma,
  Tools: Wn,
  UI: Ia
};

var _a = /*#__PURE__*/function () {
  /**
   * @param {EditorConfig} config - user configuration
   */
  function _a(e) {
    var _this122 = this;

    _classCallCheck(this, _a);

    this.moduleInstances = {}, this.eventsDispatcher = new Oe();
    var t, o;
    this.isReady = new Promise(function (i, s) {
      t = i, o = s;
    }), Promise.resolve().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
      var _this122$moduleInstan, i, s, r, a;

      return _regeneratorRuntime.wrap(function _callee51$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              _this122.configuration = e;

              _this122.validate();

              _this122.init();

              _context51.next = 5;
              return _this122.start();

            case 5:
              _context51.next = 7;
              return _this122.render();

            case 7:
              _this122$moduleInstan = _this122.moduleInstances, i = _this122$moduleInstan.BlockManager, s = _this122$moduleInstan.Caret, r = _this122$moduleInstan.UI, a = _this122$moduleInstan.ModificationsObserver;
              r.checkEmptiness(), a.enable(), _this122.configuration.autofocus === !0 && _this122.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t();

            case 9:
            case "end":
              return _context51.stop();
          }
        }
      }, _callee51);
    }))).catch(function (i) {
      S("Editor.js is not ready because of ".concat(i), "error"), o(i);
    });
  }
  /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */


  _createClass(_a, [{
    key: "configuration",
    get:
    /**
     * Returns private property
     *
     * @returns {EditorConfig}
     */
    function get() {
      return this.config;
    }
    /**
     * Checks for required fields in Editor's config
     */
    ,
    set: function set(e) {
      var o, i;
      D(e) ? this.config = _objectSpread({}, e) : this.config = {
        holder: e
      }, ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = Lo.VERBOSE), Zn(this.config.logLevel), ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
      var t = {
        type: this.config.defaultBlock,
        data: {}
      };
      this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
        p: !0,
        b: !0,
        a: !0
      }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
        blocks: []
      }, this.config.onReady = this.config.onReady || function () {}, this.config.onChange = this.config.onChange || function () {}, this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, (V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
        blocks: [t]
      }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this$config = this.config,
          e = _this$config.holderId,
          t = _this$config.holder;
      if (e && t) throw Error("«holderId» and «holder» param can't assign at the same time.");
      if (te(t) && !u.get(t)) throw Error("element with ID \xAB".concat(t, "\xBB is missing. Pass correct holder's ID."));
      if (t && D(t) && !u.isElement(t)) throw Error("«holder» value must be an Element node");
    }
    /**
     * Initializes modules:
     *  - make and save instances
     *  - configure
     */

  }, {
    key: "init",
    value: function init() {
      this.constructModules(), this.configureModules();
    }
    /**
     * Start Editor!
     *
     * Get list of modules that needs to be prepared and return a sequence (Promise)
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        var _this123 = this;

        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return ["Tools", "UI", "BlockManager", "Paste", "BlockSelection", "RectangleSelection", "CrossBlockSelection", "ReadOnly"].reduce(function (t, o) {
                  return t.then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
                    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
                      while (1) {
                        switch (_context52.prev = _context52.next) {
                          case 0:
                            _context52.prev = 0;
                            _context52.next = 3;
                            return _this123.moduleInstances[o].prepare();

                          case 3:
                            _context52.next = 10;
                            break;

                          case 5:
                            _context52.prev = 5;
                            _context52.t0 = _context52["catch"](0);

                            if (!(_context52.t0 instanceof Ho)) {
                              _context52.next = 9;
                              break;
                            }

                            throw new Error(_context52.t0.message);

                          case 9:
                            S("Module ".concat(o, " was skipped because of %o"), "warn", _context52.t0);

                          case 10:
                          case "end":
                            return _context52.stop();
                        }
                      }
                    }, _callee52, null, [[0, 5]]);
                  })));
                }, Promise.resolve());

              case 2:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * Render initial data
     */

  }, {
    key: "render",
    value: function render() {
      return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
     * Make modules instances and save it to the @property this.moduleInstances
     */

  }, {
    key: "constructModules",
    value: function constructModules() {
      var _this124 = this;

      Object.entries(Oa).forEach(function (_ref79) {
        var _ref80 = _slicedToArray(_ref79, 2),
            e = _ref80[0],
            t = _ref80[1];

        try {
          _this124.moduleInstances[e] = new t({
            config: _this124.configuration,
            eventsDispatcher: _this124.eventsDispatcher
          });
        } catch (o) {
          S("[constructModules]", "Module ".concat(e, " skipped because"), "error", o);
        }
      });
    }
    /**
     * Modules instances configuration:
     *  - pass other modules to the 'state' property
     *  - ...
     */

  }, {
    key: "configureModules",
    value: function configureModules() {
      for (var e in this.moduleInstances) {
        Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
      }
    }
    /**
     * Return modules without passed name
     *
     * @param {string} name - module for witch modules difference should be calculated
     */

  }, {
    key: "getModulesDiff",
    value: function getModulesDiff(e) {
      var t = {};

      for (var o in this.moduleInstances) {
        o !== e && (t[o] = this.moduleInstances[o]);
      }

      return t;
    }
  }]);

  return _a;
}();
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */


var Aa = /*#__PURE__*/function () {
  /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */
  function Aa(e) {
    var _this125 = this;

    _classCallCheck(this, Aa);

    var t = function t() {};

    D(e) && A(e.onReady) && (t = e.onReady);
    var o = new _a(e);
    this.isReady = o.isReady.then(function () {
      _this125.exportAPI(o), t();
    });
  }
  /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */


  _createClass(Aa, [{
    key: "exportAPI",
    value: function exportAPI(e) {
      var _this126 = this;

      var t = ["configuration"],
          o = function o() {
        Object.values(e.moduleInstances).forEach(function (s) {
          A(s.destroy) && s.destroy(), s.listeners.removeAll();
        }), zi(), e = null;

        for (var s in _this126) {
          Object.prototype.hasOwnProperty.call(_this126, s) && delete _this126[s];
        }

        Object.setPrototypeOf(_this126, null);
      };

      t.forEach(function (s) {
        _this126[s] = e[s];
      }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
        blocks: {
          clear: "clear",
          render: "render"
        },
        caret: {
          focus: "focus"
        },
        events: {
          on: "on",
          off: "off",
          emit: "emit"
        },
        saver: {
          save: "save"
        }
      }).forEach(function (_ref81) {
        var _ref82 = _slicedToArray(_ref81, 2),
            s = _ref82[0],
            r = _ref82[1];

        Object.entries(r).forEach(function (_ref83) {
          var _ref84 = _slicedToArray(_ref83, 2),
              a = _ref84[0],
              l = _ref84[1];

          _this126[l] = e.moduleInstances.API.methods[s][a];
        });
      });
    }
  }], [{
    key: "version",
    get:
    /** Editor version */
    function get() {
      return "2.31.0";
    }
  }]);

  return Aa;
}();

export { Aa as default };